<template>
  <!--projectId == '901' San Francisco-->
    <div v-if="projectApiId == '4'" class="master-plan-page san-francisco-project" :class="{'loading-view': loading}">
        <template>
            <div class="lds-loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </template>

        <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
            <div class="logo-container">
                <a href="/">
                    <img :src="publicPath + '/img/logo-header.png'" alt="">
                </a>

                <a class="filter-menu d-sm-none" @click.prevent="showProjectModels = !showProjectModels" href="#">Filtrar
                    casas
                    <img :src="publicPath + '/img/filter-icon.svg'" alt=""></a>
            </div>

        </div>

        <div class="master-plan-container" ref="masterPlanContainer" v-if="projectInfo">
            <img class="map-image" v-if="!isMobile()" :src="publicPath + '/img/sanfrancisco-masterplan.png'" alt="">
            <img class="map-image" ref="defaultView" v-if="isMobile()"
                 :src="publicPath + '/img/sanfrancisco-masterplan.png'" alt="">
            <!--      Mobile point container-->
            <div class="points-container" v-if="!isMobile()">
                <template v-if="showUnavailableProperties">
                    <template v-for="property in sanFranciscoProperties">
                        <button :key="property.modelCode" :id="'sold_property_'+ property.modelCode"
                                class="color-indicator indicator-in-map sold-property"
                                :class="['property-'+ property.modelCode]"><span
                                class="circle-inner"></span></button>

                        <b-tooltip :key="'tooltip'+ property.modelCode" :target="'sold_property_'+ property.modelCode"
                                   tabindex="0" triggers="click blur">

                            <div class="property-info-tooltip sold-property-card">
                                <div class="image-container">
                                    <img :src="publicPath + '/img/vendido-san-francisco.jpg'"
                                         :alt="'Casa' + property.modelCode">
                                </div>
                                <div class="header-content">
                                    <div class="title">
                                        <h2 class="model-name">{{ property.modelCode }}</h2>
                                    </div>
                                    <div class="financing-info">
                                        <h4>CASA VENDIDA</h4>
                                    </div>
                                </div>
                            </div>
                        </b-tooltip>
                    </template>
                </template>

                <template v-for="property in filteredProperties">
                    <button :key="property.NRO_INMUEBLE" :id="'property_'+ property.NRO_INMUEBLE"
                            class="color-indicator indicator-in-map"
                            :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO ]"><span
                            class="circle-inner"></span></button>

                    <b-tooltip :key="'tooltip'+ property.NRO_INMUEBLE" :target="'property_'+ property.NRO_INMUEBLE"
                               tabindex="0" triggers="click blur">

                        <div class="property-info-tooltip">
                            <form :action="submitUrl" method="post">
                                <div class="inputs-container">
                                    <input type="hidden" name="nombreModelo" :value="getModelName(property.MODELO)">
                                    <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                    <input type="hidden" name="barrio" :value="property.BARRIO">
                                    <input type="hidden" name="etapa" :value="property.ETAPA">
                                    <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                    <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                    <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                    <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                    <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                    <input type="hidden" name="projectId" :value="projectId">
                                    <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                    <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                    <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                    <input type="hidden" name="valorAntesDescuentoUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                    <input type="hidden" name="valorAntesDescuentoPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">


                                    <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                    <input type="hidden" name="simu20precioUF"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20precioPesos"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20periodoCredito"
                                           :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu20montoPie"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20tasaInteres"
                                           :value="property.SIMULACION_20[1].TASA_INTERES">
                                    <input type="hidden" name="simu20valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                    <input type="hidden" name="simu25periodoCredito"
                                           :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu25tasaInteres"
                                           :value="property.SIMULACION_25[1].TASA_INTERES">
                                    <input type="hidden" name="simu25valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu25RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                    <input type="hidden" name="simu30periodoCredito"
                                           :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu30tasaInteres"
                                           :value="property.SIMULACION_30[1].TASA_INTERES">
                                    <input type="hidden" name="simu30valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu30RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                </div>

                                <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                    {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                </div>
                                <div class="image-container">
                                    <img :src="publicPath + '/img/' + getImagesName(property.MODELO)"
                                         :alt="'Casa' + getModelName(property.MODELO)">
                                </div>
                                <div class="header-content">
                                    <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                        <h2 class="model-name">Casa {{ getModelName(property.MODELO) }}</h2>
                                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</span>

                                        <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                            priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                        <h3 class="price" v-else>UF {{
                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                    </div>
                                    <!--                  <div class="financing-info">-->
                                    <!--                    <h4>Dividendo aprox. ${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                    <!--                      currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                    <!--                    <span>30 años / 20% de pie</span>-->
                                    <!--                  </div>-->
                                </div>
                                <div class="body-content">
                                    <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>,
                                        orientación <span>{{ property.ORIENTACION }}</span>,
                                        con un
                                        estacionamiento.</p>

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="16.67" :src="publicPath + '/img/square-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_TOTAL }} m2</span>
                                        </div>
                                    </div>

                                    <p class="show-distribution-link">
                                        <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                        <a :href="'/modelo/?id=' + projectId + '&modelo=' + getModelSlug(property.MODELO) + '#modelDescription'"
                                           target="_blank">Ver distribución en Planta de la casa</a>
                                    </p>

                                    <div class="buttons-container buttons-w-48">
                                        <button type="submit"
                                                @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-yellow">Reservar en linea
                                        </button>
                                        <button type="submit"
                                                @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-outline">Cotizar
                                        </button>
                                    </div>

                                    <div class="terms-info">
                                        *Valores aproximados calculados en base a UF al día de hoy ( {{ dateToday }} ) y
                                        con un plazo de 25
                                        años, con crédito aprobado y 20% de pie.
                                    </div>
                                </div>
                            </form>
                        </div>
                    </b-tooltip>
                </template>
            </div>

            <!--      Desktop point container-->
            <div class="points-container" v-else>
                <template v-if="showUnavailableProperties">
                    <template v-for="property in sanFranciscoProperties">
                        <button v-b-modal="'sold_property_'+ property.modelCode" :key="property.modelCode"
                                class="color-indicator indicator-in-map sold-property"
                                :class="['property-'+ property.modelCode]"><span
                                class="circle-inner"></span>
                        </button>

                        <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.modelCode"
                                 :id="'sold_property_'+ property.modelCode" hide-footer>

                            <b-button class="close custom-close back-button" block
                                      @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                <span>Volver</span>
                            </b-button>

                            <div class="property-info-tooltip sold-property-card">

                                <div class="image-container">
                                    <img :src="publicPath + '/img/vendido-san-francisco.jpg'"
                                         :alt="'Casa' + property.modelCode">
                                </div>

                                <div class="header-content">
                                    <div class="title">
                                        <h2 class="model-name">{{ property.modelCode }}</h2>
                                    </div>
                                    <div class="financing-info">
                                        <h4>CASA VENDIDA</h4>
                                    </div>
                                </div>

                            </div>
                        </b-modal>
                    </template>
                </template>

                <template v-for="property in filteredProperties">
                    <button v-b-modal="'property_'+ property.NRO_INMUEBLE" :key="property.NRO_INMUEBLE"
                            class="color-indicator indicator-in-map"
                            :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO ]"><span
                            class="circle-inner"></span>
                    </button>

                    <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.NRO_INMUEBLE"
                             :id="'property_'+ property.NRO_INMUEBLE" hide-footer>

                        <b-button class="close custom-close back-button" block
                                  @click="$bvModal.hide('property_'+ property.NRO_INMUEBLE)">
                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                            <span>Volver</span>
                        </b-button>

                        <div class="property-info-tooltip">
                            <form :action="submitUrl" method="post">
                                <div class="inputs-container">
                                    <input type="hidden" name="nombreModelo" :value="getModelName(property.MODELO)">
                                    <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                    <input type="hidden" name="barrio" :value="property.BARRIO">
                                    <input type="hidden" name="etapa" :value="property.ETAPA">
                                    <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                    <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                    <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                    <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                    <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                    <input type="hidden" name="projectId" :value="projectId">
                                    <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                    <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                    <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                    <input type="hidden" name="valorAntesDescuentoUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                    <input type="hidden" name="valorAntesDescuentoPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">


                                    <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                    <input type="hidden" name="simu20precioUF"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20precioPesos"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20periodoCredito"
                                           :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu20montoPie"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20tasaInteres"
                                           :value="property.SIMULACION_20[1].TASA_INTERES">
                                    <input type="hidden" name="simu20valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                    <input type="hidden" name="simu25periodoCredito"
                                           :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu25tasaInteres"
                                           :value="property.SIMULACION_25[1].TASA_INTERES">
                                    <input type="hidden" name="simu25valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu25RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                    <input type="hidden" name="simu30periodoCredito"
                                           :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu30tasaInteres"
                                           :value="property.SIMULACION_30[1].TASA_INTERES">
                                    <input type="hidden" name="simu30valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu30RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                </div>

                                <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                    {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                </div>

                                <div class="image-container">
                                    <img :src="publicPath + '/img/' + getImagesName(property.MODELO)"
                                         :alt="'Casa' + getModelName(property.MODELO)">
                                </div>

                                <div class="header-content">
                                    <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                        <h2 class="model-name">Casa {{ getModelName(property.MODELO) }}</h2>
                                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</span>

                                        <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                            priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                        <h3 class="price" v-else>UF {{
                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                    </div>
                                    <!--                  <div class="financing-info">-->
                                    <!--                    <h4>Dividendo aprox. <br>${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                    <!--                      currency('', 0, { thousandsSeparator: '.' })}}*</h4>-->
                                    <!--                    <span>30 años / 20% de pie</span>-->
                                    <!--                  </div>-->
                                </div>

                                <div class="body-content">
                                    <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>,
                                        orientación <span>{{ property.ORIENTACION }}</span>,
                                        con un
                                        estacionamiento.</p>

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="16.67" :src="publicPath + '/img/square-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_TOTAL }} m2</span>
                                        </div>
                                    </div>

                                    <p class="show-distribution-link border-gray-bottom">
                                        <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                        <a :href="'/modelo/?id=' + projectId + '&modelo=' + getModelSlug(property.MODELO)  + '#modelDescription'"
                                           target="_blank">Ver distribución en Planta de la casa</a>
                                    </p>

                                    <div class="buttons-container buttons-w-48">
                                        <button type="submit"
                                                @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-yellow">Reservar en linea
                                        </button>
                                        <button type="submit"
                                                @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-outline">Cotizar
                                        </button>
                                    </div>

                                    <div class="terms-info">
                                        *Valores aproximados calculados en base a UF al día de hoy ( {{ dateToday }} ) y
                                        con un plazo de 25
                                        años, con crédito aprobado y 20% de pie.
                                    </div>
                                </div>
                            </form>
                        </div>
                    </b-modal>
                </template>
            </div>

            <div class="project-info-sidebar desktop-sidebar">
                <div class="logo-container">
                    <a href="/">
                        <img :src="publicPath + '/img/logo-header.png'" alt="">
                    </a>
                </div>
                <ul class="info-items-container">
                    <li class="info-item">
                        <div class="project-info-title">
                            <h2>PROYECTO</h2>
                            <h1>{{ currentProject.PROYECTO }} ETAPA 1, 2 y 3</h1>
                            <span>{{ currentProject.COMUNA }}</span>

                            <p class="price-info item-with-icon">
                                <span class="icon-box"><img :src="publicPath + '/img/security-icon-dark.svg'"
                                                            alt=""></span>Desde UF {{
                                minPrice(properties) | currency('', 0, {thousandsSeparator: '.'})
                                }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="property-counter-item">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/house-icon.svg'"
                                    alt=""></span>Casas disponibles</h3>
                            <span><strong>{{ properties.length }}</strong></span>
                        </div>

                        <!--            <div class="property-counter-item">-->
                        <!--              <p class="item-with-icon">Casas totales</p>-->
                        <!--              <span>{{ currentProject.NRO_INMUEBLES }}</span>-->
                        <!--            </div>-->
                    </li>

                    <li class="info-item">
                        <div class="stages-container">
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-1"></span></span>Etapa 1
                            </p>
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-2"></span></span>Etapa 2
                            </p>
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-3"></span></span>Etapa 3
                            </p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="contact-info-container">
                            <h4>Visita nuestro piloto</h4>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/calendar-two-colors.svg'"
                                    alt=""></span>{{ currentProject.HORARIO_SEMANA }}
                            </p>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/location-icon-yellow.svg'"
                                    alt=""></span>{{ currentProject.DIRECCION }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="example-instruction-container">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/money-icon-dark.svg'"
                                    alt=""></span>¿Cómo cotizo?</h3>
                            <div class="instruction-content">
                                <img :src="publicPath + '/img/dynnamic-map-indication.png'" alt="">
                                <div>
                                    <h4>Selecciona desde el mapa tu nuevo hogar</h4>

                                    <p>Haz click sobre la ubicación de la casa que te interesa para conocer detalles y
                                        cotización</p>
                                </div>
                            </div>
                        </div>

                    </li>

                    <li class="info-item">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=http://esepe.cl/proyecto/sanfrancisco"
                           target="_blank"
                           class="item-with-icon share-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/share-icon-dark.svg'" alt=""></span>Compartir este proyecto</a>
                    </li>
                </ul>
            </div>

        </div>

        <div v-if="isMobile()" class="fixed-project-info">
            <div class="project-name">
                <h1>PROYECTO <strong>{{ currentProject.PROYECTO }}</strong></h1>
                <span>{{ currentProject.COMUNA }}</span>
            </div>
            <p class="price-info item-with-icon"><span class="icon-box"><img
                    :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{
                minPrice(properties) |
                    currency('', 0, {thousandsSeparator: '.'})
                }}</p>


        </div>

        <template v-if="!loading">
            <div class="project-models" v-if="projectInfo" :class="{'show-project-models': showProjectModels}">
                <h3 class="filter-title d-sm-none">Filtra las casas que deseas ver</h3>
                <div class="container esepe-custom-container">
                    <div class="row esepe-row">

                        <div class="col-md-3">
                            <div class="model-item justify-content-md-center" @click="changeFilterSelected('all')"
                                 :class="{active: filterSelected === 'all'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <p>Todos los modelos</p>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('SF75')"
                                 :class="{active: filterSelected === 'SF75'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <div class="model-info">
                                    <span class="color-indicator model-SF75"></span>
                                    <div>
                                        <p>Casa Lux - {{ luxModelproperties.length }} casas 77,64 mt2 - 3d / 3b</p>
                                        <h4>Desde UF {{
                                            minPrice(luxModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('SF90')"
                                 :class="{active: filterSelected === 'SF90'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <div class="model-info">
                                    <span class="color-indicator model-SF90"></span>
                                    <div>
                                        <p>Casa Terra - {{ terraModelproperties.length }} casas 96,05 mt2 - 3d / 3b</p>
                                        <h4>Desde UF {{
                                            minPrice(terraModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('SF100')"
                                 :class="{active: filterSelected === 'SF100'}">
                                <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">
                                <div class="model-info">
                                    <span class="color-indicator model-SF100"></span>
                                    <div>
                                        <p>Casa Aqua - {{ aquaModelproperties.length }} casas 104,77 mt2 - 4d / 3b</p>
                                        <h4>Desde UF {{
                                            minPrice(aquaModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </template>

        <b-modal ref="instructionModal" hide-footer modal-class="guide-modal" id="guideModal">
            <div class="guide-modal-content">
                <div class="header-content">
                    <h3>IMPORTANTE</h3>
                    <img :src="publicPath + '/img/guide-img-sf.png'" alt="">
                </div>
                <div class="footer-content">
                    <div class="d-flex align-items-center text-info">
                        <img :src="publicPath + '/img/alert-dark-icon.png'" alt="">
                        <p>Posicionando el cursor por encima de cada uno de los círculos
                            de colores de la vista, podrás acceder a más información sobre cada
                            una de las casas, así como también cotizarlas o
                            reservarlas en línea. <a href="/como-reservar-o-cotizar/">Más información</a></p>
                    </div>
                    <b-button v-b-toggle.collapseContent
                              class="button-call-action dark-btn"
                              block @click="$bvModal.hide('guideModal')">¡Entendido!
                    </b-button>

                </div>
            </div>
        </b-modal>
    </div>

  <!--projectId == '805' - 33583 Altos Del Valle-->
    <div v-else-if="projectApiId == '2'" class="master-plan-page altos-del-valle-project"
         :class="{'loading-view': loading}">
        <template v-if="loading">
            <div class="lds-loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </template>
        <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
            <div class="logo-container">
                <a href="/">
                    <img :src="publicPath + '/img/logo-header.png'" alt="">
                </a>

                <a class="filter-menu d-sm-none" @click.prevent="showProjectModels = !showProjectModels" href="#">Filtrar
                    casas
                    <img :src="publicPath + '/img/filter-icon.svg'" alt=""></a>
            </div>
        </div>

        <div class="master-plan-container altos-del-valle-project" ref="masterPlanContainer" v-if="projectInfo">
            <template v-if="projectId === '33583'">
                <img class="map-image" v-if="!isMobile()"
                     :src="publicPath + '/img/masterplan_altos-del-valle-etapa-4.png'" alt="">
                <img class="map-image" ref="defaultView" v-if="isMobile()"
                     :src="publicPath + '/img/masterplan_altos-del-valle-etapa-4.png'" alt="">
            </template>
            <template v-else>
                <img class="map-image" v-if="!isMobile()" :src="publicPath + '/img/masterplan_altos-del-valle.png'"
                     alt="">
                <img class="map-image" ref="defaultView" v-if="isMobile()"
                     :src="publicPath + '/img/masterplan_altos-del-valle.png'" alt="">
            </template>

            <div class="points-container" v-if="!isMobile()">
                <template v-if="showUnavailableProperties">
                    <template v-if="projectId === '33583'">
                        <template v-for="property in altosVallePropertiesEtapa4">
                            <button :key="property.modelCode" :id="'sold_property_'+ property.modelCode"
                                    class="color-indicator indicator-in-map sold-property stage-4-indicator"
                                    :class="['property-'+ property.modelCode]"><span
                                    class="circle-inner"></span></button>

                            <b-tooltip :key="'tooltip'+ property.modelCode"
                                       :target="'sold_property_'+ property.modelCode"
                                       tabindex="0" triggers="click blur">

                                <div class="property-info-tooltip sold-property-card">
                                    <div class="image-container">
                                        <img :src="publicPath + '/img/vendido-adv.jpg'"
                                             :alt="'Casa' + property.modelCode">
                                    </div>
                                    <div class="header-content">
                                        <div class="title">
                                            <h2 class="model-name">{{ property.modelCode }}</h2>
                                        </div>
                                        <div class="financing-info">
                                            <h4>CASA VENDIDA</h4>
                                        </div>
                                    </div>
                                </div>
                            </b-tooltip>
                        </template>
                    </template>

                    <template v-else>
                        <template v-for="property in altosValleProperties">
                            <button :key="property.modelCode" :id="'sold_property_'+ property.modelCode"
                                    class="color-indicator indicator-in-map sold-property"
                                    :class="['property-'+ property.modelCode]"><span
                                    class="circle-inner"></span></button>

                            <b-tooltip :key="'tooltip'+ property.modelCode"
                                       :target="'sold_property_'+ property.modelCode"
                                       tabindex="0" triggers="click blur">

                                <div class="property-info-tooltip sold-property-card">
                                    <div class="image-container">
                                        <img :src="publicPath + '/img/vendido-adv.jpg'"
                                             :alt="'Casa' + property.modelCode">
                                    </div>
                                    <div class="header-content">
                                        <div class="title">
                                            <h2 class="model-name">{{ property.modelCode }}</h2>
                                        </div>
                                        <div class="financing-info">
                                            <h4>CASA VENDIDA</h4>
                                        </div>
                                    </div>
                                </div>
                            </b-tooltip>
                        </template>
                    </template>

                </template>

                <template v-for="property in filteredProperties">
                    <button :key="property.NRO_INMUEBLE" :id="'property_'+ property.NRO_INMUEBLE"
                            class="color-indicator indicator-in-map"
                            :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO, { 'stage-4-indicator': projectId === '33583' } ]"><span
                            class="circle-inner"></span></button>

                    <b-tooltip tabindex="0" :key="'tooltip'+ property.NRO_INMUEBLE"
                               :target="'property_'+ property.NRO_INMUEBLE"
                               triggers="click blur">

                        <div class="property-info-tooltip">
                            <form :action="submitUrl" method="post">
                                <div class="inputs-container">
                                    <input type="hidden" name="nombreModelo" :value="getModelName(property.MODELO)">
                                    <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                    <input type="hidden" name="barrio" :value="property.BARRIO">
                                    <input type="hidden" name="etapa" :value="property.ETAPA">
                                    <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                    <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                    <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_CONSTRUIDA">
                                    <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                    <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                    <input type="hidden" name="projectId" :value="projectId">
                                    <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                    <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                    <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                    <input type="hidden" name="valorAntesDescuentoUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                    <input type="hidden" name="valorAntesDescuentoPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">


                                    <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                    <input type="hidden" name="simu20precioUF"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE)  | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20precioPesos"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20periodoCredito"
                                           :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu20montoPie"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20tasaInteres"
                                           :value="property.SIMULACION_20[1].TASA_INTERES">
                                    <input type="hidden" name="simu20valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                    <input type="hidden" name="simu25periodoCredito"
                                           :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu25tasaInteres"
                                           :value="property.SIMULACION_25[1].TASA_INTERES">
                                    <input type="hidden" name="simu25valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu25RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                    <input type="hidden" name="simu30periodoCredito"
                                           :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu30tasaInteres"
                                           :value="property.SIMULACION_30[1].TASA_INTERES">
                                    <input type="hidden" name="simu30valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu30RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                </div>
                                <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                    {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                </div>
                                <div class="image-container">
                                    <img :src="publicPath + '/img/' + getImagesName(property.MODELO)"
                                         :alt="'Casa' + getModelName(property.MODELO)">
                                </div>
                                <div class="header-content">
                                    <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                        <h2 class="model-name">Casa {{ getModelName(property.MODELO) }}</h2>
                                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</span>

                                        <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                            priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                        <h3 class="price" v-else>UF {{
                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                    </div>
                                    <!--                  <div class="financing-info">-->
                                    <!--                    <h4>Dividendo aprox. ${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                    <!--                      currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                    <!--                    <span>30 años / 20% de pie</span>-->
                                    <!--                  </div>-->
                                </div>
                                <div class="body-content">
                                    <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>,
                                        orientación <span>{{ property.ORIENTACION }}</span>,
                                        con un
                                        estacionamiento.</p>

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="16.67" :src="publicPath + '/img/square-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_TOTAL }} m2</span>
                                        </div>
                                    </div>

                                    <p class="show-distribution-link">
                                        <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                        <a :href="'/modelo/?id=' + projectId + '&modelo=' + getModelSlug(property.MODELO) + '#modelDescription'"
                                           target="_blank">Ver distribución en Planta de la casa</a>
                                    </p>

                                    <div class="buttons-container buttons-w-48">
                                        <button type="submit"
                                                @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-yellow">Reservar en linea
                                        </button>
                                        <button type="submit"
                                                @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-outline">Cotizar
                                        </button>

                                    </div>

                                    <div class="terms-info">
                                        *Valores aproximados calculados en base a UF al día de hoy ( {{ dateToday }} ) y
                                        con un plazo de 25
                                        años, con crédito aprobado y 20% de pie.
                                    </div>
                                </div>
                            </form>

                        </div>
                    </b-tooltip>
                </template>
            </div>

            <div class="points-container" v-else>
                <template v-if="showUnavailableProperties">

                    <template v-if="projectId === '33583'">
                        <template v-for="property in altosVallePropertiesEtapa4">
                            <button v-b-modal="'sold_property_'+ property.modelCode" :key="property.modelCode"
                                    class="color-indicator indicator-in-map sold-property"
                                    :class="['property-'+ property.modelCode]"><span
                                    class="circle-inner"></span>
                            </button>

                            <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.modelCode"
                                     :id="'sold_property_'+ property.modelCode" hide-footer>
                                <b-button class="close custom-close back-button" block
                                          @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                    <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                    <span>Volver</span>
                                </b-button>

                                <div class="property-info-tooltip sold-property-card">

                                    <div class="image-container">
                                        <img :src="publicPath + '/img/vendido-adv.jpg'"
                                             :alt="'Casa' + property.modelCode">
                                    </div>

                                    <div class="header-content">
                                        <div class="title">
                                            <h2 class="model-name">{{ property.modelCode }}</h2>
                                        </div>
                                        <div class="financing-info">
                                            <h4>CASA VENDIDA</h4>
                                        </div>
                                    </div>

                                </div>
                            </b-modal>
                        </template>
                    </template>

                    <template v-else>
                        <template v-for="property in altosValleProperties">
                            <button v-b-modal="'sold_property_'+ property.modelCode" :key="property.modelCode"
                                    class="color-indicator indicator-in-map sold-property"
                                    :class="['property-'+ property.modelCode]"><span
                                    class="circle-inner"></span>
                            </button>

                            <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.modelCode"
                                     :id="'sold_property_'+ property.modelCode" hide-footer>
                                <b-button class="close custom-close back-button" block
                                          @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                    <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                    <span>Volver</span>
                                </b-button>

                                <div class="property-info-tooltip sold-property-card">

                                    <div class="image-container">
                                        <img :src="publicPath + '/img/vendido-adv.jpg'"
                                             :alt="'Casa' + property.modelCode">
                                    </div>

                                    <div class="header-content">
                                        <div class="title">
                                            <h2 class="model-name">{{ property.modelCode }}</h2>
                                        </div>
                                        <div class="financing-info">
                                            <h4>CASA VENDIDA</h4>
                                        </div>
                                    </div>

                                </div>
                            </b-modal>
                        </template>
                    </template>

                </template>

                <template v-for="property in filteredProperties">
                    <button v-b-modal="'property_'+ property.NRO_INMUEBLE" :key="property.NRO_INMUEBLE"
                            class="color-indicator indicator-in-map"
                            :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO, { 'stage-4-indicator': projectId === '33583' }]"><span
                            class="circle-inner"></span>
                    </button>

                    <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.NRO_INMUEBLE"
                             :id="'property_'+ property.NRO_INMUEBLE" hide-footer>

                        <b-button class="close custom-close back-button" block
                                  @click="$bvModal.hide('property_'+ property.NRO_INMUEBLE)">
                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                            <span>Volver</span>
                        </b-button>

                        <div class="property-info-tooltip">
                            <form :action="submitUrl" method="post">
                                <div class="inputs-container">
                                    <input type="hidden" name="nombreModelo" :value="getModelName(property.MODELO)">
                                    <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                    <input type="hidden" name="barrio" :value="property.BARRIO">
                                    <input type="hidden" name="etapa" :value="property.ETAPA">
                                    <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                    <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                    <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                    <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                    <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                    <input type="hidden" name="projectId" :value="projectId">
                                    <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                    <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                    <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                    <input type="hidden" name="valorAntesDescuentoUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                    <input type="hidden" name="valorAntesDescuentoPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">


                                    <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                    <input type="hidden" name="simu20precioUF"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20precioPesos"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20periodoCredito"
                                           :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu20montoPie"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20tasaInteres"
                                           :value="property.SIMULACION_20[1].TASA_INTERES">
                                    <input type="hidden" name="simu20valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                    <input type="hidden" name="simu25periodoCredito"
                                           :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu25tasaInteres"
                                           :value="property.SIMULACION_25[1].TASA_INTERES">
                                    <input type="hidden" name="simu25valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu25RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                    <input type="hidden" name="simu30periodoCredito"
                                           :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu30tasaInteres"
                                           :value="property.SIMULACION_30[1].TASA_INTERES">
                                    <input type="hidden" name="simu30valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu30RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                </div>

                                <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                    {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                </div>

                                <div class="image-container">
                                    <img :src="publicPath + '/img/' + getImagesName(property.MODELO)"
                                         :alt="'Casa' + getModelName(property.MODELO)">
                                </div>

                                <div class="header-content">
                                    <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                        <h2 class="model-name">Casa {{ getModelName(property.MODELO) }}</h2>
                                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</span>

                                        <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                            priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                        <h3 class="price" v-else>UF {{
                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                    </div>
                                    <!--                  <div class="financing-info">-->
                                    <!--                    <h4>Dividendo aprox. <br>${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                    <!--                      currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                    <!--                    <span>30 años / 20% de pie</span>-->
                                    <!--                  </div>-->
                                </div>

                                <div class="body-content">
                                    <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>,
                                        orientación <span>{{ property.ORIENTACION }}</span>,
                                        con un
                                        estacionamiento.</p>

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="16.67" :src="publicPath + '/img/square-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_TOTAL }} m2</span>
                                        </div>
                                    </div>

                                    <p class="show-distribution-link border-gray-bottom">
                                        <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                        <a :href="'/modelo/?id=' + projectId + '&modelo=' + getModelSlug(property.MODELO)  + '#modelDescription'"
                                           target="_blank">Ver distribución en Planta de la casa</a>
                                    </p>

                                    <div class="buttons-container buttons-w-48">

                                        <button type="submit"
                                                @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-yellow">Reservar en linea
                                        </button>
                                        <button type="submit"
                                                @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-outline">Cotizar
                                        </button>
                                    </div>

                                    <div class="terms-info">
                                        *Valores aproximados calculados en base a UF al día de hoy ( {{ dateToday }} ) y
                                        con un plazo de 25
                                        años, con crédito aprobado y 20% de pie.
                                    </div>
                                </div>
                            </form>

                        </div>
                    </b-modal>
                </template>

            </div>

            <div class="project-info-sidebar desktop-sidebar">
                <div class="logo-container">
                    <a href="/">
                        <img :src="publicPath + '/img/logo-header.png'" alt="">
                    </a>
                </div>
                <ul class="info-items-container">
                    <li class="info-item">
                        <div class="project-info-title">
                            <h2>PROYECTO</h2>
                            <template v-if="projectId === '33583'">
                                <h1>{{ currentProject.PROYECTO }} Oriente</h1>
                            </template>

                            <template v-else>
                                <h1>{{ currentProject.PROYECTO }} ETAPA 1, 2 y 3</h1>
                            </template>

                            <span>{{ currentProject.COMUNA }}</span>

                            <p class="price-info item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{
                                minPrice(properties) |
                                    currency('', 0, {thousandsSeparator: '.'})
                                }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="property-counter-item">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/house-icon.svg'"
                                    alt=""></span>Casas disponibles</h3>
                            <span><strong>{{ properties.length }}</strong></span>
                        </div>

                        <!--            <div class="property-counter-item">-->
                        <!--              <p class="item-with-icon">Casas totales</p>-->
                        <!--              <span>{{ currentProject.NRO_INMUEBLES }}</span>-->
                        <!--            </div>-->
                    </li>

                    <li class="info-item" v-if="projectId === '805'">
                        <div class="stages-container">
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-1"></span></span>Etapa 1</p>
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-2"></span></span>Etapa 2</p>
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-3"></span></span>Etapa 3</p>
                            <!--                            <p class="item-with-icon"><span class="icon-box"><span-->
                            <!--                                    class="color-point stage-4"></span></span>Etapa 4</p>-->
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="contact-info-container">
                            <h4>Visita nuestro piloto</h4>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/calendar-two-colors.svg'"
                                    alt=""></span>{{ currentProject.HORARIO_SEMANA }}
                            </p>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/location-icon-yellow.svg'"
                                    alt=""></span>{{ currentProject.DIRECCION }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="example-instruction-container">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/money-icon-dark.svg'"
                                    alt=""></span>¿Cómo cotizo?</h3>
                            <div class="instruction-content">
                                <img :src="publicPath + '/img/dynnamic-map-indication.png'" alt="">
                                <div>
                                    <h4>Selecciona desde el mapa tu nuevo hogar</h4>

                                    <p>Haz click sobre la ubicación de la casa que te interesa para conocer detalles y
                                        cotización</p>
                                </div>
                            </div>
                        </div>

                    </li>

                    <li class="info-item">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=http://esepe.cl/proyecto/casas-nuevas-en-puente-alto"
                           target="_blank" class="item-with-icon share-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/share-icon-dark.svg'" alt=""></span>Compartir este proyecto</a>
                    </li>
                </ul>
            </div>

        </div>

        <div v-if="isMobile()" class="fixed-project-info">
            <div class="project-name">
                <h1>PROYECTO <strong>{{ currentProject.PROYECTO }}</strong></h1>
                <span>{{ currentProject.COMUNA }}</span>
            </div>
            <p class="price-info item-with-icon"><span class="icon-box"><img
                    :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{
                minPrice(properties) |
                    currency('', 0, {thousandsSeparator: '.'})
                }}</p>

        </div>

        <template v-if="!loading">
            <div class="project-models" :class="{'show-project-models': showProjectModels}">
                <h3 class="filter-title d-sm-none">Filtra las casas que deseas ver</h3>
                <div class="container esepe-custom-container">
                    <div class="row esepe-row">

                        <template v-if="projectId === '33583'">

                            <div class="col-md-3">
                                <div class="model-item justify-content-md-center" @click="changeFilterSelected('all')"
                                     :class="{active: filterSelected === 'all'}">
                                    <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                    <p>Todos los modelos</p>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/all-models-icon.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/all-models-icon-dark.svg'" alt="">-->
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="model-item" @click="changeFilterSelected('Calbuco-AV09')"
                                     :class="{active: filterSelected === 'Calbuco-AV09'}">
                                    <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                    <div class="model-info">
                                        <span class="color-indicator model-Calbuco-AV09"></span>
                                        <div>
                                            <p>Casa Calbuco - <!-- {{ calbucoModelproperties.length }}  casas --> 74,71
                                                mt2 - 3d /
                                                2b</p>
                                            <h4>Desde UF {{
                                                minPrice(calbucoModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</h4>
                                        </div>
                                    </div>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/house-icon-white.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/house-icon.svg'" alt="">-->
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="model-item" @click="changeFilterSelected('Osorno-AV07')"
                                     :class="{active: filterSelected === 'Osorno-AV07'}">
                                    <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                    <div class="model-info">
                                        <span class="color-indicator model-Osorno-AV07"></span>
                                        <div>
                                            <p>Casa Osorno - <!-- {{ osornoModelproperties.length }} casas -->83,01 mt2
                                                - 3d / 2b</p>
                                            <h4>Desde UF {{
                                                minPrice(osornoModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</h4>
                                        </div>
                                    </div>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/apartment-icon-white.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/apartment-icon.svg'" alt="">-->
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="model-item" @click="changeFilterSelected('Lonquimay-AV03')"
                                     :class="{active: filterSelected === 'Lonquimay-AV03'}">
                                    <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">
                                    <div class="model-info">
                                        <span class="color-indicator model-Lonquimay-AV03"></span>
                                        <div>
                                            <p>Casa Lonquimay - <!--{{ lonquimayModelproperties.length }} casas-->90,24
                                                mt2 - 3d /
                                                3b</p>
                                            <h4>Desde UF {{
                                                minPrice(lonquimayModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</h4>
                                        </div>
                                    </div>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/house-2-icon-white.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/house-2-icon.svg'" alt="">-->
                                </div>
                            </div>

                        </template>

                        <template v-else>

                            <div class="col-md-2">
                                <div class="model-item justify-content-md-center" @click="changeFilterSelected('all')"
                                     :class="{active: filterSelected === 'all'}">
                                    <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                    <p>Todos los modelos</p>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/all-models-icon.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/all-models-icon-dark.svg'" alt="">-->
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="model-item" @click="changeFilterSelected('Calbuco-AV09')"
                                     :class="{active: filterSelected === 'Calbuco-AV09'}">
                                    <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                    <div class="model-info">
                                        <span class="color-indicator model-Calbuco-AV09"></span>
                                        <div>
                                            <p>Casa Calbuco - <!-- {{ calbucoModelproperties.length }}  casas --> 74,71
                                                mt2 - 3d /
                                                2b</p>
                                            <h4>Desde UF {{
                                                minPrice(calbucoModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</h4>
                                        </div>
                                    </div>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/house-icon-white.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/house-icon.svg'" alt="">-->
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="model-item" @click="changeFilterSelected('Osorno-AV07')"
                                     :class="{active: filterSelected === 'Osorno-AV07'}">
                                    <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                    <div class="model-info">
                                        <span class="color-indicator model-Osorno-AV07"></span>
                                        <div>
                                            <p>Casa Osorno - <!-- {{ osornoModelproperties.length }} casas -->83,01 mt2
                                                - 3d / 2b</p>
                                            <h4>Desde UF {{
                                                minPrice(osornoModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</h4>
                                        </div>
                                    </div>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/apartment-icon-white.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/apartment-icon.svg'" alt="">-->
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="model-item" @click="changeFilterSelected('Lonquimay-AV03')"
                                     :class="{active: filterSelected === 'Lonquimay-AV03'}">
                                    <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">
                                    <div class="model-info">
                                        <span class="color-indicator model-Lonquimay-AV03"></span>
                                        <div>
                                            <p>Casa Lonquimay - <!--{{ lonquimayModelproperties.length }} casas-->90,24
                                                mt2 - 3d /
                                                3b</p>
                                            <h4>Desde UF {{
                                                minPrice(lonquimayModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</h4>
                                        </div>
                                    </div>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/house-2-icon-white.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/house-2-icon.svg'" alt="">-->
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="model-item" @click="changeFilterSelected('Llaima-AV08')"
                                     :class="{active: filterSelected === 'Llaima-AV08'}">
                                    <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">
                                    <div class="model-info">
                                        <span class="color-indicator model-Llaima-AV08"></span>
                                        <div>
                                            <p>Casa Llaima - <!--{{ llaimaModelproperties.length }} casas--> 124,29 mt2
                                                - 4d /
                                                3b</p>
                                            <h4>Desde UF {{
                                                minPrice(llaimaModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</h4>
                                        </div>
                                    </div>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/house-2-icon-white.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/house-2-icon.svg'" alt="">-->
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="model-item" @click="changeFilterSelected('SanJose-AV10')"
                                     :class="{active: filterSelected === 'SanJose-AV10'}">
                                    <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">
                                    <div class="model-info">
                                        <span class="color-indicator model-SanJose-AV10"></span>
                                        <div>
                                            <p>Casa San José - <!--{{ sanJoseModelproperties.length }} casas--> 125,31
                                                mt2 - 5d /
                                                3b</p>
                                            <h4>Desde UF {{
                                                minPrice(sanJoseModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</h4>
                                        </div>
                                    </div>
                                    <!--                <img class="model-icon-active" :src="publicPath + '/img/house-2-icon-white.svg'" alt="">-->
                                    <!--                <img class="model-icon" :src="publicPath + '/img/house-2-icon.svg'" alt="">-->
                                </div>
                            </div>
                        </template>

                    </div>
                </div>
            </div>
        </template>

        <b-modal ref="instructionModal" hide-footer modal-class="guide-modal" id="guideModal">
            <div class="guide-modal-content">
                <div class="header-content">
                    <h3>IMPORTANTE</h3>
                    <img :src="publicPath + '/img/guide-img-av.png'" alt="">
                </div>
                <div class="footer-content">
                    <div class="d-flex align-items-center text-info">
                        <img :src="publicPath + '/img/alert-dark-icon.png'" alt="">
                        <p>Posicionando el cursor por encima de cada uno de los círculos
                            de colores de la vista, podrás acceder a más información sobre cada
                            una de las casas, así como también cotizarlas o
                            reservarlas en línea. <a href="/como-reservar-o-cotizar/">Más información</a></p>
                    </div>
                    <b-button v-b-toggle.collapseContent
                              class="button-call-action dark-btn"
                              block @click="$bvModal.hide('guideModal')">¡Entendido!
                    </b-button>

                </div>
            </div>
        </b-modal>
    </div>

  <!--projectId == '33583' Altos Del Valle-->
    <div v-else-if="projectApiId == '6'" class="master-plan-page altos-del-valle-project"
         :class="{'loading-view': loading}">
        <template v-if="loading">
            <div class="lds-loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </template>
        <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
            <div class="logo-container">
                <a href="/">
                    <img :src="publicPath + '/img/logo-header.png'" alt="">
                </a>

                <a class="filter-menu d-sm-none" @click.prevent="showProjectModels = !showProjectModels" href="#">Filtrar
                    casas
                    <img :src="publicPath + '/img/filter-icon.svg'" alt=""></a>
            </div>
        </div>

        <div class="master-plan-container altos-del-valle-project" ref="masterPlanContainer" v-if="projectInfo">
            <img class="map-image" v-if="!isMobile()" :src="publicPath + '/img/masterplan_altos-del-valle-etapa-4.png'"
                 alt="">
            <img class="map-image" ref="defaultView" v-if="isMobile()"
                 :src="publicPath + '/img/masterplan_altos-del-valle-etapa-4.png'" alt="">

            <div class="points-container" v-if="!isMobile()">
                <template v-if="showUnavailableProperties">
                    <template v-for="property in altosVallePropertiesEtapa4">
                        <button :key="property.modelCode" :id="'sold_property_'+ property.modelCode"
                                class="color-indicator indicator-in-map sold-property stage-4-indicator"
                                :class="['property-'+ property.modelCode]"><span
                                class="circle-inner"></span></button>

                        <b-tooltip :key="'tooltip'+ property.modelCode" :target="'sold_property_'+ property.modelCode"
                                   tabindex="0" triggers="click blur">

                            <div class="property-info-tooltip sold-property-card">
                                <div class="image-container">
                                    <img :src="publicPath + '/img/vendido-adv.jpg'"
                                         :alt="'Casa' + property.modelCode">
                                </div>
                                <div class="header-content">
                                    <div class="title">
                                        <h2 class="model-name">{{ property.modelCode }}</h2>
                                    </div>
                                    <div class="financing-info">
                                        <h4>CASA VENDIDA</h4>
                                    </div>
                                </div>
                            </div>
                        </b-tooltip>
                    </template>

                </template>

                <template v-for="property in filteredProperties">
                    <button :key="property.NRO_INMUEBLE" :id="'property_'+ property.NRO_INMUEBLE"
                            class="color-indicator indicator-in-map stage-4-indicator"
                            :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO ]"><span
                            class="circle-inner"></span></button>

                    <b-tooltip tabindex="0" :key="'tooltip'+ property.NRO_INMUEBLE"
                               :target="'property_'+ property.NRO_INMUEBLE"
                               triggers="click blur">

                        <div class="property-info-tooltip">
                            <form :action="submitUrl" method="post">
                                <div class="inputs-container">
                                    <input type="hidden" name="nombreModelo" :value="getModelName(property.MODELO)">
                                    <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                    <input type="hidden" name="barrio" :value="property.BARRIO">
                                    <input type="hidden" name="etapa" :value="property.ETAPA">
                                    <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                    <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                    <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_CONSTRUIDA">
                                    <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                    <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                    <input type="hidden" name="projectId" :value="projectId">
                                    <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                    <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                    <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                    <input type="hidden" name="valorAntesDescuentoUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                    <input type="hidden" name="valorAntesDescuentoPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">


                                    <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                    <input type="hidden" name="simu20precioUF"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE)  | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20precioPesos"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20periodoCredito"
                                           :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu20montoPie"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20tasaInteres"
                                           :value="property.SIMULACION_20[1].TASA_INTERES">
                                    <input type="hidden" name="simu20valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                    <input type="hidden" name="simu25periodoCredito"
                                           :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu25tasaInteres"
                                           :value="property.SIMULACION_25[1].TASA_INTERES">
                                    <input type="hidden" name="simu25valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu25RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                    <input type="hidden" name="simu30periodoCredito"
                                           :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu30tasaInteres"
                                           :value="property.SIMULACION_30[1].TASA_INTERES">
                                    <input type="hidden" name="simu30valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu30RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                </div>
                                <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                    {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                </div>
                                <div class="image-container">
                                    <img :src="publicPath + '/img/advo-' + getImagesName(property.MODELO)"
                                         :alt="'Casa' + getModelName(property.MODELO)">
                                </div>
                                <div class="header-content">
                                    <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                        <h2 class="model-name">Casa {{ getModelName(property.MODELO) }}</h2>
                                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</span>

                                        <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                            priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                        <h3 class="price" v-else>UF {{
                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                    </div>
                                    <!--                  <div class="financing-info">-->
                                    <!--                    <h4>Dividendo aprox. ${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                    <!--                      currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                    <!--                    <span>30 años / 20% de pie</span>-->
                                    <!--                  </div>-->
                                </div>
                                <div class="body-content">
                                    <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>,
                                        orientación <span>{{ property.ORIENTACION }}</span>,
                                        con un
                                        estacionamiento.</p>

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="16.67" :src="publicPath + '/img/square-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_TOTAL }} m2</span>
                                        </div>
                                    </div>

                                    <p class="show-distribution-link">
                                        <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                        <a :href="'/modelo/?id=' + projectId + '&modelo=' + getModelSlug(property.MODELO) + '#modelDescription'"
                                           target="_blank">Ver distribución en Planta de la casa</a>
                                    </p>

                                    <div class="buttons-container buttons-w-48">
                                        <button type="submit"
                                                @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-yellow">Reservar en linea
                                        </button>
                                        <button type="submit"
                                                @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-outline">Cotizar
                                        </button>

                                    </div>

                                    <div class="terms-info">
                                        *Valores aproximados calculados en base a UF al día de hoy ( {{ dateToday }} ) y
                                        con un plazo de 25
                                        años, con crédito aprobado y 20% de pie.
                                    </div>
                                </div>
                            </form>

                        </div>
                    </b-tooltip>
                </template>
            </div>

            <div class="points-container" v-else>
                <template v-if="showUnavailableProperties">

                    <template v-for="property in altosVallePropertiesEtapa4">
                        <button v-b-modal="'sold_property_'+ property.modelCode" :key="property.modelCode"
                                class="color-indicator indicator-in-map sold-property"
                                :class="['property-'+ property.modelCode]"><span
                                class="circle-inner"></span>
                        </button>

                        <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.modelCode"
                                 :id="'sold_property_'+ property.modelCode" hide-footer>
                            <b-button class="close custom-close back-button" block
                                      @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                <span>Volver</span>
                            </b-button>

                            <div class="property-info-tooltip sold-property-card">

                                <div class="image-container">
                                    <img :src="publicPath + '/img/vendido-adv.jpg'"
                                         :alt="'Casa' + property.modelCode">
                                </div>

                                <div class="header-content">
                                    <div class="title">
                                        <h2 class="model-name">{{ property.modelCode }}</h2>
                                    </div>
                                    <div class="financing-info">
                                        <h4>CASA VENDIDA</h4>
                                    </div>
                                </div>

                            </div>
                        </b-modal>
                    </template>

                </template>

                <template v-for="property in filteredProperties">
                    <button v-b-modal="'property_'+ property.NRO_INMUEBLE" :key="property.NRO_INMUEBLE"
                            class="color-indicator indicator-in-map stage-4-indicator"
                            :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO]"><span
                            class="circle-inner"></span>
                    </button>

                    <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.NRO_INMUEBLE"
                             :id="'property_'+ property.NRO_INMUEBLE" hide-footer>

                        <b-button class="close custom-close back-button" block
                                  @click="$bvModal.hide('property_'+ property.NRO_INMUEBLE)">
                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                            <span>Volver</span>
                        </b-button>

                        <div class="property-info-tooltip">
                            <form :action="submitUrl" method="post">
                                <div class="inputs-container">
                                    <input type="hidden" name="nombreModelo" :value="getModelName(property.MODELO)">
                                    <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                    <input type="hidden" name="barrio" :value="property.BARRIO">
                                    <input type="hidden" name="etapa" :value="property.ETAPA">
                                    <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                    <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                    <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                    <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                    <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                    <input type="hidden" name="projectId" :value="projectId">
                                    <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                    <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                    <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                    <input type="hidden" name="valorAntesDescuentoUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                    <input type="hidden" name="valorAntesDescuentoPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">


                                    <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                    <input type="hidden" name="simu20precioUF"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20precioPesos"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20periodoCredito"
                                           :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu20montoPie"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20tasaInteres"
                                           :value="property.SIMULACION_20[1].TASA_INTERES">
                                    <input type="hidden" name="simu20valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                    <input type="hidden" name="simu25periodoCredito"
                                           :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu25tasaInteres"
                                           :value="property.SIMULACION_25[1].TASA_INTERES">
                                    <input type="hidden" name="simu25valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu25RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                    <input type="hidden" name="simu30periodoCredito"
                                           :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu30tasaInteres"
                                           :value="property.SIMULACION_30[1].TASA_INTERES">
                                    <input type="hidden" name="simu30valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu30RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                </div>

                                <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                    {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                </div>

                                <div class="image-container">
                                    <img :src="publicPath + '/img/advo-' + getImagesName(property.MODELO)"
                                         :alt="'Casa' + getModelName(property.MODELO)">
                                </div>

                                <div class="header-content">
                                    <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                        <h2 class="model-name">Casa {{ getModelName(property.MODELO) }}</h2>
                                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</span>

                                        <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                            priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                        <h3 class="price" v-else>UF {{
                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                    </div>
                                    <!--                  <div class="financing-info">-->
                                    <!--                    <h4>Dividendo aprox. <br>${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                    <!--                      currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                    <!--                    <span>30 años / 20% de pie</span>-->
                                    <!--                  </div>-->
                                </div>

                                <div class="body-content">
                                    <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>,
                                        orientación <span>{{ property.ORIENTACION }}</span>,
                                        con un
                                        estacionamiento.</p>

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="16.67" :src="publicPath + '/img/square-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_TOTAL }} m2</span>
                                        </div>
                                    </div>

                                    <p class="show-distribution-link border-gray-bottom">
                                        <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                        <a :href="'/modelo/?id=' + projectId + '&modelo=' + getModelSlug(property.MODELO)  + '#modelDescription'"
                                           target="_blank">Ver distribución en Planta de la casa</a>
                                    </p>

                                    <div class="buttons-container buttons-w-48">

                                        <button type="submit"
                                                @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-yellow">Reservar en linea
                                        </button>
                                        <button type="submit"
                                                @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-outline">Cotizar
                                        </button>
                                    </div>

                                    <div class="terms-info">
                                        *Valores aproximados calculados en base a UF al día de hoy ( {{ dateToday }} ) y
                                        con un plazo de 25
                                        años, con crédito aprobado y 20% de pie.
                                    </div>
                                </div>
                            </form>

                        </div>
                    </b-modal>
                </template>

            </div>

            <div class="project-info-sidebar desktop-sidebar">
                <div class="logo-container">
                    <a href="/">
                        <img :src="publicPath + '/img/logo-header.png'" alt="">
                    </a>
                </div>
                <ul class="info-items-container">
                    <li class="info-item">
                        <div class="project-info-title">
                            <h2>PROYECTO</h2>
                            <h1>{{ currentProject.PROYECTO }} Oriente</h1>

                            <span>{{ currentProject.COMUNA }}</span>

                            <p class="price-info item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{
                                minPrice(properties) |
                                    currency('', 0, {thousandsSeparator: '.'})
                                }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="property-counter-item">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/house-icon.svg'"
                                    alt=""></span>Casas disponibles</h3>
                            <span><strong>{{ properties.length }}</strong></span>
                        </div>

                        <!--            <div class="property-counter-item">-->
                        <!--              <p class="item-with-icon">Casas totales</p>-->
                        <!--              <span>{{ currentProject.NRO_INMUEBLES }}</span>-->
                        <!--            </div>-->
                    </li>

                    <li class="info-item" v-if="projectId === '805'">
                        <div class="stages-container">
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-1"></span></span>Etapa 1</p>
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-2"></span></span>Etapa 2</p>
                            <p class="item-with-icon"><span class="icon-box"><span
                                    class="color-point stage-3"></span></span>Etapa 3</p>
                            <!--                            <p class="item-with-icon"><span class="icon-box"><span-->
                            <!--                                    class="color-point stage-4"></span></span>Etapa 4</p>-->
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="contact-info-container">
                            <h4>Visita nuestro piloto</h4>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/calendar-two-colors.svg'"
                                    alt=""></span>{{ currentProject.HORARIO_SEMANA }}
                            </p>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/location-icon-yellow.svg'"
                                    alt=""></span>{{ currentProject.DIRECCION }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="example-instruction-container">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/money-icon-dark.svg'"
                                    alt=""></span>¿Cómo cotizo?</h3>
                            <div class="instruction-content">
                                <img :src="publicPath + '/img/dynnamic-map-indication.png'" alt="">
                                <div>
                                    <h4>Selecciona desde el mapa tu nuevo hogar</h4>

                                    <p>Haz click sobre la ubicación de la casa que te interesa para conocer detalles y
                                        cotización</p>
                                </div>
                            </div>
                        </div>

                    </li>

                    <li class="info-item">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=http://esepe.cl/proyecto/casas-nuevas-en-puente-alto"
                           target="_blank" class="item-with-icon share-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/share-icon-dark.svg'" alt=""></span>Compartir este proyecto</a>
                    </li>
                </ul>
            </div>

        </div>

        <div v-if="isMobile()" class="fixed-project-info">
            <div class="project-name">
                <h1>PROYECTO <strong>{{ currentProject.PROYECTO }}</strong></h1>
                <span>{{ currentProject.COMUNA }}</span>
            </div>
            <p class="price-info item-with-icon"><span class="icon-box"><img
                    :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{
                minPrice(properties) |
                    currency('', 0, {thousandsSeparator: '.'})
                }}</p>

        </div>

        <template v-if="!loading">
            <div class="project-models" :class="{'show-project-models': showProjectModels}">
                <h3 class="filter-title d-sm-none">Filtra las casas que deseas ver</h3>
                <div class="container esepe-custom-container">
                    <div class="row esepe-row">

                        <div class="col-md-3">
                            <div class="model-item justify-content-md-center" @click="changeFilterSelected('all')"
                                 :class="{active: filterSelected === 'all'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <p>Todos los modelos</p>
                                <!--                <img class="model-icon-active" :src="publicPath + '/img/all-models-icon.svg'" alt="">-->
                                <!--                <img class="model-icon" :src="publicPath + '/img/all-models-icon-dark.svg'" alt="">-->
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('Calbuco-AV09')"
                                 :class="{active: filterSelected === 'Calbuco-AV09'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <div class="model-info">
                                    <span class="color-indicator model-Calbuco-AV09"></span>
                                    <div>
                                        <p>Casa Calbuco - <!-- {{ calbucoModelproperties.length }}  casas --> 74,71 mt2
                                            - 3d /
                                            2b</p>
                                        <h4>Desde UF {{
                                            minPrice(calbucoModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                                <!--                <img class="model-icon-active" :src="publicPath + '/img/house-icon-white.svg'" alt="">-->
                                <!--                <img class="model-icon" :src="publicPath + '/img/house-icon.svg'" alt="">-->
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('Osorno-AV07')"
                                 :class="{active: filterSelected === 'Osorno-AV07'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <div class="model-info">
                                    <span class="color-indicator model-Osorno-AV07"></span>
                                    <div>
                                        <p>Casa Osorno - <!-- {{ osornoModelproperties.length }} casas -->83,01 mt2 - 3d
                                            / 2b</p>
                                        <h4>Desde UF {{
                                            minPrice(osornoModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                                <!--                <img class="model-icon-active" :src="publicPath + '/img/apartment-icon-white.svg'" alt="">-->
                                <!--                <img class="model-icon" :src="publicPath + '/img/apartment-icon.svg'" alt="">-->
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('Lonquimay-AV03')"
                                 :class="{active: filterSelected === 'Lonquimay-AV03'}">
                                <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">
                                <div class="model-info">
                                    <span class="color-indicator model-Lonquimay-AV03"></span>
                                    <div>
                                        <p>Casa Lonquimay - <!--{{ lonquimayModelproperties.length }} casas-->90,24 mt2
                                            - 3d /
                                            3b</p>
                                        <h4>Desde UF {{
                                            minPrice(lonquimayModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                                <!--                <img class="model-icon-active" :src="publicPath + '/img/house-2-icon-white.svg'" alt="">-->
                                <!--                <img class="model-icon" :src="publicPath + '/img/house-2-icon.svg'" alt="">-->
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </template>

        <b-modal ref="instructionModal" hide-footer modal-class="guide-modal" id="guideModal">
            <div class="guide-modal-content">
                <div class="header-content">
                    <h3>IMPORTANTE</h3>
                    <img :src="publicPath + '/img/guide-img-av.png'" alt="">
                </div>
                <div class="footer-content">
                    <div class="d-flex align-items-center text-info">
                        <img :src="publicPath + '/img/alert-dark-icon.png'" alt="">
                        <p>Posicionando el cursor por encima de cada uno de los círculos
                            de colores de la vista, podrás acceder a más información sobre cada
                            una de las casas, así como también cotizarlas o
                            reservarlas en línea. <a href="/como-reservar-o-cotizar/">Más información</a></p>
                    </div>
                    <b-button v-b-toggle.collapseContent
                              class="button-call-action dark-btn"
                              block @click="$bvModal.hide('guideModal')">¡Entendido!
                    </b-button>

                </div>
            </div>
        </b-modal>
    </div>

  <!--projectId == '29928' Viña Carmen-->
    <div v-else-if="projectApiId == '3'" class="master-plan-page barrio-viña-carmen-project"
         :class="{'loading-view': loading}">
        <template v-if="loading">
            <div class="lds-loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </template>

        <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
            <div class="logo-container">
                <a href="/">
                    <img :src="publicPath + '/img/logo-header.png'" alt="">
                </a>

                <a class="filter-menu d-sm-none" @click.prevent="showProjectModels = !showProjectModels" href="#">Filtrar
                    casas
                    <img :src="publicPath + '/img/filter-icon.svg'" alt=""></a>
            </div>

        </div>

        <div class="master-plan-container" ref="masterPlanContainer" v-if="projectInfo">
            <img class="map-image" v-if="!isMobile()" :src="publicPath + '/img/master-bvc-map.jpg'" alt="">
            <img class="map-image" ref="defaultView" v-if="isMobile()" :src="publicPath + '/img/master-bvc-map.jpg'"
                 alt="">
            <!--        Desktop:-->
            <div class="points-container" v-if="!isMobile()">
                <template v-if="showUnavailableProperties">
                    <template v-for="property in bvcProperties">
                        <button :key="property.modelCode" :id="'sold_property_'+ property.modelCode"
                                class="color-indicator indicator-in-map sold-property"
                                :class="['property-'+ property.modelCode]"><span
                                class="circle-inner"></span></button>

                        <b-tooltip :key="'tooltip'+ property.modelCode" :target="'sold_property_'+ property.modelCode"
                                   tabindex="0" triggers="click blur">

                            <div class="property-info-tooltip sold-property-card">
                                <div class="image-container">
                                    <img :src="publicPath + '/img/vendido-buin.webp'"
                                         :alt="'Casa' + property.modelCode">
                                </div>
                                <div class="header-content">
                                    <div class="title">
                                        <h2 class="model-name">{{ property.modelCode }}</h2>
                                    </div>
                                    <div class="financing-info">
                                        <h4>CASA VENDIDA</h4>
                                    </div>
                                </div>
                            </div>
                        </b-tooltip>
                    </template>
                </template>

                <template v-for="property in filteredProperties">
                    <button :key="property.NRO_INMUEBLE" :id="'property_'+ property.NRO_INMUEBLE"
                            class="color-indicator indicator-in-map"
                            :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO ]"><span
                            class="circle-inner"></span></button>

                    <b-tooltip :key="'tooltip'+ property.NRO_INMUEBLE" :target="'property_'+ property.NRO_INMUEBLE"
                               tabindex="0" triggers="click blur">

                        <div class="property-info-tooltip">
                            <form :action="submitUrl" method="post">
                                <div class="inputs-container">
                                    <input type="hidden" name="nombreModelo" :value="property.MODELO">
                                    <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                    <input type="hidden" name="barrio" :value="property.BARRIO">
                                    <input type="hidden" name="etapa" :value="property.ETAPA">
                                    <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                    <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                    <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                    <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                    <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                    <input type="hidden" name="projectId" :value="projectId">
                                    <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                    <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                    <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                    <input type="hidden" name="valorAntesDescuentoUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                    <input type="hidden" name="valorAntesDescuentoPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">


                                    <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                    <input type="hidden" name="simu20precioUF"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20precioPesos"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20periodoCredito"
                                           :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu20montoPie"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20tasaInteres"
                                           :value="property.SIMULACION_20[1].TASA_INTERES">
                                    <input type="hidden" name="simu20valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                    <input type="hidden" name="simu25periodoCredito"
                                           :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu25tasaInteres"
                                           :value="property.SIMULACION_25[1].TASA_INTERES">
                                    <input type="hidden" name="simu25valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu25RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                    <input type="hidden" name="simu30periodoCredito"
                                           :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu30tasaInteres"
                                           :value="property.SIMULACION_30[1].TASA_INTERES">
                                    <input type="hidden" name="simu30valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu30RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                </div>

                                <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                    {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                </div>
                                <div class="image-container">
                                    <img :src="publicPath + '/img/' + getImagesName(property.MODELO)"
                                         :alt="'Casa' + property.MODELO">
                                </div>

                                <div class="header-content">
                                    <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                        <h2 class="model-name">Casa {{ property.MODELO }}</h2>
                                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</span>

                                        <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                            priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                        <h3 class="price" v-else>UF {{
                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                    </div>
                                    <!--                  <div class="financing-info">-->
                                    <!--                    <h4>Dividendo aprox. ${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                    <!--                      currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                    <!--                    <span>30 años / 20% de pie</span>-->
                                    <!--                  </div>-->
                                </div>

                                <div class="body-content">
                                    <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>,
                                        con un estacionamiento.</p>
                                    <!--                  <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>, orientación <span>{{ property.ORIENTACION }}</span>, con un estacionamiento.</p>-->

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="16.67" :src="publicPath + '/img/square-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_TOTAL }} m2</span>
                                        </div>
                                    </div>

                                    <p class="show-distribution-link">
                                        <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                        <a :href="'/modelo/?id=' + projectId + '&modelo=' + property.MODELO + '#modelDescription'"
                                           target="_blank">Ver distribución en Planta de la casa</a>
                                    </p>

                                    <div class="buttons-container buttons-w-48">
                                        <button type="submit"
                                                @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-yellow">Reservar en linea
                                        </button>
                                        <button type="submit"
                                                @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-outline">Cotizar
                                        </button>
                                    </div>

                                    <div class="terms-info">
                                        *Valores aproximados calculados en base a UF al día de hoy ( {{ dateToday }} ) y
                                        con un plazo de 25
                                        años, con crédito aprobado y 20% de pie.
                                    </div>
                                </div>
                            </form>
                        </div>
                    </b-tooltip>
                </template>
            </div>

            <!--      Mobile:-->
            <div class="points-container" v-else>

                <template v-if="showUnavailableProperties">
                    <template v-for="property in bvcProperties">
                        <button v-b-modal="'sold_property_'+ property.modelCode" :key="property.modelCode"
                                class="color-indicator indicator-in-map sold-property"
                                :class="['property-'+ property.modelCode]"><span
                                class="circle-inner"></span>
                        </button>

                        <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.modelCode"
                                 :id="'sold_property_'+ property.modelCode" hide-footer>

                            <b-button class="close custom-close back-button" block
                                      @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                <span>Volver</span>
                            </b-button>

                            <div class="property-info-tooltip sold-property-card">

                                <div class="image-container">
                                    <img :src="publicPath + '/img/vendido-buin.webp'"
                                         :alt="'Casa' + property.modelCode">
                                </div>

                                <div class="header-content">
                                    <div class="title">
                                        <h2 class="model-name">{{ property.modelCode }}</h2>
                                    </div>
                                    <div class="financing-info">
                                        <h4>CASA VENDIDA</h4>
                                    </div>
                                </div>

                            </div>
                        </b-modal>
                    </template>
                </template>

                <template v-for="property in filteredProperties">
                    <button v-b-modal="'property_'+ property.NRO_INMUEBLE" :key="property.NRO_INMUEBLE"
                            class="color-indicator indicator-in-map"
                            :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO ]"><span
                            class="circle-inner"></span>
                    </button>

                    <b-modal modal-class="model-info-Modal" :key="'tooltip'+ property.NRO_INMUEBLE"
                             :id="'property_'+ property.NRO_INMUEBLE" hide-footer>

                        <b-button class="close custom-close back-button" block
                                  @click="$bvModal.hide('property_'+ property.NRO_INMUEBLE)">
                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                            <span>Volver</span>
                        </b-button>

                        <div class="property-info-tooltip">
                            <form :action="submitUrl" method="post">
                                <div class="inputs-container">
                                    <input type="hidden" name="nombreModelo" :value="property.MODELO">
                                    <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                    <input type="hidden" name="barrio" :value="property.BARRIO">
                                    <input type="hidden" name="etapa" :value="property.ETAPA">
                                    <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                    <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                    <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                    <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                    <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                    <input type="hidden" name="projectId" :value="projectId">
                                    <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                    <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                    <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                    <input type="hidden" name="valorAntesDescuentoUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioUF"
                                           :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                    <input type="hidden" name="valorAntesDescuentoPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                    <input type="hidden" name="originalPrecioPesos"
                                           :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">


                                    <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                    <input type="hidden" name="simu20precioUF"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20precioPesos"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20periodoCredito"
                                           :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu20montoPie"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20tasaInteres"
                                           :value="property.SIMULACION_20[1].TASA_INTERES">
                                    <input type="hidden" name="simu20valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu20RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                    <input type="hidden" name="simu25periodoCredito"
                                           :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu25tasaInteres"
                                           :value="property.SIMULACION_25[1].TASA_INTERES">
                                    <input type="hidden" name="simu25valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu25RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                    <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                    <input type="hidden" name="simu30periodoCredito"
                                           :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                    <input type="hidden" name="simu30tasaInteres"
                                           :value="property.SIMULACION_30[1].TASA_INTERES">
                                    <input type="hidden" name="simu30valorDividendo"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                    <input type="hidden" name="simu30RentaAcreditable"
                                           :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                </div>

                                <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                    {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                </div>

                                <div class="image-container">
                                    <img :src="publicPath + '/img/' + getImagesName(property.MODELO)"
                                         :alt="'Casa' + property.MODELO">
                                </div>

                                <div class="header-content">
                                    <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                        <h2 class="model-name">Casa {{ property.MODELO }}</h2>
                                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</span>

                                        <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                            priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                        <h3 class="price" v-else>UF {{
                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                currency('', 0, {thousandsSeparator: '.'})
                                            }}</h3>
                                    </div>
                                    <!--                  <div class="financing-info">-->
                                    <!--                    <h4>Dividendo aprox. <br>${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                    <!--                      currency('', 0, { thousandsSeparator: '.' })}}*</h4>-->
                                    <!--                    <span>30 años / 20% de pie</span>-->
                                    <!--                  </div>-->
                                </div>

                                <div class="body-content">
                                    <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>,
                                        con un estacionamiento.</p>
                                    <!--                  <p>Casa {{ property.NRO_INMUEBLE }} de la Etapa <span>{{ property.ETAPA }}</span>, orientación <span>{{ property.ORIENTACION }}</span>, con un estacionamiento.</p>-->

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="16.67" :src="publicPath + '/img/square-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_TOTAL }} m2</span>
                                        </div>
                                    </div>

                                    <p class="show-distribution-link border-gray-bottom">
                                        <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                        <a :href="'/modelo/?id=' + projectId + '&modelo=' + property.MODELO  + '#modelDescription'"
                                           target="_blank">Ver distribución en Planta de la casa</a>
                                    </p>

                                    <div class="buttons-container buttons-w-48">
                                        <button type="submit"
                                                @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-yellow">Reservar en linea
                                        </button>
                                        <button type="submit"
                                                @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                class="button-call-action button-outline">Cotizar
                                        </button>
                                    </div>

                                    <div class="terms-info">
                                        *Valores aproximados calculados en base a UF al día de hoy ( {{ dateToday }} ) y
                                        con un plazo de 25
                                        años, con crédito aprobado y 20% de pie.
                                    </div>
                                </div>
                            </form>
                        </div>
                    </b-modal>
                </template>
            </div>

            <div class="project-info-sidebar desktop-sidebar">
                <div class="logo-container">
                    <a href="/">
                        <img :src="publicPath + '/img/logo-header.png'" alt="">
                    </a>
                </div>
                <ul class="info-items-container">
                    <li class="info-item">
                        <div class="project-info-title">
                            <h2>PROYECTO</h2>
                            <h1>{{ currentProject.PROYECTO }}</h1>
                            <span>{{ currentProject.COMUNA }}</span>

                            <p class="price-info item-with-icon">
                                <span class="icon-box"><img :src="publicPath + '/img/security-icon-dark.svg'"
                                                            alt=""></span>Desde UF {{
                                minPrice(properties) | currency('', 0, {thousandsSeparator: '.'})
                                }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="property-counter-item">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/house-icon.svg'"
                                    alt=""></span>Casas disponibles</h3>
                            <span><strong>{{ properties.length }}</strong></span>
                        </div>

                        <!--            <div class="property-counter-item">-->
                        <!--              <p class="item-with-icon">Casas totales</p>-->
                        <!--              <span>{{ currentProject.NRO_INMUEBLES }}</span>-->
                        <!--            </div>-->
                    </li>

                    <li class="info-item">
                        <div class="stages-container">
                            <p class="item-with-icon"><span class="icon-box"><span style="background: #DE6F58;"
                                                                                   class="color-point stage-1"></span></span>Etapa
                                1
                            </p>

                            <p class="item-with-icon"><span class="icon-box"><span style="background: #8AB953;"
                                                                                   class="color-point stage-2"></span></span>Etapa
                                2
                            </p>

                            <p class="item-with-icon"><span class="icon-box"><span style="background: #A491E1;"
                                                                                   class="color-point stage-3"></span></span>Etapa
                                3</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="contact-info-container">
                            <h4>Visita nuestro piloto</h4>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/calendar-two-colors.svg'"
                                    alt=""></span>{{ currentProject.HORARIO_SEMANA }}
                            </p>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/location-icon-yellow.svg'"
                                    alt=""></span>{{ currentProject.DIRECCION }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="example-instruction-container">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/money-icon-dark.svg'"
                                    alt=""></span>¿Cómo cotizo?</h3>
                            <div class="instruction-content">
                                <img :src="publicPath + '/img/dynnamic-map-indication.png'" alt="">
                                <div>
                                    <h4>Selecciona desde el mapa tu nuevo hogar</h4>

                                    <p>Haz click sobre la ubicación de la casa que te interesa para conocer detalles y
                                        cotización</p>
                                </div>
                            </div>
                        </div>

                    </li>

                    <li class="info-item">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=http://esepe.cl/proyecto/casas-nuevas-en-buin"
                           target="_blank"
                           class="item-with-icon share-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/share-icon-dark.svg'" alt=""></span>Compartir este proyecto</a>
                    </li>
                </ul>
            </div>

        </div>

        <div v-if="isMobile()" class="fixed-project-info">
            <div class="project-name">
                <h1>PROYECTO <strong>{{ currentProject.PROYECTO }}</strong></h1>
                <span>{{ currentProject.COMUNA }}</span>
            </div>
            <p class="price-info item-with-icon"><span class="icon-box"><img
                    :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{
                minPrice(properties) |
                    currency('', 0, {thousandsSeparator: '.'})
                }}</p>


        </div>

        <template v-if="!loading">
            <div class="project-models" v-if="projectInfo" :class="{'show-project-models': showProjectModels}">
                <h3 class="filter-title d-sm-none">Filtra las casas que deseas ver</h3>
                <div class="container esepe-custom-container">
                    <div class="row esepe-row">

                        <div class="col-md-3">
                            <div class="model-item justify-content-md-center" @click="changeFilterSelected('all')"
                                 :class="{active: filterSelected === 'all'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <p>Todos los modelos</p>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('Barreno')"
                                 :class="{active: filterSelected === 'Barreno'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <div class="model-info">
                                    <span class="color-indicator model-Barreno"></span>
                                    <div>
                                        <p>Casa Barreno - {{ barrenoModelproperties.length }} casas 55,18 m2 - 3d /
                                            1b</p>
                                        <h4>Desde UF {{
                                            minPrice(barrenoModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('Legón')"
                                 :class="{active: filterSelected === 'Legón'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <div class="model-info">
                                    <span class="color-indicator model-Legón"></span>
                                    <div>
                                        <p>Casa Legón - {{ legonModelproperties.length }} casas 65,45 mt2 - 3d / 2b</p>
                                        <h4>Desde UF {{
                                            minPrice(legonModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="model-item" @click="changeFilterSelected('Mayal')"
                                 :class="{active: filterSelected === 'Mayal'}">
                                <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">
                                <div class="model-info">
                                    <span class="color-indicator model-Mayal"></span>
                                    <div>
                                        <p>Casa Mayal - {{ mayalModelproperties.length }} casas 72,59 mt2 - 3d / 2b</p>
                                        <h4>Desde UF {{
                                            minPrice(mayalModelproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </template>

        <b-modal ref="instructionModal" hide-footer modal-class="guide-modal" id="guideModal">
            <div class="guide-modal-content">
                <div class="header-content">
                    <h3>IMPORTANTE</h3>
                    <img :src="publicPath + '/img/master-bvc-guia.jpg'" alt="">
                </div>
                <div class="footer-content">
                    <div class="d-flex align-items-center text-info">
                        <img :src="publicPath + '/img/alert-dark-icon.png'" alt="">
                        <p>Posicionando el cursor por encima de cada uno de los círculos
                            de colores de la vista, podrás acceder a más información sobre cada
                            una de las casas, así como también cotizarlas o
                            reservarlas en línea. <a href="/como-reservar-o-cotizar/">Más información</a></p>
                    </div>
                    <b-button v-b-toggle.collapseContent
                              class="button-call-action dark-btn"
                              block @click="$bvModal.hide('guideModal')">¡Entendido!
                    </b-button>

                </div>
            </div>
        </b-modal>
    </div>

  <!--projectId == '29238' Matta sur-->
    <div v-else-if="projectApiId == '29238'" class="master-plan-page matta-sur-project"
         :class="{'loading-view': loading, 'default-view': floorSelected !== 'Selecciona el piso a revisar'}">

        <template v-if="loading">
            <div class="lds-loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </template>

        <template v-if="floorSelected !== 'Selecciona el piso a revisar'">
            <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
                <div class="logo-container">
                    <a href="/">
                        <img :src="publicPath + '/img/logo-header.png'" alt="">
                    </a>

                    <a class="filter-menu d-sm-none" @click.prevent="showProjectModels = !showProjectModels" href="#">Filtrar
                        Deptos.
                        <img :src="publicPath + '/img/filter-icon.svg'" alt=""></a>
                </div>
            </div>
        </template>

        <div class="master-plan-container" ref="masterPlanContainer"
             :class="{'matta-sur-default-view': floorSelected === 'Selecciona el piso a revisar'}" v-if="projectInfo">
            <div v-if="floorSelected === 'Selecciona el piso a revisar'" class="matta-sur-default">
                <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
                    <div class="logo-container">
                        <a href="/">
                            <img :src="publicPath + '/img/logo-header.png'" alt="">
                        </a>
                    </div>
                </div>
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/matta-portada.png'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/matta-portada.png'" alt="">
                </template>
            </div>

            <template v-if="floorSelected === 'Zócalo - Piso -1'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/planta-1-piso.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/planta-1-piso.jpg'" alt="">
                </template>
            </template>

            <template v-if="floorSelected === 'Piso 1'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/planta-1-sub.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/planta-1-sub.jpg'" alt="">
                </template>

            </template>

            <template v-if="floorSelected === 'Piso 2'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/planta-2-piso.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/planta-2-piso.jpg'" alt="">
                </template>

            </template>

            <template v-if="floorSelected === 'Piso 3'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/planta-2-sub.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/planta-2-sub.jpg'" alt="">
                </template>
            </template>

            <template v-if="floorSelected === 'Piso 4'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/planta-2-5.png'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/planta-2-5.png'" alt="">
                </template>
            </template>

            <template v-if="floorSelected === 'Piso 5'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/planta-2-5.png'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/planta-2-5.png'" alt="">
                </template>
            </template>

            <template v-if="floorSelected !== 'Selecciona el piso a revisar'">
                <!--        Desktop points-->
                <div class="points-container" v-if="!isMobile()">
                    <template v-if="showUnavailableProperties">
                        <template v-if="floorSelected === 'Zócalo - Piso -1'">
                            <template v-for="property in mattaSurFloor0">
                                <button :id="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        @click="deleteParking()"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode" tabindex="0" triggers="click">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 1'">
                            <template v-for="property in mattaSurFloor1">
                                <button :id="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 2'">
                            <template v-for="property in mattaSurFloor2">
                                <button :id="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 3'">
                            <template v-for="property in mattaSurFloor3">
                                <button :id="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 4'">
                            <template v-for="property in mattaSurFloor4">
                                <button :id="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 5'">
                            <template v-for="property in mattaSurFloor5">
                                <button :id="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>
                    </template>

                    <template v-for="(property, index) in filteredApartments">
                        <button :key="property.NRO_INMUEBLE" :id="'property_'+ property.NRO_INMUEBLE"
                                class="color-indicator indicator-in-map" @click="deleteParking()"
                                :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO.toLowerCase().replace(/ /g, '-') ]"><span
                                class="circle-inner"></span></button>

                        <b-tooltip tabindex="0" :key="'tooltip'+ property.NRO_INMUEBLE"
                                   :target="'property_'+ property.NRO_INMUEBLE">

                            <div class="property-info-tooltip">
                                <form :action="submitUrl" method="post">
                                    <div class="inputs-container">
                                        <input type="hidden" name="nombreModelo" :value="getModelName(property.MODELO)">
                                        <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                        <input type="hidden" name="barrio" :value="property.BARRIO">
                                        <input type="hidden" name="etapa" :value="property.ETAPA">
                                        <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                        <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                        <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                        <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                        <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                        <input type="hidden" name="projectId" :value="projectId">
                                        <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                        <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                        <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                        <input type="hidden" name="valorAntesDescuentoUF"
                                               :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                        <input type="hidden" name="originalPrecioUF"
                                               :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                        <input type="hidden" name="valorAntesDescuentoPesos"
                                               :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                        <input type="hidden" name="originalPrecioPesos"
                                               :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">

                                        <input type="hidden" name="precioConEstacionamiento"
                                               :value="apartmentTotalPrice  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="precioConEstacionamientoPesos"
                                               :value="apartmentTotalPricePesos  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="precioConEstacionamientoPesos"
                                               :value="apartmentTotalPricePesos  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="numEstacionamiento"
                                               :value="parkingSelected">
                                        <input type="hidden" name="precioEstacionaiento"
                                               :value="parkingSelectedPrice  | currency('', 0, { thousandsSeparator: '.' })">

                                        <input type="hidden" name="tipoEstacionamiento" :value="parkingTypeSelected">
                                        <input type="hidden" name="EstacionamientiId" :value="parkingId">

                                        <input v-if="apartmentTotalPricePesos !== null" type="hidden"
                                               name="precioEstacionamientoPesos"
                                               :value="parkingPricePesos(priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE)) | currency('', 0, { thousandsSeparator: '.' })">

                                        <input type="hidden" name="montoPieConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].VALOR_DIVIDENDO  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <input type="hidden" name="montoPieConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].VALOR_DIVIDENDO  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <!--                        SIMULATION 30:-->
                                        <input type="hidden" name="montoPieConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento"
                                               :value="dividendoTotalPrice | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                        <input type="hidden" name="simu20precioUF"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE)  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20precioPesos"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20periodoCredito"
                                               :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu20montoPie"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20tasaInteres"
                                               :value="property.SIMULACION_20[1].TASA_INTERES">
                                        <input type="hidden" name="simu20valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                        <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                        <input type="hidden" name="simu25periodoCredito"
                                               :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu25tasaInteres"
                                               :value="property.SIMULACION_25[1].TASA_INTERES">
                                        <input type="hidden" name="simu25valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu25RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                        <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                        <input type="hidden" name="simu30periodoCredito"
                                               :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu30tasaInteres"
                                               :value="property.SIMULACION_30[1].TASA_INTERES">
                                        <input type="hidden" name="simu30valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu30RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    </div>
                                    <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                        {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                    </div>
                                    <div class="image-container">
                                        <img :src="publicPath + '/img/' + getImagesName(property.MODELO.toLowerCase().replace(/ /g, '-'))"
                                             :alt="'Depto. ' + property.MODELO.toLowerCase().replace(/ /g, '-')">
                                    </div>

                                    <div class="header-content d-block" v-if="apartmentTotalPrice !== null">
                                        <p class="mb-0"><strong>Costo total</strong></p>
                                        <div class="d-flex align-items-center justify-content-between mb-3">
                                            <div class="title"
                                                 :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                          <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                              priceFromApiFormatter(property.PRECIO_LISTA) |
                                  currency('', 0, {thousandsSeparator: '.'})
                              }}</span>

                                                <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF
                                                    {{
                                                    priceFromApiFormatter(property.PRECIO_DESCUENTO) + parseInt(parkingSelectedPrice) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</h3>

                                                <h3 class="price" v-else>UF {{
                                                    apartmentTotalPrice | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</h3>

                                                <div style="margin-top: 10px;">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <p class="mb-0" style="font-size: 12px; line-height: 13px;">
                                                            <strong>DEPARTAMENTO {{ property.NRO_INMUEBLE }}</strong>
                                                        </p>
                                                        <h3 class="price"
                                                            style="line-height: 17px; margin-bottom: 0; font-size: 14px;margin-left: 8px;">
                                                            UF {{
                                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                                currency('', 0, {thousandsSeparator: '.'})
                                                            }}</h3>
                                                    </div>

                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <p class="mb-0" style="font-size: 12px; line-height: 13px;">
                                                            <strong>ESTACIONAMIENTO {{ parkingSelected }}</strong></p>
                                                        <h3 class="price text-uppercase"
                                                            style="line-height: 17px; margin-bottom: 0; font-size: 14px;margin-left: 8px;">
                                                            UF {{
                                                            parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                            }}</h3>
                                                    </div>
                                                </div>


                                                <!--                        <h3 class="price" v-else >UF {{ priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |-->
                                                <!--                          currency('', 0, { thousandsSeparator: '.' }) }}</h3>-->
                                            </div>
                                            <!--                      <div class="financing-info">-->

                                            <!--                      </div>-->

                                        </div>

                                        <!--                    <h4>Dividendo aprox. ${{ dividendoTotalPrice |-->
                                        <!--                      currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                        <!--                    <span>30 años / 20% de pie</span>-->
                                    </div>

                                    <div class="header-content" v-else>

                                        <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                            <h2 class="model-name">Depto. {{ property.MODELO }}</h2>
                                            <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                                priceFromApiFormatter(property.PRECIO_LISTA) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</span>

                                            <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                                priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</h3>
                                            <h3 class="price" v-else>UF {{
                                                priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</h3>
                                        </div>


                                        <!--                    <div class="financing-info">-->
                                        <!--                      <h4>Dividendo aprox. ${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                        <!--                        currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                        <!--                      <span>30 años / 20% de pie</span>-->
                                        <!--                    </div>-->
                                    </div>

                                    <div class="body-content">
                                        <p v-if="floorSelected === 'Zócalo - Piso -1'">Departamento
                                            {{ property.NRO_INMUEBLE }}, orientación <span>{{
                                              property.ORIENTACION
                                                }}</span>, incluye patio</p>
                                        <p v-else>Departamento {{ property.NRO_INMUEBLE }}, orientación
                                            <span>{{ property.ORIENTACION }}</span></p>

                                        <div class="house-specs">
                                            <div class="spec-item">
                                                <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                                <span>{{ property.PROGRAMA[0] }} hab.</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                                <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                                <span>{{ property.PROGRAMA[3] }} baños</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                                <a class="show-distribution-modal" href="#"
                                                   v-b-modal="index + 'apartmentInfo' + property.NRO_INMUEBLE">Ver
                                                    planta y
                                                    distrib.</a>
                                            </div>
                                        </div>

                                        <div class="parking-select-container">
                                            <p class="mb-0"><strong>Adicionales</strong></p>
                                            <div v-if="!showParkingSelect" class="add-parking mb-3">
                                                <p class="mb-0">No tienes seleccionado ningun adicional como
                                                    estacionamiento</p>
                                                <a href="#" @click.prevent="addParking()"><img class="icon-arrow"
                                                                                               :src="publicPath + '/img/add-more-icon.png'"
                                                                                               alt=""> Agregar
                                                    estacionamiento</a>
                                            </div>

                                            <template v-if="showParkingSelect">
                                                <template v-if="!showParkingSelected">
                                                    <div class="parking-select">
                                                        <div class="mattasur-custom-select parking-type-select">
                                                            <a href="#" class="ms-option-selected"
                                                               @click.prevent="parkingTypeSelectOpen = !parkingTypeSelectOpen">
                                                                <p class="option-title">
                                                                    {{ parkingTypeSelected }}
                                                                </p>

                                                                <img class="icon-arrow"
                                                                     :src="publicPath + '/img/collapse-arrow-down.png'"
                                                                     alt="">
                                                            </a>

                                                            <ul class="ms-options-list" v-if="parkingTypeSelectOpen">
                                                                <li>
                                                                    <a href="#"
                                                                       @click.prevent="selectparkingType('Cubierto')">
                                                                        <p class="option-title">Cubierto</p>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="#"
                                                                       @click.prevent="selectparkingType('Descubierto')">
                                                                        <p class="option-title">Descubierto</p>
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                        </div>

                                                        <div class="mattasur-custom-select parking-list-select"
                                                             v-if="parkingTypeSelected !== 'Seleccionar'">
                                                            <a href="#" class="ms-option-selected"
                                                               @click.prevent="parkingSelectOpen = !parkingSelectOpen">
                                                                <p class="option-title">
                                                                    <strong>{{ parkingSelected }} <span
                                                                            class="text-uppercase"
                                                                            v-if="parkingSelected !== 'Seleccionar'">- UF {{
                                                                        parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                                        }}</span></strong>
                                                                </p>

                                                                <img class="icon-arrow"
                                                                     :src="publicPath + '/img/collapse-arrow-down.png'"
                                                                     alt="">
                                                            </a>

                                                            <ul class="ms-options-list" v-if="parkingSelectOpen">
                                                                <li v-for="parking in filteredParkingsList">
                                                                    <a href="#"
                                                                       @click.prevent="selectparking(parking.NRO_ESTACIONAMIENTO, parking.PRECIO_LISTA, parking.ID_ESTACIONAMIENTO)">
                                                                        <p class="option-title">
                                                                            <strong>{{ parking.NRO_ESTACIONAMIENTO }} -
                                                                                UF {{
                                                                                parking.PRECIO_LISTA |
                                                                                    currency('', 0, {thousandsSeparator: '.'})
                                                                                }}</strong>
                                                                        </p>
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                        </div>
                                                    </div>

                                                    <h4 class="parking-price-value"
                                                        v-if="parkingSelected !== 'Seleccionar'">Valor {{
                                                        parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                        }} UF</h4>

                                                    <div class="buttons-container add-parking-button-container">
                                                        <template v-if="showAddParkingLoader">
                                                            <div class="lds-loader">
                                                                <div style="background:#000;"></div>
                                                                <div style="background: #000;"></div>
                                                                <div style="background: #000;"></div>
                                                            </div>
                                                        </template>

                                                        <a href="#" v-else
                                                           @click.prevent="showParkingSelectedInfo(property.ID_INMUEBLE)"
                                                           :class="{disabled: parkingSelected === 'Seleccionar'}"
                                                           class="button-call-action button-yellow add-parking-button">Continuar</a>
                                                        <!--<a href="#" class="button-call-action button-outline">Reservar ahora</a>-->
                                                    </div>
                                                </template>

                                                <p v-if="showParkingSelected"><strong>Estacionamiento:</strong>
                                                    {{ parkingTypeSelected }} {{
                                                    parkingSelected
                                                    }}
                                                    <a href="#" @click.prevent="deleteParking()"><img
                                                            :src="publicPath + '/img/trash-icon.png'" alt=""></a></p>
                                            </template>
                                        </div>

                                        <template v-if="showQuoteButton">
                                            <div class="buttons-container buttons-w-48">
                                                <button type="submit"
                                                        @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                        class="button-call-action button-yellow">Reservar en linea
                                                </button>
                                                <button type="submit"
                                                        @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                        class="button-call-action button-outline">Cotizar
                                                </button>
                                            </div>

                                            <div class="terms-info">
                                                *Valores aproximados calculados en base a UF al día de hoy (
                                                {{ dateToday }} ) y con un plazo de 25
                                                años, con crédito aprobado y 20% de pie.
                                            </div>
                                        </template>
                                    </div>
                                </form>

                            </div>
                        </b-tooltip>

                        <b-modal modal-class="model-info-Modal distribution-apartment-modal"
                                 :id="index + 'apartmentInfo' + property.NRO_INMUEBLE" hide-footer>
                            <b-button class="close custom-close" block
                                      @click="$bvModal.hide(index + 'apartmentInfo' + property.NRO_INMUEBLE)">
                                <img :src="publicPath + '/img/close-icon.png'" alt="">
                            </b-button>
                            <div class="apartment-info-modal">
                                <div class="title-and-specs-info">
                                    <div class="title-continer">
                                        <p><strong>Departamento {{ property.NRO_INMUEBLE }}</strong></p>
                                        <p>
                                            <strong>UF {{
                                                priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}
                                            </strong>
                                        </p>
                                    </div>

                                    <div class="house-specs">
                                        <div class="spec-item">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="description">
                                    <p>Departamento {{ property.PROGRAMA[0] }} dormitorios, Orientación {{
                                        property.ORIENTACION
                                        }}, Numeración {{ property.NRO_INMUEBLE }}, Opcional
                                        estacionamiento.</p>
                                </div>

                                <img class="modal-image"
                                     :src="publicPath + '/img/' + getImagesName(property.MODELO.toLowerCase().replace(/ /g, '-'))"
                                     :alt="'Depto. ' + property.MODELO.toLowerCase().replace(/ /g, '-')">
                            </div>
                        </b-modal>
                    </template>
                </div>

                <!--        mobile points-->
                <div ref="pointsContainer" class="points-container" v-else>
                    <template v-if="showUnavailableProperties">
                        <template v-if="floorSelected === 'Zócalo - Piso -1'">
                            <template v-for="property in mattaSurFloor0">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        @click="deleteParking()"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 1'">
                            <template v-for="property in mattaSurFloor1">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 2'">
                            <template v-for="property in mattaSurFloor2">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 3'">
                            <template v-for="property in mattaSurFloor3">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 4'">
                            <template v-for="property in mattaSurFloor4">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === 'Piso 5'">
                            <template v-for="property in mattaSurFloor5">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-ms.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                    </template>

                    <template v-for="property in filteredApartments">
                        <button v-b-modal="'property_'+ property.NRO_INMUEBLE" :key="property.NRO_INMUEBLE"
                                @click="deleteParking()"
                                class="color-indicator indicator-in-map"
                                :class="['property-'+ property.NRO_INMUEBLE, 'model-'+ property.MODELO.toLowerCase().replace(/ /g, '-') ]"><span
                                class="circle-inner"></span>
                        </button>

                        <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                 :key="'tooltip'+ property.NRO_INMUEBLE"
                                 :id="'property_'+ property.NRO_INMUEBLE" hide-footer>
                            <div class="property-info-tooltip">
                                <form :action="submitUrl" method="post">
                                    <div class="inputs-container">
                                        <input type="hidden" name="nombreModelo" :value="getModelName(property.MODELO)">
                                        <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                        <input type="hidden" name="barrio" :value="property.BARRIO">
                                        <input type="hidden" name="etapa" :value="property.ETAPA">
                                        <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                        <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                        <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                        <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                        <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                        <input type="hidden" name="projectId" :value="projectId">
                                        <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                        <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                        <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                        <input type="hidden" name="valorAntesDescuentoUF"
                                               :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                        <input type="hidden" name="originalPrecioUF"
                                               :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                        <input type="hidden" name="valorAntesDescuentoPesos"
                                               :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                        <input type="hidden" name="originalPrecioPesos"
                                               :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">

                                        <input type="hidden" name="precioConEstacionamiento"
                                               :value="apartmentTotalPrice  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="precioConEstacionamientoPesos"
                                               :value="apartmentTotalPricePesos  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="precioConEstacionamientoPesos"
                                               :value="apartmentTotalPricePesos  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="numEstacionamiento"
                                               :value="parkingSelected">
                                        <input type="hidden" name="precioEstacionaiento"
                                               :value="parkingSelectedPrice  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input v-if="apartmentTotalPricePesos !== null" type="hidden"
                                               name="precioEstacionamientoPesos"
                                               :value="parkingPricePesos(priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE)) | currency('', 0, { thousandsSeparator: '.' })">

                                        <input type="hidden" name="tipoEstacionamiento"
                                               :value="parkingTypeSelected">
                                        <input type="hidden" name="EstacionamientiId"
                                               :value="parkingId">

                                        <input type="hidden" name="montoPieConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].VALOR_DIVIDENDO  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <input type="hidden" name="montoPieConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].VALOR_DIVIDENDO  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <!--                        SIMULATION 30:-->
                                        <input type="hidden" name="montoPieConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento"
                                               :value="dividendoTotalPrice | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                        <input type="hidden" name="simu20precioUF"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE)  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20precioPesos"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20periodoCredito"
                                               :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu20montoPie"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20tasaInteres"
                                               :value="property.SIMULACION_20[1].TASA_INTERES">
                                        <input type="hidden" name="simu20valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                        <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                        <input type="hidden" name="simu25periodoCredito"
                                               :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu25tasaInteres"
                                               :value="property.SIMULACION_25[1].TASA_INTERES">
                                        <input type="hidden" name="simu25valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu25RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                        <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                        <input type="hidden" name="simu30periodoCredito"
                                               :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu30tasaInteres"
                                               :value="property.SIMULACION_30[1].TASA_INTERES">
                                        <input type="hidden" name="simu30valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu30RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    </div>

                                    <b-button class="close custom-close back-button" block
                                              @click="$bvModal.hide('property_'+ property.NRO_INMUEBLE)">
                                        <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                        <span>Volver</span>
                                    </b-button>

                                    <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                        {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                    </div>

                                    <div class="image-container">
                                        <img :src="publicPath + '/img/' + getImagesName(property.MODELO.toLowerCase().replace(/ /g, '-'))"
                                             :alt="'Depto. ' + property.MODELO.toLowerCase().replace(/ /g, '-')">
                                    </div>

                                    <div class="header-content d-block" v-if="apartmentTotalPrice !== null">
                                        <p class="mb-0"><strong>Costo total</strong></p>
                                        <div class="mb-3">
                                            <div class="title"
                                                 :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                currency('', 0, {thousandsSeparator: '.'})
                            }}</span>

                                                <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF
                                                    {{
                                                    priceFromApiFormatter(property.PRECIO_DESCUENTO) + parseInt(parkingSelectedPrice) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</h3>

                                                <h3 class="price" v-else>UF {{
                                                    apartmentTotalPrice | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</h3>

                                                <div class="financing-info w-100 mt-4">
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <p class="mb-0 mr-4"
                                                                   style="font-size: 12px; line-height: 13px;"><strong>DEPARTAMENTO
                                                                    {{ property.NRO_INMUEBLE }}</strong></p>
                                                            </td>
                                                            <td>
                                                                <h3 class="price"
                                                                    style="line-height: 17px; margin-bottom: 0; font-size: 14px; margin-left: 8px;">
                                                                    UF {{
                                                                    priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                                        currency('', 0, {thousandsSeparator: '.'})
                                                                    }}</h3>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <p class="mb-0 mr-4"
                                                                   style="font-size: 12px; line-height: 13px;"><strong>ESTACIONAMIENTO
                                                                    {{ parkingSelected }}</strong></p>
                                                            </td>
                                                            <td>
                                                                <h3 class="price text-uppercase"
                                                                    style="line-height: 17px; margin-bottom: 0; font-size: 14px; margin-left: 8px;">
                                                                    UF {{
                                                                    parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                                    }}</h3>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>

                                            </div>


                                        </div>

                                        <!--                    <h4>Dividendo aprox. <br>${{ dividendoTotalPrice | currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                        <!--                    <span>30 años / 20% de pie</span>-->
                                    </div>

                                    <div class="header-content" v-else>

                                        <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                            <h2 class="model-name">Depto. {{ property.MODELO }}</h2>
                                            <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                                priceFromApiFormatter(property.PRECIO_LISTA) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</span>

                                            <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                                priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</h3>
                                            <h3 class="price" v-else>UF {{
                                                priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</h3>
                                        </div>


                                        <!--                    <div class="financing-info">-->
                                        <!--                      <h4>Dividendo aprox. ${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                        <!--                        currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                        <!--                      <span>30 años / 20% de pie</span>-->
                                        <!--                    </div>-->
                                    </div>

                                    <div class="body-content">
                                        <p v-if="floorSelected === 'Zócalo - Piso -1'">Departamento
                                            {{ property.NRO_INMUEBLE }}, orientación <span>{{
                                              property.ORIENTACION
                                                }}</span>, incluye patio</p>
                                        <p v-else>Departamento {{ property.NRO_INMUEBLE }}, orientación
                                            <span>{{ property.ORIENTACION }}</span></p>

                                        <div class="house-specs border-gray-bottom">
                                            <div class="spec-item">
                                                <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                                <span>{{ property.PROGRAMA[0] }} hab.</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                                <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                                <span>{{ property.PROGRAMA[3] }} baños</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                                <a class="show-distribution-modal" href="#"
                                                   v-b-modal="'apartmentInfo' + property.NRO_INMUEBLE">Ver planta y
                                                    distrib.</a>

                                                <b-modal modal-class="model-info-Modal distribution-apartment-modal"
                                                         :id="'apartmentInfo' + property.NRO_INMUEBLE" hide-footer>
                                                    <b-button class="close custom-close" block
                                                              @click="$bvModal.hide('apartmentInfo' + property.NRO_INMUEBLE)">
                                                        <img :src="publicPath + '/img/close-icon.png'" alt="">
                                                    </b-button>
                                                    <div class="apartment-info-modal">
                                                        <div class="title-and-specs-info">
                                                            <div class="title-continer">
                                                                <p><strong>Departamento {{
                                                                    property.NRO_INMUEBLE
                                                                    }}</strong></p>
                                                                <p>
                                                                    <strong>UF {{
                                                                        priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                                            currency('', 0, {thousandsSeparator: '.'})
                                                                        }}
                                                                    </strong>
                                                                </p>
                                                            </div>

                                                            <div class="house-specs">
                                                                <div class="spec-item">
                                                                    <img width="23" :src="publicPath + '/img/bed.svg'"
                                                                         alt="">
                                                                    <span>{{ property.PROGRAMA[0] }} hab.</span>
                                                                </div>

                                                                <div class="spec-item">
                                                                    <img width="17.2"
                                                                         :src="publicPath + '/img/dimensions-icon.svg'"
                                                                         alt="">
                                                                    <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                                                </div>

                                                                <div class="spec-item">
                                                                    <img width="15"
                                                                         :src="publicPath + '/img/bathroom-icon.svg'"
                                                                         alt="">
                                                                    <span>{{ property.PROGRAMA[3] }} baños</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="description">
                                                            <p>Departamento {{ property.PROGRAMA[0] }} dormitorios,
                                                                Orientación {{
                                                                property.ORIENTACION
                                                                }}, Numeración {{ property.NRO_INMUEBLE }}, Opcional
                                                                estacionamiento.</p>
                                                        </div>

                                                        <img class="modal-image"
                                                             :src="publicPath + '/img/' + getImagesName(property.MODELO.toLowerCase().replace(/ /g, '-'))"
                                                             :alt="'Depto. ' + property.MODELO.toLowerCase().replace(/ /g, '-')">
                                                    </div>
                                                </b-modal>
                                            </div>
                                        </div>

                                        <div class="parking-select-container">
                                            <p class="mb-0"><strong>Adicionales</strong></p>
                                            <div v-if="!showParkingSelect" class="add-parking mb-3">
                                                <p class="mb-0">No tienes seleccionado ningun adicional como
                                                    estacionamiento</p>
                                                <a href="#" @click.prevent="addParking()"><img class="icon-arrow"
                                                                                               :src="publicPath + '/img/add-more-icon.png'"
                                                                                               alt=""> Agregar
                                                    estacionamiento</a>
                                            </div>

                                            <template v-if="showParkingSelect">
                                                <template v-if="!showParkingSelected">
                                                    <div class="parking-select">
                                                        <div class="mattasur-custom-select parking-type-select">
                                                            <a href="#" class="ms-option-selected"
                                                               @click.prevent="parkingTypeSelectOpen = !parkingTypeSelectOpen">
                                                                <p class="option-title">
                                                                    {{ parkingTypeSelected }}
                                                                </p>

                                                                <img class="icon-arrow"
                                                                     :src="publicPath + '/img/collapse-arrow-down.png'"
                                                                     alt="">
                                                            </a>

                                                            <ul class="ms-options-list" v-if="parkingTypeSelectOpen">
                                                                <li>
                                                                    <a href="#"
                                                                       @click.prevent="selectparkingType('Cubierto')">
                                                                        <p class="option-title">Cubierto</p>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="#"
                                                                       @click.prevent="selectparkingType('Descubierto')">
                                                                        <p class="option-title">Descubierto</p>
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                        </div>

                                                        <div class="mattasur-custom-select parking-list-select"
                                                             v-if="parkingTypeSelected !== 'Seleccionar'">
                                                            <a href="#" class="ms-option-selected"
                                                               @click.prevent="parkingSelectOpen = !parkingSelectOpen">
                                                                <p class="option-title">
                                                                    <strong>{{ parkingSelected }} <span
                                                                            class="text-uppercase"
                                                                            v-if="parkingSelected !== 'Seleccionar'">- UF {{
                                                                        parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                                        }}</span></strong>
                                                                </p>

                                                                <img class="icon-arrow"
                                                                     :src="publicPath + '/img/collapse-arrow-down.png'"
                                                                     alt="">
                                                            </a>

                                                            <ul class="ms-options-list" v-if="parkingSelectOpen">
                                                                <li v-for="parking in filteredParkingsList">
                                                                    <a href="#"
                                                                       @click.prevent="selectparking(parking.NRO_ESTACIONAMIENTO, parking.PRECIO_LISTA, parking.ID_ESTACIONAMIENTO)">
                                                                        <p class="option-title">
                                                                            <strong>{{ parking.NRO_ESTACIONAMIENTO }} -
                                                                                UF {{
                                                                                parking.PRECIO_LISTA |
                                                                                    currency('', 0, {thousandsSeparator: '.'})
                                                                                }}</strong>
                                                                        </p>
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                        </div>
                                                    </div>

                                                    <h4 class="parking-price-value"
                                                        v-if="parkingSelected !== 'Seleccionar'">Valor {{
                                                        parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                        }} UF</h4>

                                                    <div class="buttons-container add-parking-button-container">
                                                        <template v-if="showAddParkingLoader">
                                                            <div class="lds-loader">
                                                                <div style="background:#000;"></div>
                                                                <div style="background: #000;"></div>
                                                                <div style="background: #000;"></div>
                                                            </div>
                                                        </template>
                                                        <a href="#" v-else
                                                           @click.prevent="showParkingSelectedInfo(property.ID_INMUEBLE)"
                                                           :class="{disabled: parkingSelected === 'Seleccionar'}"
                                                           class="button-call-action button-yellow add-parking-button">Continuar</a>
                                                        <!--<a href="#" class="button-call-action button-outline">Reservar ahora</a>-->
                                                    </div>
                                                </template>

                                                <p v-if="showParkingSelected"><strong>Estacionamiento:</strong>
                                                    {{ parkingTypeSelected }} {{
                                                    parkingSelected
                                                    }}
                                                    <a href="#" @click.prevent="deleteParking()"><img
                                                            :src="publicPath + '/img/trash-icon.png'"
                                                            alt=""></a></p>
                                            </template>
                                        </div>

                                        <template v-if="showQuoteButton">
                                            <div class="buttons-container buttons-w-48">
                                                <button type="submit"
                                                        @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                        class="button-call-action button-yellow">Reservar en linea
                                                </button>
                                                <button type="submit"
                                                        @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                        class="button-call-action button-outline">Cotizar
                                                </button>
                                            </div>

                                            <div class="terms-info">
                                                *Valores aproximados calculados en base a UF al día de hoy (
                                                {{ dateToday }} ) y con un plazo de 25 años, con crédito aprobado y 20%
                                                de pie.
                                            </div>
                                        </template>
                                    </div>
                                </form>

                            </div>
                        </b-modal>
                    </template>


                </div>

            </template>

            <div class="project-info-sidebar desktop-sidebar">
                <div class="logo-container">
                    <a href="/">
                        <img :src="publicPath + '/img/logo-header.png'" alt="">
                    </a>
                </div>

                <ul class="info-items-container">
                    <li class="info-item">
                        <div class="project-info-title">
                            <h2>PROYECTO</h2>
                            <h1>{{ currentProject.PROYECTO }} ETAPA 1</h1>
                            <span>{{ currentProject.COMUNA }}</span>

                            <p class="price-info item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{
                                minPrice(properties) |
                                    currency('', 0, {thousandsSeparator: '.'})
                                }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="property-counter-item">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/house-icon.svg'"
                                    alt=""></span>Deptos. disponibles</h3>
                            <span><strong>{{ properties.length }}</strong></span>
                        </div>

                        <div class="property-counter-item">
                            <p class="item-with-icon">Deptos. totales</p>
                            <span>{{ currentProject.NRO_INMUEBLES }}</span>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="mattasur-custom-select">
                            <h4>Selecciona el piso donde quieres tu departamento</h4>
                            <div class="mattasur-custom-select">
                                <a href="#" class="ms-option-selected"
                                   @click.prevent="floorSelectOpen = !floorSelectOpen">
                                    <p class="option-title"><strong>{{ floorSelected }}</strong></p>
                                    <span class="floor-info" v-if="floorSelected !== 'Selecciona el piso a revisar'">{{
                                        filteredApartments.length
                                        }}
                    departamentos desde <strong>{{
                                          minPrice(filteredApartments) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</strong></span>

                                    <img class="icon-arrow" :src="publicPath + '/img/collapse-arrow-down.png'" alt="">
                                </a>

                                <ul class="ms-options-list" v-if="floorSelectOpen">
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('Zócalo - Piso -1')">
                                            <p class="option-title"><strong>Zócalo - Piso -1</strong></p>
                                            <span class="floor-info">{{ floor0properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor0properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('Piso 1')">
                                            <p class="option-title"><strong>Piso 1</strong></p>
                                            <span class="floor-info">{{ floor1properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor1properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('Piso 2')">
                                            <p class="option-title"><strong>Piso 2</strong></p>
                                            <span class="floor-info">{{ floor2properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor2properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('Piso 3')">
                                            <p class="option-title"><strong>Piso 3</strong></p>
                                            <span class="floor-info">{{ floor3properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor3properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('Piso 4')">
                                            <p class="option-title"><strong>Piso 4</strong></p>
                                            <span class="floor-info">{{ floor4properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor4properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('Piso 5')">
                                            <p class="option-title"><strong>Piso 5</strong></p>
                                            <span class="floor-info">{{ floor5properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor5properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                </ul>

                            </div>

                        </div>
                    </li>

                    <li class="info-item">
                        <div class="contact-info-container">
                            <h4>Horario de atención</h4>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/calendar-two-colors.svg'"
                                    alt=""></span>{{ currentProject.HORARIO_SEMANA }}
                            </p>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/location-icon-yellow.svg'"
                                    alt=""></span>{{ currentProject.DIRECCION }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=http://esepe.cl/proyecto/casas-puente-alto"
                           target="_blank" class="item-with-icon share-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/share-icon-dark.svg'" alt=""></span>Compartir este proyecto</a>
                    </li>
                </ul>
            </div>

            <div v-if="floorSelected === 'Selecciona el piso a revisar' && isMobile()" class="start-quote-button">
                <div class="start-quote-button-inner">
                    <div class="project-info-title">
                        <h2>PROYECTO</h2>
                        <h1>{{ currentProject.PROYECTO }} ETAPA 1</h1>
                        <span>{{ currentProject.COMUNA }}</span>

                        <p class="price-info item-with-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{
                            minPrice(properties) |
                                currency('', 0, {thousandsSeparator: '.'})
                            }}</p>
                    </div>

                    <div class="buttons-container">
                        <a href="#" v-b-modal="'projectModalInfo'" class="button-call-action button-yellow">Quiero
                            cotizar mi depto</a>
                    </div>
                </div>
            </div>

            <b-modal modal-class="sidebar-modal" id="projectModalInfo" hide-footer>
                <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
                    <div class="logo-container">
                        <a href="/">
                            <img :src="publicPath + '/img/logo-header.png'" alt="">
                        </a>

                    </div>

                    <div class="mattasur-custom-select-container">
                        <h4>Selecciona el piso donde quieres tu departamento</h4>
                        <div class="mattasur-custom-select">
                            <a href="#" class="ms-option-selected"
                               :class="{'bg-white': floorSelected !== 'Selecciona el piso a revisar'}"
                               @click.prevent="floorSelectOpen = !floorSelectOpen">
                                <p class="option-title"><strong>{{ floorSelected }}</strong></p>
                                <span class="floor-info" v-if="floorSelected !== 'Selecciona el piso a revisar'">{{
                                    filteredApartments.length
                                    }}
                    departamentos desde <strong>{{
                                      minPrice(filteredApartments) | currency('', 0, {thousandsSeparator: '.'})
                                        }}</strong></span>

                                <img class="icon-arrow" :src="publicPath + '/img/collapse-arrow-down.png'" alt="">
                            </a>

                            <ul class="ms-options-list" v-if="floorSelectOpen">
                                <li>
                                    <a href="#" @click.prevent="selectFloor('Zócalo - Piso -1')">
                                        <p class="option-title"><strong>Zócalo - Piso -1</strong></p>
                                        <span class="floor-info">{{ floor0properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor0properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('Piso 1')">
                                        <p class="option-title"><strong>Piso 1</strong></p>
                                        <span class="floor-info">{{ floor1properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor1properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('Piso 2')">
                                        <p class="option-title"><strong>Piso 2</strong></p>
                                        <span class="floor-info">{{ floor2properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor2properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('Piso 3')">
                                        <p class="option-title"><strong>Piso 3</strong></p>
                                        <span class="floor-info">{{ floor3properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor3properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('Piso 4')">
                                        <p class="option-title"><strong>Piso 4</strong></p>
                                        <span class="floor-info">{{ floor4properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor4properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('Piso 5')">
                                        <p class="option-title"><strong>Piso 5</strong></p>
                                        <span class="floor-info">{{ floor5properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor5properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                            </ul>

                        </div>

                    </div>

                    <ul class="info-items-container">

                        <li class="info-item">
                            <div class="project-info-title">
                                <div>
                                    <h2>PROYECTO</h2>
                                    <h1>{{ currentProject.PROYECTO }}</h1>
                                    <span>{{ currentProject.COMUNA }}</span>
                                </div>

                                <div class="price">
                                    <span>Desde</span>
                                    <p class="price-info"><span>
                  <img :src="publicPath + '/img/security-icon-dark.svg'" alt="">
                  </span>UF {{ minPrice(properties) | currency('', 0, {thousandsSeparator: '.'}) }}
                                    </p>
                                </div>
                            </div>

                            <div class="property-counter-item">
                                <h3 class="item-with-icon"><span class="icon-box"><img
                                        :src="publicPath + '/img/house-icon.svg'"
                                        alt=""></span>Deptos. disponibles</h3>
                                <span><strong>{{ properties.length }}</strong></span>
                            </div>

                            <div class="property-counter-item">
                                <p class="item-with-icon">Deptos. totales</p>
                                <span>{{ currentProject.NRO_INMUEBLES }}</span>
                            </div>
                        </li>

                        <li class="info-item">
                            <div class="contact-info-container">
                                <h4>Horario de atención</h4>
                                <p class="item-with-icon"><span class="icon-box"><img
                                        :src="publicPath + '/img/calendar-two-colors.svg'"
                                        alt=""></span>{{ currentProject.HORARIO_SEMANA }}
                                </p>
                                <p class="item-with-icon"><span class="icon-box"><img
                                        :src="publicPath + '/img/location-icon-yellow.svg'"
                                        alt=""></span>{{ currentProject.DIRECCION }}</p>
                            </div>
                        </li>
                    </ul>
                    <div class="button-container">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=http://esepe.cl/proyecto/casas-puente-alto"
                           target="_blank" class="share-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/share-icon-dark.svg'" alt=""></span>Compartir este proyecto</a>

                        <b-button v-b-toggle.collapseContent
                                  class="button-call-action button-yellow"
                                  block @click="$bvModal.hide('projectModalInfo')">Cerrar
                        </b-button>
                    </div>
                </div>
            </b-modal>

        </div>

        <div v-if="isMobile()" class="fixed-project-info">
            <div class="project-name">
                <h1>PROYECTO <strong>{{ currentProject.PROYECTO }}</strong></h1>
                <span>{{ currentProject.COMUNA }}</span>
            </div>

            <div class="mattasur-custom-select">
                <a href="#" class="ms-option-selected" @click.prevent="floorSelectOpen = !floorSelectOpen">
                    <p class="option-title"><strong>{{ floorSelected }}</strong></p>
                    <span class="floor-info"
                          v-if="floorSelected !== 'Selecciona el piso a revisar'">{{ filteredApartments.length }}
                    departamentos desde <strong>{{
                          minPrice(filteredApartments) | currency('', 0, {thousandsSeparator: '.'})
                            }}</strong></span>

                    <img class="icon-arrow" :src="publicPath + '/img/collapse-arrow-down.png'" alt="">
                </a>

                <ul class="ms-options-list" v-if="floorSelectOpen">
                    <li>
                        <a href="#" @click.prevent="selectFloor('Zócalo - Piso -1')">
                            <p class="option-title"><strong>Zócalo - Piso -1</strong></p>
                            <span class="floor-info">{{ floor0properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor0properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('Piso 1')">
                            <p class="option-title"><strong>Piso 1</strong></p>
                            <span class="floor-info">{{ floor1properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor1properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('Piso 2')">
                            <p class="option-title"><strong>Piso 2</strong></p>
                            <span class="floor-info">{{ floor2properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor2properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('Piso 3')">
                            <p class="option-title"><strong>Piso 3</strong></p>
                            <span class="floor-info">{{ floor3properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor3properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('Piso 4')">
                            <p class="option-title"><strong>Piso 4</strong></p>
                            <span class="floor-info">{{ floor4properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor4properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('Piso 5')">
                            <p class="option-title"><strong>Piso 5</strong></p>
                            <span class="floor-info">{{ floor5properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor5properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                </ul>

            </div>
        </div>

        <b-modal ref="instructionModal" hide-footer modal-class="guide-modal" id="guideModal">
            <div class="guide-modal-content">
                <img class="point-indicator-img" :src="publicPath + '/img/map-point-icon.png'" alt="">
                <div class="header-content">
                    <p><strong>Haz click sobre el círculo</strong> para ver detalles y cotizar este departamento
                        específico.</p>
                    <img :src="publicPath + '/img/instruction-icon.png'" alt="">
                </div>
                <div class="footer-content">
                    <div class="d-flex align-items-center">
                        <img :src="publicPath + '/img/cruz-icon.png'" alt="">
                        <p>Mueve el mapa con tu dedo para visualizar todos los departamentos.</p>
                    </div>
                    <b-button v-b-toggle.collapseContent
                              class="button-call-action button-yellow"
                              block @click="$bvModal.hide('guideModal')">¡Entendido!
                    </b-button>

                </div>
            </div>
        </b-modal>

        <template v-if="!loading">
            <div v-if="floorSelected !== 'Selecciona el piso a revisar'" class="project-models"
                 :class="{'show-project-models': showProjectModels}">
                <h3 class="filter-title d-sm-none">Filtra los departamentos por: </h3>
                <div class="container esepe-custom-container">
                    <div class="row esepe-row">

                        <div class="col-md-3">
                            <div class="model-item justify-content-start justify-content-md-center"
                                 @click="changeFilterSelected('all')"
                                 :class="{active: filterSelected === 'all'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <p>Todos los modelos</p>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="model-item" @click="changeFilterSelected('tipo-a')"
                                 :class="{active: filterSelected === 'tipo-a'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">
                                <div class="model-info">
                                    <div class="d-flex align-items-center flex-shrink-0">
                                        <span class="color-indicator model-tipo-a"></span>
                                    </div>
                                    <div class="pl-3">
                                        <p>Departamento tipo A - 53,64 m2 2d / 2b</p>
                                        <h4>Desde UF {{
                                            minPrice(tipoAproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="model-item" @click="changeFilterSelected('tipo-b')"
                                 :class="{active: filterSelected === 'tipo-b'}">
                                <img class="down-arrow" :src="publicPath + '/img/arrow-down-yellow.svg'" alt="">

                                <div class="model-info">
                                    <div class="d-flex align-items-center flex-shrink-0">
                                        <span class="color-indicator model-tipo-b"></span>
                                    </div>
                                    <div class="pl-3">
                                        <p>Departamento tipo B - 46,80 m2 2d / 1b</p>
                                        <h4>Desde UF {{
                                            minPrice(tipoBproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="model-item" @click="changeFilterSelected('tipo-c')"
                                 :class="{active: filterSelected === 'tipo-c'}">
                                <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">

                                <div class="model-info">
                                    <div class="d-flex align-items-center flex-shrink-0">
                                        <span class="color-indicator model-tipo-c"></span>
                                    </div>
                                    <div class="pl-3">
                                        <p>Departamento tipo C - 52,44 m2 2d / 2b</p>
                                        <h4>Desde UF {{
                                            minPrice(tipoCproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="model-item" @click="changeFilterSelected('tipo-d')"
                                 :class="{active: filterSelected === 'tipo-d'}">
                                <img :src="publicPath + '/img/arrow-down-yellow.svg'" alt="" class="down-arrow">

                                <div class="model-info">
                                    <div class="d-flex align-items-center flex-shrink-0">
                                        <span class="color-indicator model-tipo-d"></span>
                                    </div>
                                    <div class="pl-3">
                                        <p>Departamento tipo D - 38 m2 1d / 1b</p>
                                        <h4>Desde UF {{
                                            minPrice(tipoDproperties) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</h4>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>


                </div>
            </div>
        </template>
    </div>

  <!--projectId == '31063' Parque Germania-->
    <div v-else-if="projectApiId == '5'" class="master-plan-page matta-sur-project parque-germania-mp"
         :class="{'loading-view': loading, 'default-view': floorSelected !== 'Selecciona el piso a revisar'}">

        <template v-if="loading">
            <div class="lds-loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </template>

        <template v-if="floorSelected !== 'Selecciona el piso a revisar'">
            <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
                <div class="logo-container">
                    <a href="/">
                        <img :src="publicPath + '/img/logo-header.png'" alt="">
                    </a>
                </div>
            </div>
        </template>

        <div class="master-plan-container" ref="masterPlanContainer"
             :class="{'matta-sur-default-view': floorSelected === 'Selecciona el piso a revisar'}" v-if="projectInfo">

            <template v-if="floorSelected === '1'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-1.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-1.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '2'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-2.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-2.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '3'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-3.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-3.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '4'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-4.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-4.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '5'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-5.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-5.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '6'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-6.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-6.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '7'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-7.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-7.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '8'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-8.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-8.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '9'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-9.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-9.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '10'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-10.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-10.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '11'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-11.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-11.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '12'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-12.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-12.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '13'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-alternativo-13.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView"
                         :src="publicPath + '/img/pisos-pg/pg-piso-alternativo-13.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '14'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-14.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView" :src="publicPath + '/img/pisos-pg/pg-piso-14.jpg'" alt="">
                </template>

            </template>
            <template v-if="floorSelected === '15'">
                <template v-if="!isMobile()">
                    <img class="map-image" :src="publicPath + '/img/pisos-pg/pg-piso-alternativo-15.jpg'" alt="">
                </template>
                <template v-if="isMobile()">
                    <img class="map-image" ref="defaultView"
                         :src="publicPath + '/img/pisos-pg/pg-piso-alternativo-15.jpg'" alt="">
                </template>

            </template>

            <template v-if="floorSelected !== 'Selecciona el piso a revisar'">
                <!--        Desktop points-->
                <div class="points-container" v-if="!isMobile()">
                    <template v-if="showUnavailableProperties">
                        <template v-if="floorSelected === '1'">
                            <template v-for="property in pgFloor1">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '2'">
                            <template v-for="property in pgFloor2">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '3'">
                            <template v-for="property in pgFloor3">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '4'">
                            <template v-for="property in pgFloor4">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '5'">
                            <template v-for="property in pgFloor5">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '6'">
                            <template v-for="property in pgFloor6">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '7'">
                            <template v-for="property in pgFloor7">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '8'">
                            <template v-for="property in pgFloor8">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '9'">
                            <template v-for="property in pgFloor9">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '10'">
                            <template v-for="property in pgFloor10">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '11'">
                            <template v-for="property in pgFloor11">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '12'">
                            <template v-for="property in pgFloor12">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '13'">
                            <template v-for="property in pgFloor13">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '14'">
                            <template v-for="property in pgFloor14">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>

                        <template v-if="floorSelected === '15'">
                            <template v-for="property in pgFloor15">
                                <button :id="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span></button>

                                <b-tooltip :target="'sold_property_'+ property.modelCode"
                                           :key="'sold_property_'+ property.modelCode" tabindex="0">
                                    <div class="property-info-tooltip sold-property-card">
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>
                                    </div>
                                </b-tooltip>
                            </template>
                        </template>
                    </template>

                    <template v-for="(property, index) in filteredApartments">
                        <button :key="property.NRO_INMUEBLE" :id="'property_'+ property.NRO_INMUEBLE"
                                class="color-indicator indicator-in-map" @click="deleteParking()"
                                :class="['pg-property-'+ property.NRO_INMUEBLE.toLowerCase().replace(/ /g, '-'), 'model-'+ property.MODELO.toLowerCase().replace(/ /g, '-') ]"><span
                                class="circle-inner"></span></button>

                        <b-tooltip tabindex="0" :key="'tooltip'+ property.NRO_INMUEBLE"
                                   :target="'property_'+ property.NRO_INMUEBLE">

                            <div class="property-info-tooltip">
                                <form :action="submitUrl" method="post">
                                    <div class="inputs-container">
                                        <input type="hidden" name="nombreModelo" :value="property.MODELO">
                                        <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                        <input type="hidden" name="barrio" :value="property.BARRIO">
                                        <input type="hidden" name="etapa" :value="property.ETAPA">
                                        <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                        <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                        <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                        <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                        <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                        <input type="hidden" name="projectId" :value="projectId">
                                        <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                        <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                        <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                        <input type="hidden" name="valorAntesDescuentoUF"
                                               :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                        <input type="hidden" name="originalPrecioUF"
                                               :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                        <input type="hidden" name="valorAntesDescuentoPesos"
                                               :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                        <input type="hidden" name="originalPrecioPesos"
                                               :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">

                                        <input type="hidden" name="precioConEstacionamiento"
                                               :value="apartmentTotalPrice  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="precioConEstacionamientoPesos"
                                               :value="apartmentTotalPricePesos  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="precioConEstacionamientoPesos"
                                               :value="apartmentTotalPricePesos  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="numEstacionamiento"
                                               :value="parkingSelected">
                                        <input type="hidden" name="precioEstacionaiento"
                                               :value="parkingSelectedPrice  | currency('', 0, { thousandsSeparator: '.' })">

                                        <input type="hidden" name="tipoEstacionamiento" :value="parkingTypeSelected">
                                        <input type="hidden" name="EstacionamientiId" :value="parkingId">

                                        <input v-if="apartmentTotalPricePesos !== null" type="hidden"
                                               name="precioEstacionamientoPesos"
                                               :value="parkingPricePesos(priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE)) | currency('', 0, { thousandsSeparator: '.' })">

                                        <input type="hidden" name="montoPieConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].VALOR_DIVIDENDO  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <input type="hidden" name="montoPieConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].VALOR_DIVIDENDO  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <!--                        SIMULATION 30:-->
                                        <input type="hidden" name="montoPieConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento"
                                               :value="dividendoTotalPrice | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                        <input type="hidden" name="simu20precioUF"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE)  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20precioPesos"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20periodoCredito"
                                               :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu20montoPie"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20tasaInteres"
                                               :value="property.SIMULACION_20[1].TASA_INTERES">
                                        <input type="hidden" name="simu20valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                        <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                        <input type="hidden" name="simu25periodoCredito"
                                               :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu25tasaInteres"
                                               :value="property.SIMULACION_25[1].TASA_INTERES">
                                        <input type="hidden" name="simu25valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu25RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                        <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                        <input type="hidden" name="simu30periodoCredito"
                                               :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu30tasaInteres"
                                               :value="property.SIMULACION_30[1].TASA_INTERES">
                                        <input type="hidden" name="simu30valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu30RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    </div>

                                    <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                        {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                    </div>
                                    <div class="image-container">
                                        <img :src="publicPath + '/img/' + getImagesName(property.MODELO.replace(/ /g, '-'))"
                                             :alt="'Depto. ' + property.MODELO.toLowerCase().replace(/ /g, '-')">
                                    </div>

                                    <div class="header-content d-block" v-if="apartmentTotalPrice !== null">
                                        <p class="mb-0"><strong>Costo total</strong></p>
                                        <div class="d-flex align-items-center justify-content-between mb-3">
                                            <div class="title"
                                                 :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                          <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                              priceFromApiFormatter(property.PRECIO_LISTA) |
                                  currency('', 0, {thousandsSeparator: '.'})
                              }}</span>

                                                <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF
                                                    {{
                                                    priceFromApiFormatter(property.PRECIO_DESCUENTO) + parseInt(parkingSelectedPrice) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</h3>

                                                <h3 class="price" v-else>UF {{
                                                    apartmentTotalPrice | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</h3>

                                                <div style="margin-top: 10px;">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <p class="mb-0" style="font-size: 12px; line-height: 13px;">
                                                            <strong>DEPARTAMENTO {{ property.NRO_INMUEBLE }}</strong>
                                                        </p>
                                                        <h3 class="price"
                                                            style="line-height: 17px; margin-bottom: 0; font-size: 14px;margin-left: 8px;">
                                                            UF {{
                                                            priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                                currency('', 0, {thousandsSeparator: '.'})
                                                            }}</h3>
                                                    </div>

                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <p class="mb-0" style="font-size: 12px; line-height: 13px;">
                                                            <strong>ESTACIONAMIENTO {{ parkingSelected }}</strong></p>
                                                        <h3 class="price text-uppercase"
                                                            style="line-height: 17px; margin-bottom: 0; font-size: 14px;margin-left: 8px;">
                                                            UF {{
                                                            parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                            }}</h3>
                                                    </div>
                                                </div>


                                                <!--                        <h3 class="price" v-else >UF {{ priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |-->
                                                <!--                          currency('', 0, { thousandsSeparator: '.' }) }}</h3>-->
                                            </div>
                                            <!--                      <div class="financing-info">-->

                                            <!--                      </div>-->

                                        </div>

                                        <!--                    <h4>Dividendo aprox. ${{ dividendoTotalPrice |-->
                                        <!--                      currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                        <!--                    <span>30 años / 20% de pie</span>-->
                                    </div>

                                    <div class="header-content" v-else>

                                        <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                            <h2 class="model-name">Depto. {{ property.MODELO }}</h2>
                                            <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                                priceFromApiFormatter(property.PRECIO_LISTA) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</span>

                                            <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                                priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</h3>
                                            <h3 class="price" v-else>UF {{
                                                priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</h3>
                                        </div>


                                        <!--                    <div class="financing-info">-->
                                        <!--                      <h4>Dividendo aprox. ${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                        <!--                        currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                        <!--                      <span>30 años / 20% de pie</span>-->
                                        <!--                    </div>-->
                                    </div>

                                    <div class="body-content">
                                        <p style="margin-bottom: 5px;">Departamento {{ property.NRO_INMUEBLE }},
                                            orientación <span>{{ property.ORIENTACION }}</span>.</p>
                                        <p><strong>Precios de estacionamientos desde UF 340 y de bodegas desde UF
                                            70.</strong></p>

                                        <div class="house-specs">
                                            <div class="spec-item" v-if="property.MODELO != 'LOCAL'">
                                                <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                                <span>{{ property.PROGRAMA[0] }} hab.</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                                <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                            </div>

                                            <div class="spec-item" v-if="property.MODELO != 'LOCAL'">
                                                <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                                <span>{{ property.PROGRAMA[3] }} baños</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                                <a class="show-distribution-modal" href="#"
                                                   v-b-modal="index + 'apartmentInfo' + property.NRO_INMUEBLE">Ver
                                                    planta y
                                                    distrib.</a>
                                            </div>
                                        </div>

                                        <div style="display: none" class="parking-select-container">
                                            <p class="mb-0"><strong>Adicionales</strong></p>
                                            <div v-if="!showParkingSelect" class="add-parking mb-3">
                                                <p class="mb-0">No tienes seleccionado ningun adicional como
                                                    estacionamiento</p>
                                                <a href="#" @click.prevent="addParking()"><img class="icon-arrow"
                                                                                               :src="publicPath + '/img/add-more-icon.png'"
                                                                                               alt=""> Agregar
                                                    estacionamiento</a>
                                            </div>

                                            <template v-if="showParkingSelect">
                                                <template v-if="!showParkingSelected">
                                                    <div class="parking-select">
                                                        <div class="mattasur-custom-select parking-type-select">
                                                            <a href="#" class="ms-option-selected"
                                                               @click.prevent="parkingTypeSelectOpen = !parkingTypeSelectOpen">
                                                                <p class="option-title">
                                                                    {{ parkingTypeSelected }}
                                                                </p>

                                                                <img class="icon-arrow"
                                                                     :src="publicPath + '/img/collapse-arrow-down.png'"
                                                                     alt="">
                                                            </a>

                                                            <ul class="ms-options-list" v-if="parkingTypeSelectOpen">
                                                                <li>
                                                                    <a href="#"
                                                                       @click.prevent="selectparkingType('Cubierto')">
                                                                        <p class="option-title">Cubierto</p>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="#"
                                                                       @click.prevent="selectparkingType('Descubierto')">
                                                                        <p class="option-title">Descubierto</p>
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                        </div>

                                                        <div class="mattasur-custom-select parking-list-select"
                                                             v-if="parkingTypeSelected !== 'Seleccionar'">
                                                            <a href="#" class="ms-option-selected"
                                                               @click.prevent="parkingSelectOpen = !parkingSelectOpen">
                                                                <p class="option-title">
                                                                    <strong>{{ parkingSelected }} <span
                                                                            class="text-uppercase"
                                                                            v-if="parkingSelected !== 'Seleccionar'">- UF {{
                                                                        parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                                        }}</span></strong>
                                                                </p>

                                                                <img class="icon-arrow"
                                                                     :src="publicPath + '/img/collapse-arrow-down.png'"
                                                                     alt="">
                                                            </a>

                                                            <ul class="ms-options-list" v-if="parkingSelectOpen">
                                                                <li v-for="(parking, index) in filteredParkingsList"
                                                                    :key="index">
                                                                    <a href="#"
                                                                       @click.prevent="selectparking(parking.NRO_ESTACIONAMIENTO, parking.PRECIO_LISTA, parking.ID_ESTACIONAMIENTO)">
                                                                        <p class="option-title">
                                                                            <strong>{{ parking.NRO_ESTACIONAMIENTO }} -
                                                                                UF {{
                                                                                parking.PRECIO_LISTA |
                                                                                    currency('', 0, {thousandsSeparator: '.'})
                                                                                }}</strong>
                                                                        </p>
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                        </div>
                                                    </div>

                                                    <h4 class="parking-price-value"
                                                        v-if="parkingSelected !== 'Seleccionar'">Valor {{
                                                        parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                        }} UF</h4>

                                                    <div class="buttons-container add-parking-button-container">
                                                        <template v-if="showAddParkingLoader">
                                                            <div class="lds-loader">
                                                                <div style="background:#000;"></div>
                                                                <div style="background: #000;"></div>
                                                                <div style="background: #000;"></div>
                                                            </div>
                                                        </template>

                                                        <a href="#" v-else
                                                           @click.prevent="showParkingSelectedInfo(property.ID_INMUEBLE)"
                                                           :class="{disabled: parkingSelected === 'Seleccionar'}"
                                                           class="button-call-action button-yellow add-parking-button">Continuar</a>
                                                        <!--<a href="#" class="button-call-action button-outline">Reservar ahora</a>-->
                                                    </div>
                                                </template>

                                                <p v-if="showParkingSelected"><strong>Estacionamiento:</strong>
                                                    {{ parkingTypeSelected }} {{
                                                    parkingSelected
                                                    }}
                                                    <a href="#" @click.prevent="deleteParking()"><img
                                                            :src="publicPath + '/img/trash-icon.png'" alt=""></a></p>
                                            </template>
                                        </div>

                                        <template v-if="showQuoteButton">
                                            <div class="buttons-container buttons-w-48">
                                                <button type="submit"
                                                        @click="submitFunction('/reservar/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                        class="button-call-action button-yellow">Reservar en linea
                                                </button>
                                                <button type="submit"
                                                        @click="submitFunction('/cotizacion/?nombreProyecto='+ convertToSlug(currentProject.PROYECTO))"
                                                        class="button-call-action button-outline">Cotizar
                                                </button>
                                            </div>

                                            <div class="terms-info">
                                                *Valores aproximados calculados en base a UF al día de hoy (
                                                {{ dateToday }} ) y con un plazo de 25
                                                años, con crédito aprobado y 20% de pie.
                                            </div>
                                        </template>
                                    </div>
                                </form>

                            </div>
                        </b-tooltip>

                        <b-modal modal-class="model-info-Modal distribution-apartment-modal"
                                 :key="index + 'apartmentInfo' + property.NRO_INMUEBLE"
                                 :id="index + 'apartmentInfo' + property.NRO_INMUEBLE" hide-footer>
                            <b-button class="close custom-close" block
                                      @click="$bvModal.hide(index + 'apartmentInfo' + property.NRO_INMUEBLE)">
                                <img :src="publicPath + '/img/close-icon.png'" alt="">
                            </b-button>
                            <div class="apartment-info-modal">
                                <div class="title-and-specs-info">
                                    <div class="title-continer">
                                        <p><strong>Departamento {{ property.NRO_INMUEBLE }}</strong></p>
                                        <p>
                                            <strong>UF {{
                                                priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}
                                            </strong>
                                        </p>
                                    </div>

                                    <div class="house-specs">
                                        <div class="spec-item" v-if="property.MODELO != 'LOCAL'">
                                            <img width="23" :src="publicPath + '/img/bed.svg'" alt="">
                                            <span>{{ property.PROGRAMA[0] }} hab.</span>
                                        </div>

                                        <div class="spec-item">
                                            <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                            <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                        </div>

                                        <div class="spec-item" v-if="property.MODELO != 'LOCAL'">
                                            <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt="">
                                            <span>{{ property.PROGRAMA[3] }} baños</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="description">
                                    <p>Departamento {{ property.PROGRAMA[0] }} dormitorios, Orientación {{
                                        property.ORIENTACION
                                        }}, Numeración {{ property.NRO_INMUEBLE }}, Opcional
                                        estacionamiento.</p>
                                </div>

                                <img class="modal-image"
                                     :src="publicPath + '/img/' + getImagesName(property.MODELO.replace(/ /g, '-'))"
                                     :alt="'Depto. ' + property.MODELO.toLowerCase().replace(/ /g, '-')">
                            </div>
                        </b-modal>
                    </template>
                </div>

                <!--        mobile points-->
                <div ref="pointsContainer" class="points-container" v-else>
                    <!-- Puntos no disponibles-->
                    <template v-if="showUnavailableProperties">
                        <template v-if="floorSelected === '1'">
                            <template v-for="property in pgFloor1">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '2'">
                            <template v-for="property in pgFloor2">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '3'">
                            <template v-for="property in pgFloor3">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '4'">
                            <template v-for="property in pgFloor4">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '5'">
                            <template v-for="property in pgFloor5">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '6'">
                            <template v-for="property in pgFloor6">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '7'">
                            <template v-for="property in pgFloor7">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '8'">
                            <template v-for="property in pgFloor8">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '9'">
                            <template v-for="property in pgFloor9">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '10'">
                            <template v-for="property in pgFloor10">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '11'">
                            <template v-for="property in pgFloor11">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '12'">
                            <template v-for="property in pgFloor12">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '13'">
                            <template v-for="property in pgFloor13">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '14'">
                            <template v-for="property in pgFloor14">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                        <template v-if="floorSelected === '15'">
                            <template v-for="property in pgFloor15">
                                <button v-b-modal="'sold_property_'+ property.modelCode"
                                        :key="'sold_property_'+ property.modelCode"
                                        class="color-indicator indicator-in-map sold-property"
                                        :class="['pg-property-'+ property.modelCode]"><span
                                        class="circle-inner"></span>
                                </button>

                                <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                         :id="'sold_property_'+ property.modelCode"
                                         :key="'sold_property_'+ property.modelCode" hide-footer>
                                    <div class="property-info-tooltip sold-property-card">
                                        <b-button class="close custom-close back-button" block
                                                  @click="$bvModal.hide('sold_property_'+ property.modelCode)">
                                            <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                            <span>Volver</span>
                                        </b-button>
                                        <div class="image-container">
                                            <img :src="publicPath + '/img/vendido-pg.jpg'"
                                                 :alt="'Depto.' + property.modelCode">
                                        </div>
                                        <div class="header-content">
                                            <div class="title">
                                                <h2 class="model-name">Depto. {{ property.modelCode }}</h2>
                                            </div>
                                            <div class="financing-info">
                                                <h4>DEPARTAMENTO VENDIDO</h4>
                                            </div>
                                        </div>

                                    </div>
                                </b-modal>
                            </template>
                        </template>
                    </template>

                    <!-- Puntos Disponibles-->
                    <template v-for="property in filteredApartments">
                        <button v-b-modal="'property_'+ property.NRO_INMUEBLE" :key="property.NRO_INMUEBLE"
                                @click="deleteParking()"
                                class="color-indicator indicator-in-map"
                                :class="['pg-property-'+ property.NRO_INMUEBLE.toLowerCase().replace(/ /g, '-'), 'model-'+ property.MODELO.toLowerCase().replace(/ /g, '-') ]"><span
                                class="circle-inner"></span>
                        </button>

                        <b-modal modal-class="model-info-Modal ms-model-info-Modal"
                                 :key="'tooltip'+ property.NRO_INMUEBLE"
                                 :id="'property_'+ property.NRO_INMUEBLE" hide-footer>
                            <div class="property-info-tooltip">
                                <form :action="submitUrl" method="post">
                                    <div class="inputs-container">
                                        <input type="hidden" name="nombreModelo" :value="property.MODELO">
                                        <input type="hidden" name="numeroCasa" :value="property.NRO_INMUEBLE">
                                        <input type="hidden" name="barrio" :value="property.BARRIO">
                                        <input type="hidden" name="etapa" :value="property.ETAPA">
                                        <input type="hidden" name="habitaciones" :value="property.PROGRAMA[0]">
                                        <input type="hidden" name="baños" :value="property.PROGRAMA[3]">
                                        <input type="hidden" name="areaConstruida" :value="property.SUPERFICIE_UTIL">
                                        <input type="hidden" name="areaTotal" :value="property.SUPERFICIE_TOTAL">
                                        <input type="hidden" name="propertyId" :value="property.ID_INMUEBLE">
                                        <input type="hidden" name="projectId" :value="projectId">
                                        <input type="hidden" name="valorReserva" :value="currentProject.VALOR_RESERVA">
                                        <input type="hidden" name="projectName" :value="currentProject.PROYECTO">
                                        <input type="hidden" name="porcentajeDescuento" :value="property.DESCUENTO">
                                        <input type="hidden" name="valorAntesDescuentoUF"
                                               :value="property.SIMULACION_20[0].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                        <input type="hidden" name="originalPrecioUF"
                                               :value="property.SIMULACION_20[0].PRECIO_INMUEBLE">
                                        <input type="hidden" name="valorAntesDescuentoPesos"
                                               :value="property.SIMULACION_20[1].PRECIO_INMUEBLE / (1 - (property.DESCUENTO / 100))">
                                        <input type="hidden" name="originalPrecioPesos"
                                               :value="property.SIMULACION_20[1].PRECIO_INMUEBLE">

                                        <input type="hidden" name="precioConEstacionamiento"
                                               :value="apartmentTotalPrice  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="precioConEstacionamientoPesos"
                                               :value="apartmentTotalPricePesos  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="precioConEstacionamientoPesos"
                                               :value="apartmentTotalPricePesos  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="numEstacionamiento"
                                               :value="parkingSelected">
                                        <input type="hidden" name="precioEstacionaiento"
                                               :value="parkingSelectedPrice  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input v-if="apartmentTotalPricePesos !== null" type="hidden"
                                               name="precioEstacionamientoPesos"
                                               :value="parkingPricePesos(priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE)) | currency('', 0, { thousandsSeparator: '.' })">

                                        <input type="hidden" name="tipoEstacionamiento"
                                               :value="parkingTypeSelected">
                                        <input type="hidden" name="EstacionamientiId"
                                               :value="parkingId">

                                        <input type="hidden" name="montoPieConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].VALOR_DIVIDENDO  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento20"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <input type="hidden" name="montoPieConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].VALOR_DIVIDENDO  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento25"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <!--                        SIMULATION 30:-->
                                        <input type="hidden" name="montoPieConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].MONTO_PIE  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="dividendoConEstacionamiento"
                                               :value="dividendoTotalPrice | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="tasaInteresConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].TASA_INTERES">
                                        <input type="hidden" name="rentaConEstacionamiento"
                                               v-if="parkingData"
                                               :value="parkingData.SIMULACIONES.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE  | currency('', 0, { thousandsSeparator: '.' })">


                                        <!--&lt;!&ndash;simulacion al 20%&ndash;&gt;-->
                                        <input type="hidden" name="simu20precioUF"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE)  | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20precioPesos"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].PRECIO_INMUEBLE) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20periodoCredito"
                                               :value="property.SIMULACION_20[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu20montoPie"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].MONTO_PIE) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20tasaInteres"
                                               :value="property.SIMULACION_20[1].TASA_INTERES">
                                        <input type="hidden" name="simu20valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu20RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_20[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                        <!--&lt;!&ndash;simulacion al 25%&ndash;&gt;-->
                                        <input type="hidden" name="simu25periodoCredito"
                                               :value="property.SIMULACION_25[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu25tasaInteres"
                                               :value="property.SIMULACION_25[1].TASA_INTERES">
                                        <input type="hidden" name="simu25valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_25[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu25RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_25[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">

                                        <!--&lt;!&ndash;simulacion al 30%&ndash;&gt;-->
                                        <input type="hidden" name="simu30periodoCredito"
                                               :value="property.SIMULACION_30[1].PERIODO_CREDITO">
                                        <input type="hidden" name="simu30tasaInteres"
                                               :value="property.SIMULACION_30[1].TASA_INTERES">
                                        <input type="hidden" name="simu30valorDividendo"
                                               :value="priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) | currency('', 0, { thousandsSeparator: '.' })">
                                        <input type="hidden" name="simu30RentaAcreditable"
                                               :value="priceFromApiFormatter(property.SIMULACION_30[1].RENTA_MINIMA_ACREDITABLE) | currency('', 0, { thousandsSeparator: '.' })">
                                    </div>

                                    <b-button class="close custom-close back-button" block
                                              @click="$bvModal.hide('property_'+ property.NRO_INMUEBLE)">
                                        <img :src="publicPath + '/img/back-arrow.png'" alt="">
                                        <span>Volver</span>
                                    </b-button>

                                    <div v-if="property.EN_PROMOCION == 'SI'" class="discount-indicator">
                                        {{ discountFormatted(property.DESCUENTO) }}% de Dcto.
                                    </div>

                                    <div class="image-container">
                                        <img :src="publicPath + '/img/' + getImagesName(property.MODELO.replace(/ /g, '-'))"
                                             :alt="'Depto. ' + property.MODELO.toLowerCase().replace(/ /g, '-')">
                                    </div>

                                    <div class="header-content d-block" v-if="apartmentTotalPrice !== null">
                                        <p class="mb-0"><strong>Costo total</strong></p>
                                        <div class="mb-3">
                                            <div class="title"
                                                 :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                        <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                            priceFromApiFormatter(property.PRECIO_LISTA) |
                                currency('', 0, {thousandsSeparator: '.'})
                            }}</span>

                                                <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF
                                                    {{
                                                    priceFromApiFormatter(property.PRECIO_DESCUENTO) + parseInt(parkingSelectedPrice) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</h3>

                                                <h3 class="price" v-else>UF {{
                                                    apartmentTotalPrice | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</h3>

                                                <div class="financing-info w-100 mt-4">
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <p class="mb-0 mr-4"
                                                                   style="font-size: 12px; line-height: 13px;"><strong>DEPARTAMENTO
                                                                    {{ property.NRO_INMUEBLE }}</strong></p>
                                                            </td>
                                                            <td>
                                                                <h3 class="price"
                                                                    style="line-height: 17px; margin-bottom: 0; font-size: 14px; margin-left: 8px;">
                                                                    UF {{
                                                                    priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                                        currency('', 0, {thousandsSeparator: '.'})
                                                                    }}</h3>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <p class="mb-0 mr-4"
                                                                   style="font-size: 12px; line-height: 13px;"><strong>ESTACIONAMIENTO
                                                                    {{ parkingSelected }}</strong></p>
                                                            </td>
                                                            <td>
                                                                <h3 class="price text-uppercase"
                                                                    style="line-height: 17px; margin-bottom: 0; font-size: 14px; margin-left: 8px;">
                                                                    UF {{
                                                                    parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                                    }}</h3>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>

                                            </div>


                                        </div>

                                        <!--                    <h4>Dividendo aprox. <br>${{ dividendoTotalPrice | currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                        <!--                    <span>30 años / 20% de pie</span>-->
                                    </div>

                                    <div class="header-content" v-else>

                                        <div class="title" :class="{'promos-prices' : property.EN_PROMOCION == 'SI'}">
                                            <h2 class="model-name">Depto. {{ property.MODELO }}</h2>
                                            <span class="full-price" v-if="property.EN_PROMOCION == 'SI'">Precio lista: UF {{
                                                priceFromApiFormatter(property.PRECIO_LISTA) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</span>

                                            <h3 class="price" v-if="property.EN_PROMOCION == 'SI'">Precio dcto.: UF {{
                                                priceFromApiFormatter(property.PRECIO_DESCUENTO) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</h3>
                                            <h3 class="price" v-else>UF {{
                                                priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                    currency('', 0, {thousandsSeparator: '.'})
                                                }}</h3>
                                        </div>


                                        <!--                    <div class="financing-info">-->
                                        <!--                      <h4>Dividendo aprox. ${{ priceFromApiFormatter(property.SIMULACION_30[1].VALOR_DIVIDENDO) |-->
                                        <!--                        currency('', 0, { thousandsSeparator: '.' }) }}*</h4>-->
                                        <!--                      <span>30 años / 20% de pie</span>-->
                                        <!--                    </div>-->
                                    </div>

                                    <div class="body-content">

                                        <p style="margin-bottom: 5px;">Departamento {{ property.NRO_INMUEBLE }},
                                            orientación <span>{{ property.ORIENTACION }}</span>.</p>
                                        <p><strong>Precios de estacionamientos desde UF 340 y de bodegas desde UF
                                            70.</strong></p>

                                        <div class="house-specs border-gray-bottom">
                                            <div class="spec-item">
                                                <img width="23" :src="publicPath + '/img/bed.svg'" alt=""
                                                     v-if="property.MODELO != 'LOCAL'">
                                                <span>{{ property.PROGRAMA[0] }} hab.</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                                <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="15" :src="publicPath + '/img/bathroom-icon.svg'" alt=""
                                                     v-if="property.MODELO != 'LOCAL'">
                                                <span>{{ property.PROGRAMA[3] }} baños</span>
                                            </div>

                                            <div class="spec-item">
                                                <img width="17.2" :src="publicPath + '/img/dimensions-icon.svg'" alt="">
                                                <a class="show-distribution-modal" href="#"
                                                   v-b-modal="'apartmentInfo' + property.NRO_INMUEBLE">Ver planta y
                                                    distrib.</a>

                                                <b-modal modal-class="model-info-Modal distribution-apartment-modal"
                                                         :id="'apartmentInfo' + property.NRO_INMUEBLE" hide-footer>
                                                    <b-button class="close custom-close" block
                                                              @click="$bvModal.hide('apartmentInfo' + property.NRO_INMUEBLE)">
                                                        <img :src="publicPath + '/img/close-icon.png'" alt="">
                                                    </b-button>
                                                    <div class="apartment-info-modal">
                                                        <div class="title-and-specs-info">
                                                            <div class="title-continer">
                                                                <p><strong>Departamento {{
                                                                    property.NRO_INMUEBLE
                                                                    }}</strong></p>
                                                                <p>
                                                                    <strong>UF {{
                                                                        priceFromApiFormatter(property.SIMULACION_20[0].PRECIO_INMUEBLE) |
                                                                            currency('', 0, {thousandsSeparator: '.'})
                                                                        }}
                                                                    </strong>
                                                                </p>
                                                            </div>

                                                            <div class="house-specs">
                                                                <div class="spec-item">
                                                                    <img width="23" :src="publicPath + '/img/bed.svg'"
                                                                         alt="">
                                                                    <span>{{ property.PROGRAMA[0] }} hab.</span>
                                                                </div>

                                                                <div class="spec-item">
                                                                    <img width="17.2"
                                                                         :src="publicPath + '/img/dimensions-icon.svg'"
                                                                         alt="">
                                                                    <span>{{ property.SUPERFICIE_UTIL }} mts 2</span>
                                                                </div>

                                                                <div class="spec-item">
                                                                    <img width="15"
                                                                         :src="publicPath + '/img/bathroom-icon.svg'"
                                                                         alt="">
                                                                    <span>{{ property.PROGRAMA[3] }} baños</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="description">
                                                            <p>Departamento {{ property.PROGRAMA[0] }} dormitorios,
                                                                Orientación {{
                                                                property.ORIENTACION
                                                                }}, Numeración {{ property.NRO_INMUEBLE }}, Opcional
                                                                estacionamiento.</p>
                                                        </div>

                                                        <img class="modal-image"
                                                             :src="publicPath + '/img/' + getImagesName(property.MODELO.toLowerCase().replace(/ /g, '-'))"
                                                             :alt="'Depto. ' + property.MODELO.toLowerCase().replace(/ /g, '-')">
                                                    </div>
                                                </b-modal>
                                            </div>
                                        </div>

                                        <div style="display: none" class="parking-select-container">
                                            <p class="mb-0"><strong>Adicionales</strong></p>
                                            <div v-if="!showParkingSelect" class="add-parking mb-3">
                                                <p class="mb-0">No tienes seleccionado ningun adicional como
                                                    estacionamiento</p>
                                                <a href="#" @click.prevent="addParking()"><img class="icon-arrow"
                                                                                               :src="publicPath + '/img/add-more-icon.png'"
                                                                                               alt=""> Agregar
                                                    estacionamiento</a>
                                            </div>

                                            <template v-if="showParkingSelect">
                                                <template v-if="!showParkingSelected">
                                                    <div class="parking-select">
                                                        <div class="mattasur-custom-select parking-type-select">
                                                            <a href="#" class="ms-option-selected"
                                                               @click.prevent="parkingTypeSelectOpen = !parkingTypeSelectOpen">
                                                                <p class="option-title">
                                                                    {{ parkingTypeSelected }}
                                                                </p>

                                                                <img class="icon-arrow"
                                                                     :src="publicPath + '/img/collapse-arrow-down.png'"
                                                                     alt="">
                                                            </a>

                                                            <ul class="ms-options-list" v-if="parkingTypeSelectOpen">
                                                                <li>
                                                                    <a href="#"
                                                                       @click.prevent="selectparkingType('Cubierto')">
                                                                        <p class="option-title">Cubierto</p>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="#"
                                                                       @click.prevent="selectparkingType('Descubierto')">
                                                                        <p class="option-title">Descubierto</p>
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                        </div>

                                                        <div class="mattasur-custom-select parking-list-select"
                                                             v-if="parkingTypeSelected !== 'Seleccionar'">
                                                            <a href="#" class="ms-option-selected"
                                                               @click.prevent="parkingSelectOpen = !parkingSelectOpen">
                                                                <p class="option-title">
                                                                    <strong>{{ parkingSelected }} <span
                                                                            class="text-uppercase"
                                                                            v-if="parkingSelected !== 'Seleccionar'">- UF {{
                                                                        parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                                        }}</span></strong>
                                                                </p>

                                                                <img class="icon-arrow"
                                                                     :src="publicPath + '/img/collapse-arrow-down.png'"
                                                                     alt="">
                                                            </a>

                                                            <ul class="ms-options-list" v-if="parkingSelectOpen">
                                                                <li v-for="(parking, index) in filteredParkingsList"
                                                                    :key="index">
                                                                    <a href="#"
                                                                       @click.prevent="selectparking(parking.NRO_ESTACIONAMIENTO, parking.PRECIO_LISTA, parking.ID_ESTACIONAMIENTO)">
                                                                        <p class="option-title">
                                                                            <strong>{{ parking.NRO_ESTACIONAMIENTO }} -
                                                                                UF {{
                                                                                parking.PRECIO_LISTA |
                                                                                    currency('', 0, {thousandsSeparator: '.'})
                                                                                }}</strong>
                                                                        </p>
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                        </div>
                                                    </div>

                                                    <h4 class="parking-price-value"
                                                        v-if="parkingSelected !== 'Seleccionar'">Valor {{
                                                        parkingSelectedPrice | currency('', 0, {thousandsSeparator: '.'})
                                                        }} UF</h4>

                                                    <div class="buttons-container add-parking-button-container">
                                                        <template v-if="showAddParkingLoader">
                                                            <div class="lds-loader">
                                                                <div style="background:#000;"></div>
                                                                <div style="background: #000;"></div>
                                                                <div style="background: #000;"></div>
                                                            </div>
                                                        </template>
                                                        <a href="#" v-else
                                                           @click.prevent="showParkingSelectedInfo(property.ID_INMUEBLE)"
                                                           :class="{disabled: parkingSelected === 'Seleccionar'}"
                                                           class="button-call-action button-yellow add-parking-button">Continuar</a>
                                                        <!--<a href="#" class="button-call-action button-outline">Reservar ahora</a>-->
                                                    </div>
                                                </template>

                                                <p v-if="showParkingSelected"><strong>Estacionamiento:</strong>
                                                    {{ parkingTypeSelected }} {{
                                                    parkingSelected
                                                    }}
                                                    <a href="#" @click.prevent="deleteParking()"><img
                                                            :src="publicPath + '/img/trash-icon.png'"
                                                            alt=""></a></p>
                                            </template>
                                        </div>

                                        <template v-if="showQuoteButton">
                                            <div class="buttons-container buttons-w-48">
                                                <button type="submit" @click="submitFunction('/reservar')"
                                                        class="button-call-action button-yellow">Reservar en linea
                                                </button>
                                                <button type="submit" @click="submitFunction('/cotizacion')"
                                                        class="button-call-action button-outline">Cotizar
                                                </button>
                                            </div>

                                            <div class="terms-info">
                                                *Valores aproximados calculados en base a UF al día de hoy (
                                                {{ dateToday }} ) y con un plazo de 25 años, con crédito aprobado y 20%
                                                de pie.
                                            </div>
                                        </template>
                                    </div>
                                </form>

                            </div>
                        </b-modal>
                    </template>
                </div>

            </template>

            <div class="project-info-sidebar desktop-sidebar">
                <div class="logo-container">
                    <a href="/">
                        <img :src="publicPath + '/img/logo-header.png'" alt="">
                    </a>
                </div>

                <ul class="info-items-container">
                    <li class="info-item">
                        <div class="project-info-title">
                            <h2>PROYECTO</h2>
                            <h1>{{ currentProject.PROYECTO }}</h1>
                            <span>{{ currentProject.COMUNA }}</span>

                            <!--              <p class="price-info item-with-icon" v-if="allProperties"><span class="icon-box"><img-->
                            <!--                      :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF {{ minPrice(allProperties) |-->
                            <!--                currency('', 0, { thousandsSeparator: '.' }) }}</p>-->

                            <p class="price-info item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/security-icon-dark.svg'" alt=""></span>Desde UF 3.044</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="property-counter-item">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/house-icon.svg'"
                                    alt=""></span>Deptos. disponibles</h3>
                            <span><strong>{{ properties.length }}</strong></span>
                        </div>

                        <!--            <div class="property-counter-item">-->
                        <!--              <p class="item-with-icon">Deptos. totales</p>-->
                        <!--              <span>{{ currentProject.NRO_INMUEBLES }}</span>-->
                        <!--            </div>-->
                    </li>

                    <li class="info-item">
                        <div class="mattasur-custom-select">
                            <h4>Selecciona el piso donde quieres tu departamento</h4>
                            <div class="mattasur-custom-select">
                                <a href="#" class="ms-option-selected" @click.prevent="openFloorSelect">
                                    <p class="option-title"><strong>Piso {{ floorSelected }}</strong></p>
                                    <span class="floor-info" v-if="floorSelected !== 'Selecciona el piso a revisar'">{{
                                        filteredApartments.length
                                        }}
                    departamentos desde <strong>{{
                                          minPrice(filteredApartments) | currency('', 0, {thousandsSeparator: '.'})
                                            }}</strong></span>

                                    <img class="icon-arrow pg-icon-arrow"
                                         :src="publicPath + '/img/collapse-arrow-down.png'" alt="">
                                </a>

                                <ul class="ms-options-list pg-select" v-if="floorSelectOpen">
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('1')">
                                            <p class="option-title"><strong>Piso 1</strong></p>
                                            <span class="floor-info">{{ floor1properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor1properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('2')">
                                            <p class="option-title"><strong>Piso 2</strong></p>
                                            <span class="floor-info">{{ floor2properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor2properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('3')">
                                            <p class="option-title"><strong>Piso 3</strong></p>
                                            <span class="floor-info">{{ floor3properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor3properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('4')">
                                            <p class="option-title"><strong>Piso 4</strong></p>
                                            <span class="floor-info">{{ floor4properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor4properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('5')">
                                            <p class="option-title"><strong>Piso 5</strong></p>
                                            <span class="floor-info">{{ floor5properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor5properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#" @click.prevent="selectFloor('6')">
                                            <p class="option-title"><strong>Piso 6</strong></p>
                                            <span class="floor-info">{{ floor6properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor6properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('7')">
                                            <p class="option-title"><strong>Piso 7</strong></p>
                                            <span class="floor-info">{{ floor7properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor7properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('8')">
                                            <p class="option-title"><strong>Piso 8</strong></p>
                                            <span class="floor-info">{{ floor8properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor8properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('9')">
                                            <p class="option-title"><strong>Piso 9</strong></p>
                                            <span class="floor-info">{{ floor9properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor9properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('10')">
                                            <p class="option-title"><strong>Piso 10</strong></p>
                                            <span class="floor-info">{{ floor10properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor10properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" @click.prevent="selectFloor('11')">
                                            <p class="option-title"><strong>Piso 11</strong></p>
                                            <span class="floor-info">{{ floor11properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor11properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#" @click.prevent="selectFloor('12')">
                                            <p class="option-title"><strong>Piso 12</strong></p>
                                            <span class="floor-info">{{ floor12properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor12properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#" @click.prevent="selectFloor('13')">
                                            <p class="option-title"><strong>Piso 13</strong></p>
                                            <span class="floor-info">{{ floor13properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor13properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#" @click.prevent="selectFloor('14')">
                                            <p class="option-title"><strong>Piso 14</strong></p>
                                            <span class="floor-info">{{ floor14properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor14properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="#" @click.prevent="selectFloor('15')">
                                            <p class="option-title"><strong>Piso 15</strong></p>
                                            <span class="floor-info">{{ floor15properties.length }}
                        departamentos desde <strong>{{
                                                  minPrice(floor15properties) | currency('', 0, {thousandsSeparator: '.'})
                                                    }}</strong></span>
                                        </a>
                                    </li>
                                </ul>

                            </div>

                        </div>

                        <div class="mattasur-custom-select">
                            <h4>Selecciona número de baños y habitaciones</h4>
                            <div class="mattasur-custom-select">
                                <a href="#" class="ms-option-selected" @click.prevent="openProgramSelect">
                                    <p class="option-title"><strong>{{
                                        programSelected === 'all' ? 'Selecciona una opción' : programSelected
                                        }}</strong></p>
                                    <img class="icon-arrow" :src="publicPath + '/img/collapse-arrow-down.png'" alt="">
                                </a>

                                <ul class="ms-options-list pg-select" v-if="programSelectOpen">
                                    <li v-if="programSelected !== 'all'">
                                        <a href="#" @click.prevent="selectProgram('all')">
                                            <p class="option-title"><strong>Mostrar todos</strong></p>
                                        </a>
                                    </li>

                                    <li v-for="(program, index) in filterProgram" :key="program + index">
                                        <a href="#"
                                           @click.prevent="selectProgram(program.toLowerCase().replace(/ /g, '-'))">
                                            <p class="option-title"><strong>{{ program }}</strong></p>
                                        </a>
                                    </li>
                                </ul>

                            </div>

                        </div>
                    </li>

                    <li class="info-item">
                        <div class="contact-info-container">
                            <h4>Horario de atención</h4>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/calendar-two-colors.svg'"
                                    alt=""></span>{{ currentProject.HORARIO_SEMANA }}
                            </p>
                            <p class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/location-icon-yellow.svg'"
                                    alt=""></span>{{ currentProject.DIRECCION }}</p>
                        </div>
                    </li>

                    <li class="info-item">
                        <div class="example-instruction-container">
                            <h3 class="item-with-icon"><span class="icon-box"><img
                                    :src="publicPath + '/img/money-icon-dark.svg'"
                                    alt=""></span>¿Cómo cotizo?</h3>
                            <div class="instruction-content">
                                <img :src="publicPath + '/img/dynnamic-map-indication.png'" alt="">
                                <div>
                                    <h4>Selecciona desde el mapa tu nuevo hogar</h4>

                                    <p>Haz click sobre la ubicación de la casa que te interesa para conocer detalles y
                                        cotización</p>
                                </div>
                            </div>
                        </div>

                    </li>

                    <li class="info-item">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=http://esepe.cl/proyecto/departamentos-puerto-montt"
                           target="_blank" class="item-with-icon share-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/share-icon-dark.svg'" alt=""></span>Compartir este proyecto</a>
                    </li>
                </ul>
            </div>

            <b-modal modal-class="sidebar-modal" id="projectModalInfo" hide-footer>
                <div class="project-info-sidebar mobile-sidebar" v-if="projectInfo">
                    <div class="logo-container">
                        <a href="/">
                            <img :src="publicPath + '/img/logo-header.png'" alt="">
                        </a>

                    </div>

                    <div class="mattasur-custom-select-container">
                        <h4>Selecciona el piso donde quieres tu departamento</h4>
                        <div class="mattasur-custom-select">
                            <a href="#" class="ms-option-selected"
                               :class="{'bg-white': floorSelected !== 'Selecciona el piso a revisar'}"
                               @click.prevent="floorSelectOpen = !floorSelectOpen">
                                <p class="option-title"><strong>{{ floorSelected }}</strong></p>
                                <span class="floor-info" v-if="floorSelected !== 'Selecciona el piso a revisar'">{{
                                    filteredApartments.length
                                    }}
                    departamentos desde <strong>{{
                                      minPrice(filteredApartments) | currency('', 0, {thousandsSeparator: '.'})
                                        }}</strong></span>

                                <img class="icon-arrow" :src="publicPath + '/img/collapse-arrow-down.png'" alt="">
                            </a>

                            <ul class="ms-options-list pg-select" v-if="floorSelectOpen">
                                <li>
                                    <a href="#" @click.prevent="selectFloor('1')">
                                        <p class="option-title"><strong>Piso 1</strong></p>
                                        <span class="floor-info">{{ floor1properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor1properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('2')">
                                        <p class="option-title"><strong>Piso 2</strong></p>
                                        <span class="floor-info">{{ floor2properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor2properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('3')">
                                        <p class="option-title"><strong>Piso 3</strong></p>
                                        <span class="floor-info">{{ floor3properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor3properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('4')">
                                        <p class="option-title"><strong>Piso 4</strong></p>
                                        <span class="floor-info">{{ floor4properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor4properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('5')">
                                        <p class="option-title"><strong>Piso 5</strong></p>
                                        <span class="floor-info">{{ floor5properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor5properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>

                                <li>
                                    <a href="#" @click.prevent="selectFloor('6')">
                                        <p class="option-title"><strong>Piso 6</strong></p>
                                        <span class="floor-info">{{ floor6properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor6properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('7')">
                                        <p class="option-title"><strong>Piso 7</strong></p>
                                        <span class="floor-info">{{ floor7properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor7properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('8')">
                                        <p class="option-title"><strong>Piso 8</strong></p>
                                        <span class="floor-info">{{ floor8properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor8properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('9')">
                                        <p class="option-title"><strong>Piso 9</strong></p>
                                        <span class="floor-info">{{ floor9properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor9properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('10')">
                                        <p class="option-title"><strong>Piso 10</strong></p>
                                        <span class="floor-info">{{ floor10properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor10properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click.prevent="selectFloor('11')">
                                        <p class="option-title"><strong>Piso 11</strong></p>
                                        <span class="floor-info">{{ floor11properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor11properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>

                                <li>
                                    <a href="#" @click.prevent="selectFloor('12')">
                                        <p class="option-title"><strong>Piso 12</strong></p>
                                        <span class="floor-info">{{ floor12properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor12properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>

                                <li>
                                    <a href="#" @click.prevent="selectFloor('13')">
                                        <p class="option-title"><strong>Piso 13</strong></p>
                                        <span class="floor-info">{{ floor13properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor13properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>

                                <li>
                                    <a href="#" @click.prevent="selectFloor('14')">
                                        <p class="option-title"><strong>Piso 14</strong></p>
                                        <span class="floor-info">{{ floor14properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor14properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>

                                <li>
                                    <a href="#" @click.prevent="selectFloor('15')">
                                        <p class="option-title"><strong>Piso 15</strong></p>
                                        <span class="floor-info">{{ floor15properties.length }}
                        departamentos desde <strong>{{
                                              minPrice(floor15properties) | currency('', 0, {thousandsSeparator: '.'})
                                                }}</strong></span>
                                    </a>
                                </li>
                            </ul>

                        </div>

                    </div>

                    <ul class="info-items-container">

                        <li class="info-item">
                            <div class="project-info-title">
                                <div>
                                    <h2>PROYECTO</h2>
                                    <h1>{{ currentProject.PROYECTO }}</h1>
                                    <span>{{ currentProject.COMUNA }}</span>
                                </div>

                                <div class="price">
                                    <span>Desde</span>
                                    <p class="price-info"><span>
                  <img :src="publicPath + '/img/security-icon-dark.svg'" alt="">
                  </span>UF {{ minPrice(properties) | currency('', 0, {thousandsSeparator: '.'}) }}
                                    </p>
                                </div>
                            </div>

                            <div class="property-counter-item">
                                <h3 class="item-with-icon"><span class="icon-box"><img
                                        :src="publicPath + '/img/house-icon.svg'"
                                        alt=""></span>Deptos. disponibles</h3>
                                <span><strong>{{ properties.length }}</strong></span>
                            </div>

                            <!--              <div class="property-counter-item">-->
                            <!--                <p class="item-with-icon">Deptos. totales</p>-->
                            <!--                <span>{{ currentProject.NRO_INMUEBLES }}</span>-->
                            <!--              </div>-->
                        </li>

                        <li class="info-item">
                            <div class="contact-info-container">
                                <h4>Horario de atención</h4>
                                <p class="item-with-icon"><span class="icon-box"><img
                                        :src="publicPath + '/img/calendar-two-colors.svg'"
                                        alt=""></span>{{ currentProject.HORARIO_SEMANA }}
                                </p>
                                <p class="item-with-icon"><span class="icon-box"><img
                                        :src="publicPath + '/img/location-icon-yellow.svg'"
                                        alt=""></span>{{ currentProject.DIRECCION }}</p>
                            </div>
                        </li>
                    </ul>
                    <div class="button-container">
                        <a href="https://www.facebook.com/sharer/sharer.php?u=http://esepe.cl/proyecto/casas-puente-alto"
                           target="_blank" class="share-icon"><span class="icon-box"><img
                                :src="publicPath + '/img/share-icon-dark.svg'" alt=""></span>Compartir este proyecto</a>

                        <b-button v-b-toggle.collapseContent
                                  class="button-call-action button-yellow"
                                  block @click="$bvModal.hide('projectModalInfo')">Cerrar
                        </b-button>
                    </div>
                </div>
            </b-modal>

            <b-modal ref="instructionModal" hide-footer modal-class="guide-modal" id="guideModal">
                <div class="guide-modal-content">
                    <div class="header-content">
                        <h3>IMPORTANTE</h3>
                        <img :src="publicPath + '/img/guide-img-pg.png'" alt="">
                    </div>
                    <div class="footer-content">
                        <div class="d-flex align-items-center text-info">
                            <img :src="publicPath + '/img/alert-dark-icon.png'" alt="">
                            <p>Posicionando el cursor por encima de cada uno de los círculos
                                negros de la vista, podrás acceder a más información sobre cada
                                uno de los departamentos, así como también cotizarlos o
                                reservarlos en línea. <a href="/como-reservar-o-cotizar/">Más información</a></p>
                        </div>
                        <b-button v-b-toggle.collapseContent
                                  class="button-call-action dark-btn"
                                  block @click="$bvModal.hide('guideModal')">¡Entendido!
                        </b-button>

                    </div>
                </div>
            </b-modal>

        </div>

        <div v-if="isMobile()" class="fixed-project-info">
            <div class="project-name">
                <h1>PROYECTO <strong>{{ currentProject.PROYECTO }}</strong></h1>
                <span>{{ currentProject.COMUNA }}</span>
            </div>

            <div class="mattasur-custom-select mb-4">
                <a href="#" class="ms-option-selected" @click.prevent="openFloorSelect">
                    <p class="option-title"><strong>Piso {{ floorSelected }}</strong></p>
                    <span class="floor-info"
                          v-if="floorSelected !== 'Selecciona el piso a revisar'">{{ filteredApartments.length }}
                    departamentos desde <strong>{{
                          minPrice(filteredApartments) | currency('', 0, {thousandsSeparator: '.'})
                            }}</strong></span>

                    <img class="icon-arrow pg-icon-arrow" :src="publicPath + '/img/collapse-arrow-down.png'" alt="">
                </a>

                <ul class="ms-options-list pg-select floor-options-list pg-program-select" v-if="floorSelectOpen">
                    <li>
                        <a href="#" @click.prevent="selectFloor('1')">
                            <p class="option-title"><strong>Piso 1</strong></p>
                            <span class="floor-info">{{ floor1properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor1properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('2')">
                            <p class="option-title"><strong>Piso 2</strong></p>
                            <span class="floor-info">{{ floor2properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor2properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('3')">
                            <p class="option-title"><strong>Piso 3</strong></p>
                            <span class="floor-info">{{ floor3properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor3properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('4')">
                            <p class="option-title"><strong>Piso 4</strong></p>
                            <span class="floor-info">{{ floor4properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor4properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('5')">
                            <p class="option-title"><strong>Piso 5</strong></p>
                            <span class="floor-info">{{ floor5properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor5properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>

                    <li>
                        <a href="#" @click.prevent="selectFloor('6')">
                            <p class="option-title"><strong>Piso 6</strong></p>
                            <span class="floor-info">{{ floor6properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor6properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('7')">
                            <p class="option-title"><strong>Piso 7</strong></p>
                            <span class="floor-info">{{ floor7properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor7properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('8')">
                            <p class="option-title"><strong>Piso 8</strong></p>
                            <span class="floor-info">{{ floor8properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor8properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('9')">
                            <p class="option-title"><strong>Piso 9</strong></p>
                            <span class="floor-info">{{ floor9properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor9properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('10')">
                            <p class="option-title"><strong>Piso 10</strong></p>
                            <span class="floor-info">{{ floor10properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor10properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="selectFloor('11')">
                            <p class="option-title"><strong>Piso 11</strong></p>
                            <span class="floor-info">{{ floor11properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor11properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>

                    <li>
                        <a href="#" @click.prevent="selectFloor('12')">
                            <p class="option-title"><strong>Piso 12</strong></p>
                            <span class="floor-info">{{ floor12properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor12properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>

                    <li>
                        <a href="#" @click.prevent="selectFloor('13')">
                            <p class="option-title"><strong>Piso 13</strong></p>
                            <span class="floor-info">{{ floor13properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor13properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>

                    <li>
                        <a href="#" @click.prevent="selectFloor('14')">
                            <p class="option-title"><strong>Piso 14</strong></p>
                            <span class="floor-info">{{ floor14properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor14properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>

                    <li>
                        <a href="#" @click.prevent="selectFloor('15')">
                            <p class="option-title"><strong>Piso 15</strong></p>
                            <span class="floor-info">{{ floor15properties.length }}
                        departamentos desde <strong>{{
                                  minPrice(floor15properties) | currency('', 0, {thousandsSeparator: '.'})
                                    }}</strong></span>
                        </a>
                    </li>
                </ul>

            </div>

            <div class="mattasur-custom-select">
                <h4>Selecciona número de baños y habitaciones</h4>
                <div class="mattasur-custom-select">
                    <a href="#" class="ms-option-selected" @click.prevent="openProgramSelect">
                        <p class="option-title">
                            <strong>{{ programSelected === 'all' ? 'Selecciona una opción' : programSelected }}</strong>
                        </p>
                        <img class="icon-arrow pg-icon-arrow" :src="publicPath + '/img/collapse-arrow-down.png'" alt="">
                    </a>

                    <ul class="ms-options-list pg-select pg-program-select" v-if="programSelectOpen">
                        <li v-if="programSelected !== 'all'">
                            <a href="#" @click.prevent="selectProgram('all')">
                                <p class="option-title"><strong>Mostrar todos</strong></p>
                            </a>
                        </li>

                        <li v-for="(program, index) in filterProgram" :key="program + index">
                            <a href="#" @click.prevent="selectProgram(program.toLowerCase().replace(/ /g, '-'))">
                                <p class="option-title"><strong>{{ program }}</strong></p>
                            </a>
                        </li>
                    </ul>

                </div>

            </div>
        </div>

    </div>

    <div v-else class="master-plan-page matta-sur-project"
         :class="{'loading-view': loading, 'default-view': floorSelected !== 'Selecciona el piso a revisar'}">
        <div>Error al cargar el mapa id: {{ projectId }}</div>
        <template v-if="loading">
            <div class="lds-loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </template>

    </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import mobileCheck from "@/mixins/mobileCheck";
// import Select2 from 'v-select2-component';

export default {
    components: {
        // Select2
    },
    data() {
        return {
            submitUrl: null,
            showQuoteLoader: false,
            showAddParkingLoader: false,
            instructionModalShown: false,

            propertyId: null,
            parkingId: null,

            apartmentTotalPrice: null,
            apartmentTotalPricePesos: null,
            dividendoTotalPrice: null,

            parkingData: null,

            showParkingSelect: false,

            showQuoteButton: true,

            showParkingSelected: false,

            floorSelectOpen: false,

            programSelectOpen: false,

            floorSelected: '1',

            programSelected: 'Selecciona una opción',

            parkingSelectOpen: false,

            parkingSelected: 'Seleccionar',
            parkingSelectedPrice: '',

            parkingTypeSelectOpen: false,

            parkingTypeSelected: 'Seleccionar',

            filteredParkingsList: [],

            loading: true,

            showUnavailableProperties: true,

            publicPath: '/wp-content/plugins/esepe-master-plan/dist',

            projectInfo: null,

            programaInfo: null,

            lastPropertySelected: '',

            filterSelected: 'all',

            showProjectModels: false,

            projectApiId: '',

            projectId: '',

            dateToday: '',

            sanFranciscoProperties: [
                {
                    modelCode: 'SF2-A36'
                },

                {
                    modelCode: 'SF2-A35'
                },

                {
                    modelCode: 'SF2-A34'
                },

                {
                    modelCode: 'SF2-A33'
                },

                {
                    modelCode: 'SF2-A32'
                },

                {
                    modelCode: 'SF2-A31'
                },

                {
                    modelCode: 'SF2-A30'
                },

                {
                    modelCode: 'SF2-A29'
                },

                {
                    modelCode: 'SF2-A28'
                },

                {
                    modelCode: 'SF2-A27'
                },

                {
                    modelCode: 'SF2-A26'
                },

                {
                    modelCode: 'SF2-A25'
                },

                {
                    modelCode: 'SF2-A24'
                },


                {
                    modelCode: 'SF2-D20'
                },

                {
                    modelCode: 'SF2-D19'
                },

                {
                    modelCode: 'SF2-D18'
                },

                {
                    modelCode: 'SF2-D17'
                },

                {
                    modelCode: 'SF2-D16'
                },

                {
                    modelCode: 'SF2-D15'
                },

                {
                    modelCode: 'SF2-D14'
                },

                {
                    modelCode: 'SF2-D13'
                },

                {
                    modelCode: 'SF2-D12'
                },

                {
                    modelCode: 'SF2-D11'
                },

                {
                    modelCode: 'SF2-D10'
                },

                {
                    modelCode: 'SF2-D09'
                },

                {
                    modelCode: 'SF2-D08'
                },

                {
                    modelCode: 'SF2-D07'
                },

                {
                    modelCode: 'SF2-D06'
                },

                {
                    modelCode: 'SF2-D05'
                },

                {
                    modelCode: 'SF2-D04'
                },

                {
                    modelCode: 'SF2-D03'
                },

                {
                    modelCode: 'SF2-D02'
                },

                {
                    modelCode: 'SF2-D01'
                },


                {
                    modelCode: 'SF2-G01'
                },

                {
                    modelCode: 'SF2-G02'
                },

                {
                    modelCode: 'SF2-G03'
                },

                {
                    modelCode: 'SF2-G04'
                },

                {
                    modelCode: 'SF2-G05'
                },

                {
                    modelCode: 'SF2-G06'
                },

                {
                    modelCode: 'SF2-G07'
                },

                {
                    modelCode: 'SF2-G08'
                },

                {
                    modelCode: 'SF2-G09'
                },

                {
                    modelCode: 'SF2-G10'
                },

                {
                    modelCode: 'SF2-G11'
                },

                {
                    modelCode: 'SF2-G12'
                },

                {
                    modelCode: 'SF2-G13'
                },

                {
                    modelCode: 'SF2-G14'
                },

                {
                    modelCode: 'SF2-G15'
                },

                {
                    modelCode: 'SF2-G16'
                },

                {
                    modelCode: 'SF2-G17'
                },

                {
                    modelCode: 'SF2-G18'
                },

                {
                    modelCode: 'SF2-G19'
                },

                {
                    modelCode: 'SF2-G20'
                },

                {
                    modelCode: 'SF2-G21'
                },

                {
                    modelCode: 'SF2-G22'
                },

                {
                    modelCode: 'SF2-G23'
                },

                {
                    modelCode: 'SF2-G24'
                },


                {
                    modelCode: 'SF2-A70'
                },

                {
                    modelCode: 'SF2-A71'
                },

                {
                    modelCode: 'SF2-A72'
                },

                {
                    modelCode: 'SF2-A73'
                },

                {
                    modelCode: 'SF2-A74'
                },

                {
                    modelCode: 'SF2-A75'
                },

                //Propiedades Etapa 1://///////////

                {
                    modelCode: 'SF1-A23'
                },

                {
                    modelCode: 'SF1-A22'
                },

                {
                    modelCode: 'SF1-A21'
                },

                {
                    modelCode: 'SF1-A20'
                },

                {
                    modelCode: 'SF1-A19'
                },

                {
                    modelCode: 'SF1-A18'
                },

                {
                    modelCode: 'SF1-A17'
                },

                {
                    modelCode: 'SF1-A16'
                },

                {
                    modelCode: 'SF1-A15'
                },

                {
                    modelCode: 'SF1-A14'
                },

                {
                    modelCode: 'SF1-A13'
                },

                {
                    modelCode: 'SF1-A12'
                },

                {
                    modelCode: 'SF1-A11'
                },

                {
                    modelCode: 'SF1-A10'
                },

                {
                    modelCode: 'SF1-A09'
                },

                {
                    modelCode: 'SF1-A08'
                },

                {
                    modelCode: 'SF1-A07'
                },

                {
                    modelCode: 'SF1-A06'
                },

                {
                    modelCode: 'SF1-A05'
                },

                {
                    modelCode: 'SF1-A04'
                },

                {
                    modelCode: 'SF1-A03'
                },

                {
                    modelCode: 'SF1-A02'
                },

                {
                    modelCode: 'SF1-A01'
                },


                {
                    modelCode: 'SF1-C13'
                },

                {
                    modelCode: 'SF1-C12'
                },

                {
                    modelCode: 'SF1-C11'
                },

                {
                    modelCode: 'SF1-C10'
                },

                {
                    modelCode: 'SF1-C09'
                },

                {
                    modelCode: 'SF1-C08'
                },

                {
                    modelCode: 'SF1-C07'
                },

                {
                    modelCode: 'SF1-C06'
                },

                {
                    modelCode: 'SF1-C05'
                },

                {
                    modelCode: 'SF1-C04'
                },

                {
                    modelCode: 'SF1-C03'
                },

                {
                    modelCode: 'SF1-C02'
                },

                {
                    modelCode: 'SF1-C01'
                },


                {
                    modelCode: 'SF1-F01'
                },

                {
                    modelCode: 'SF1-F02'
                },

                {
                    modelCode: 'SF1-F03'
                },

                {
                    modelCode: 'SF1-F04'
                },

                {
                    modelCode: 'SF1-F05'
                },

                {
                    modelCode: 'SF1-F06'
                },

                {
                    modelCode: 'SF1-F07'
                },

                {
                    modelCode: 'SF1-F08'
                },

                {
                    modelCode: 'SF1-F09'
                },

                {
                    modelCode: 'SF1-F10'
                },

                {
                    modelCode: 'SF1-F11'
                },

                {
                    modelCode: 'SF1-F12'
                },

                {
                    modelCode: 'SF1-F13'
                },

                {
                    modelCode: 'SF1-F14'
                },

                {
                    modelCode: 'SF1-F15'
                },

                {
                    modelCode: 'SF1-F16'
                },

                {
                    modelCode: 'SF1-F17'
                },

                {
                    modelCode: 'SF1-F18'
                },

                {
                    modelCode: 'SF1-F19'
                },

                {
                    modelCode: 'SF1-F20'
                },

                {
                    modelCode: 'SF1-F21'
                },

                {
                    modelCode: 'SF1-F22'
                },

                {
                    modelCode: 'SF1-F23'
                },

                {
                    modelCode: 'SF1-F24'
                },


                {
                    modelCode: 'SF1-A76'
                },

                {
                    modelCode: 'SF1-A77'
                },

                {
                    modelCode: 'SF1-A78'
                },

                {
                    modelCode: 'SF1-A79'
                },

                {
                    modelCode: 'SF1-A80'
                },

                {
                    modelCode: 'SF1-A81'
                },

                // Etapa 3 //

                {
                    modelCode: 'SF3-E01'
                },

                {
                    modelCode: 'SF3-E02'
                },

                {
                    modelCode: 'SF3-E03'
                },

                {
                    modelCode: 'SF3-E04'
                },

                {
                    modelCode: 'SF3-E05'
                },

                {
                    modelCode: 'SF3-E06'
                },

                {
                    modelCode: 'SF3-E07'
                },

                {
                    modelCode: 'SF3-E08'
                },

                {
                    modelCode: 'SF3-E09'
                },

                {
                    modelCode: 'SF3-E10'
                },

                {
                    modelCode: 'SF3-E11'
                },

                {
                    modelCode: 'SF3-E12'
                },

                {
                    modelCode: 'SF3-E13'
                },

                {
                    modelCode: 'SF3-E14'
                },

                {
                    modelCode: 'SF3-E15'
                },

                {
                    modelCode: 'SF3-E16'
                },

                {
                    modelCode: 'SF3-E17'
                },

                {
                    modelCode: 'SF3-E18'
                },

                {
                    modelCode: 'SF3-E19'
                },

                {
                    modelCode: 'SF3-E20'
                },

                {
                    modelCode: 'SF3-E21'
                },

                {
                    modelCode: 'SF3-E22'
                },

                {
                    modelCode: 'SF3-E23'
                },

                {
                    modelCode: 'SF3-E24'
                },


                {
                    modelCode: 'SF3-H01'
                },

                {
                    modelCode: 'SF3-H02'
                },

                {
                    modelCode: 'SF3-H03'
                },

                {
                    modelCode: 'SF3-H04'
                },

                {
                    modelCode: 'SF3-H05'
                },

                {
                    modelCode: 'SF3-H06'
                },

                {
                    modelCode: 'SF3-H07'
                },

                {
                    modelCode: 'SF3-H08'
                },

                {
                    modelCode: 'SF3-H09'
                },

                {
                    modelCode: 'SF3-H10'
                },

                {
                    modelCode: 'SF3-H11'
                },

                {
                    modelCode: 'SF3-H12'
                },

                {
                    modelCode: 'SF3-H13'
                },

                {
                    modelCode: 'SF3-H14'
                },

                {
                    modelCode: 'SF3-H15'
                },

                {
                    modelCode: 'SF3-H16'
                },

                {
                    modelCode: 'SF3-H17'
                },

                {
                    modelCode: 'SF3-H18'
                },

                {
                    modelCode: 'SF3-H19'
                },

                {
                    modelCode: 'SF3-H20'
                },

                {
                    modelCode: 'SF3-H21'
                },

                {
                    modelCode: 'SF3-H22'
                },

                {
                    modelCode: 'SF3-H23'
                },

                {
                    modelCode: 'SF3-H24'
                },


                {
                    modelCode: 'SF3-A37'
                },

                {
                    modelCode: 'SF3-A38'
                },

                {
                    modelCode: 'SF3-A39'
                },

                {
                    modelCode: 'SF3-A40'
                },

                {
                    modelCode: 'SF3-A41'
                },

                {
                    modelCode: 'SF3-A42'
                },

                {
                    modelCode: 'SF3-A43'
                },

                {
                    modelCode: 'SF3-A44'
                },

                {
                    modelCode: 'SF3-A45'
                },

                {
                    modelCode: 'SF3-A46'
                },

                {
                    modelCode: 'SF3-A47'
                },

                {
                    modelCode: 'SF3-A48'
                },

                {
                    modelCode: 'SF3-A49'
                },

                {
                    modelCode: 'SF3-A50'
                },

                {
                    modelCode: 'SF3-A51'
                },

                {
                    modelCode: 'SF3-A52'
                },

                {
                    modelCode: 'SF3-A53'
                },

                {
                    modelCode: 'SF3-A54'
                },

                {
                    modelCode: 'SF3-A55'
                },

                {
                    modelCode: 'SF3-A56'
                },

                {
                    modelCode: 'SF3-A57'
                },

                {
                    modelCode: 'SF3-A58'
                },

                {
                    modelCode: 'SF3-A59'
                },

                {
                    modelCode: 'SF3-A60'
                },

                {
                    modelCode: 'SF3-A61'
                },

                {
                    modelCode: 'SF3-A62'
                },

                {
                    modelCode: 'SF3-A63'
                },

                {
                    modelCode: 'SF3-A64'
                },

                {
                    modelCode: 'SF3-A65'
                },

                {
                    modelCode: 'SF3-A66'
                },

                {
                    modelCode: 'SF3-A67'
                },

                {
                    modelCode: 'SF3-A68'
                },

                {
                    modelCode: 'SF3-A69'
                },


                {
                    modelCode: 'SF3-A127'
                },

                {
                    modelCode: 'SF3-A128'
                },

                {
                    modelCode: 'SF3-A129'
                },

                {
                    modelCode: 'SF3-A130'
                },

                {
                    modelCode: 'SF3-A131'
                },

                {
                    modelCode: 'SF3-A132'
                },


            ],

            altosValleProperties: [

                {
                    modelCode: 'AV1-B01'
                },

                {
                    modelCode: 'AV1-B02'
                },

                {
                    modelCode: 'AV1-B03'
                },

                {
                    modelCode: 'AV1-B04'
                },

                {
                    modelCode: 'AV1-B05'
                },

                {
                    modelCode: 'AV1-B06'
                },

                {
                    modelCode: 'AV1-B07'
                },

                {
                    modelCode: 'AV1-B08'
                },

                {
                    modelCode: 'AV1-B09'
                },

                {
                    modelCode: 'AV1-B10'
                },

                {
                    modelCode: 'AV1-B11'
                },

                {
                    modelCode: 'AV1-B12'
                },

                {
                    modelCode: 'AV1-B13'
                },

                {
                    modelCode: 'AV1-B14'
                },

                {
                    modelCode: 'AV1-B15'
                },

                {
                    modelCode: 'AV1-B16'
                },

                {
                    modelCode: 'AV1-B17'
                },

                {
                    modelCode: 'AV1-B18'
                },

                {
                    modelCode: 'AV1-B19'
                },

                {
                    modelCode: 'AV1-B20'
                },

                {
                    modelCode: 'AV1-B21'
                },

                {
                    modelCode: 'AV1-B22'
                },

                {
                    modelCode: 'AV1-B23'
                },

                {
                    modelCode: 'AV1-B24'
                },


                {
                    modelCode: 'AV1-B25'
                },

                {
                    modelCode: 'AV1-B26'
                },

                {
                    modelCode: 'AV1-B27'
                },

                {
                    modelCode: 'AV1-B28'
                },

                {
                    modelCode: 'AV1-B29'
                },

                {
                    modelCode: 'AV1-B30'
                },

                {
                    modelCode: 'AV1-B31'
                },

                {
                    modelCode: 'AV1-B32'
                },

                {
                    modelCode: 'AV1-B33'
                },

                {
                    modelCode: 'AV1-B34'
                },

                {
                    modelCode: 'AV1-B35'
                },

                {
                    modelCode: 'AV1-B36'
                },

                {
                    modelCode: 'AV1-B37'
                },

                {
                    modelCode: 'AV1-B38'
                },

                {
                    modelCode: 'AV1-B39'
                },

                {
                    modelCode: 'AV1-B40'
                },

                {
                    modelCode: 'AV1-B41'
                },

                {
                    modelCode: 'AV1-B42'
                },

                {
                    modelCode: 'AV1-B43'
                },

                {
                    modelCode: 'AV1-B44'
                },

                {
                    modelCode: 'AV1-B45'
                },

                {
                    modelCode: 'AV1-B46'
                },


                {
                    modelCode: 'AV1-C01'
                },

                {
                    modelCode: 'AV1-C02'
                },

                {
                    modelCode: 'AV1-C03'
                },

                {
                    modelCode: 'AV1-C04'
                },

                {
                    modelCode: 'AV1-C05'
                },

                {
                    modelCode: 'AV1-C06'
                },

                {
                    modelCode: 'AV1-C07'
                },

                {
                    modelCode: 'AV1-C08'
                },

                {
                    modelCode: 'AV1-C09'
                },

                {
                    modelCode: 'AV1-C10'
                },

                {
                    modelCode: 'AV1-C11'
                },

                {
                    modelCode: 'AV1-C12'
                },

                {
                    modelCode: 'AV1-C13'
                },

                {
                    modelCode: 'AV1-C14'
                },

                {
                    modelCode: 'AV1-C15'
                },

                {
                    modelCode: 'AV1-C16'
                },

                {
                    modelCode: 'AV1-C17'
                },

                {
                    modelCode: 'AV1-C18'
                },

                {
                    modelCode: 'AV1-C19'
                },

                {
                    modelCode: 'AV1-C20'
                },


                {
                    modelCode: 'AV2-A01'
                },

                {
                    modelCode: 'AV2-A02'
                },

                {
                    modelCode: 'AV2-A03'
                },

                {
                    modelCode: 'AV2-A04'
                },

                {
                    modelCode: 'AV2-A05'
                },

                {
                    modelCode: 'AV2-A06'
                },

                {
                    modelCode: 'AV2-A07'
                },

                {
                    modelCode: 'AV2-A08'
                },

                {
                    modelCode: 'AV2-A09'
                },

                {
                    modelCode: 'AV2-A10'
                },

                {
                    modelCode: 'AV2-A11'
                },

                {
                    modelCode: 'AV2-A12'
                },


                {
                    modelCode: 'AV2-D01'
                },

                {
                    modelCode: 'AV2-D02'
                },

                {
                    modelCode: 'AV2-D03'
                },

                {
                    modelCode: 'AV2-D04'
                },

                {
                    modelCode: 'AV2-D05'
                },

                {
                    modelCode: 'AV2-D06'
                },

                {
                    modelCode: 'AV2-D07'
                },

                {
                    modelCode: 'AV2-D08'
                },

                {
                    modelCode: 'AV2-D09'
                },

                {
                    modelCode: 'AV2-D10'
                },

                {
                    modelCode: 'AV2-D11'
                },

                {
                    modelCode: 'AV2-D12'
                },

                {
                    modelCode: 'AV2-D13'
                },

                {
                    modelCode: 'AV2-D14'
                },

                {
                    modelCode: 'AV2-D15'
                },

                {
                    modelCode: 'AV2-D16'
                },


                {
                    modelCode: 'AV2-E01'
                },

                {
                    modelCode: 'AV2-E02'
                },

                {
                    modelCode: 'AV2-E03'
                },

                {
                    modelCode: 'AV2-E04'
                },

                {
                    modelCode: 'AV2-E05'
                },

                {
                    modelCode: 'AV2-E06'
                },

                {
                    modelCode: 'AV2-E07'
                },

                {
                    modelCode: 'AV2-E08'
                },

                {
                    modelCode: 'AV2-E09'
                },

                {
                    modelCode: 'AV2-E10'
                },

                {
                    modelCode: 'AV2-E11'
                },

                {
                    modelCode: 'AV2-E12'
                },


                {
                    modelCode: 'AV2-D17'
                },

                {
                    modelCode: 'AV2-D18'
                },

                {
                    modelCode: 'AV2-D31'
                },

                {
                    modelCode: 'AV2-D32'
                },

                {
                    modelCode: 'AV2-D33'
                },

                {
                    modelCode: 'AV2-D34'
                },


                {
                    modelCode: 'AV2-C85'
                },

                {
                    modelCode: 'AV2-C86'
                },

                {
                    modelCode: 'AV2-C87'
                },

                {
                    modelCode: 'AV2-C88'
                },

                {
                    modelCode: 'AV2-C89'
                },

                {
                    modelCode: 'AV2-C90'
                },


                //Propiedades Etapa 3://///////////


                {
                    modelCode: 'AV3-D19'
                },

                {
                    modelCode: 'AV3-D20'
                },

                {
                    modelCode: 'AV3-D21'
                },

                {
                    modelCode: 'AV3-D22'
                },

                {
                    modelCode: 'AV3-D23'
                },

                {
                    modelCode: 'AV3-D24'
                },

                {
                    modelCode: 'AV3-D25'
                },

                {
                    modelCode: 'AV3-D26'
                },

                {
                    modelCode: 'AV3-D27'
                },

                {
                    modelCode: 'AV3-D28'
                },

                {
                    modelCode: 'AV3-D29'
                },

                {
                    modelCode: 'AV3-D30'
                },


                {
                    modelCode: 'AV3-E13'
                },

                {
                    modelCode: 'AV3-E14'
                },

                {
                    modelCode: 'AV3-E15'
                },

                {
                    modelCode: 'AV3-E16'
                },

                {
                    modelCode: 'AV3-E17'
                },

                {
                    modelCode: 'AV3-E18'
                },

                {
                    modelCode: 'AV3-E19'
                },

                {
                    modelCode: 'AV3-E20'
                },

                {
                    modelCode: 'AV3-E21'
                },

                {
                    modelCode: 'AV3-E22'
                },

                {
                    modelCode: 'AV3-E23'
                },

                {
                    modelCode: 'AV3-E24'
                },

                {
                    modelCode: 'AV3-E25'
                },

                {
                    modelCode: 'AV3-E26'
                },

                {
                    modelCode: 'AV3-E27'
                },

                {
                    modelCode: 'AV3-E28'
                },

                {
                    modelCode: 'AV3-E29'
                },

                {
                    modelCode: 'AV3-E30'
                },

                {
                    modelCode: 'AV3-E31'
                },

                {
                    modelCode: 'AV3-E32'
                },

                {
                    modelCode: 'AV3-E33'
                },

                {
                    modelCode: 'AV3-E34'
                },

                {
                    modelCode: 'AV3-E35'
                },

                {
                    modelCode: 'AV3-E36'
                },

                {
                    modelCode: 'AV3-E37'
                },

                {
                    modelCode: 'AV3-E38'
                },

                {
                    modelCode: 'AV3-E39'
                },

                {
                    modelCode: 'AV3-E40'
                },

                {
                    modelCode: 'AV3-E41'
                },

                {
                    modelCode: 'AV3-E42'
                },

                {
                    modelCode: 'AV3-E43'
                },

                {
                    modelCode: 'AV3-E44'
                },

                {
                    modelCode: 'AV3-E45'
                },

                {
                    modelCode: 'AV3-E46'
                },

                {
                    modelCode: 'AV3-E47'
                },

                {
                    modelCode: 'AV3-E48'
                },


                {
                    modelCode: 'AV3-E49'
                },

                {
                    modelCode: 'AV3-E50'
                },

                {
                    modelCode: 'AV3-E51'
                },

                {
                    modelCode: 'AV3-E52'
                },

                {
                    modelCode: 'AV3-E53'
                },

                {
                    modelCode: 'AV3-E54'
                },

                {
                    modelCode: 'AV3-E55'
                },

                {
                    modelCode: 'AV3-E56'
                },

                {
                    modelCode: 'AV3-E57'
                },

                {
                    modelCode: 'AV3-E58'
                },

                {
                    modelCode: 'AV3-E59'
                },

                {
                    modelCode: 'AV3-E60'
                },

                {
                    modelCode: 'AV3-E61'
                },

                {
                    modelCode: 'AV3-E62'
                },

                {
                    modelCode: 'AV3-E63'
                },

                {
                    modelCode: 'AV3-E64'
                },

                {
                    modelCode: 'AV3-E65'
                },

                {
                    modelCode: 'AV3-E66'
                },


                {
                    modelCode: 'AV3-C21'
                },

                {
                    modelCode: 'AV3-C22'
                },

                {
                    modelCode: 'AV3-C23'
                },

                {
                    modelCode: 'AV3-C24'
                },

                {
                    modelCode: 'AV3-C25'
                },

                {
                    modelCode: 'AV3-C26'
                },

                {
                    modelCode: 'AV3-C27'
                },

                {
                    modelCode: 'AV3-C28'
                },

                {
                    modelCode: 'AV3-C29'
                },

                {
                    modelCode: 'AV3-C30'
                },

                {
                    modelCode: 'AV3-C31'
                },

                {
                    modelCode: 'AV3-C32'
                },

                {
                    modelCode: 'AV3-C33'
                },

                {
                    modelCode: 'AV3-C34'
                },

                {
                    modelCode: 'AV3-C35'
                },

                {
                    modelCode: 'AV3-C36'
                },

                {
                    modelCode: 'AV3-C37'
                },

                {
                    modelCode: 'AV3-C38'
                },

                {
                    modelCode: 'AV3-C39'
                },

                {
                    modelCode: 'AV3-C40'
                },

                {
                    modelCode: 'AV3-C41'
                },

                {
                    modelCode: 'AV3-C42'
                },

                {
                    modelCode: 'AV3-C43'
                },

                {
                    modelCode: 'AV3-C44'
                },

                {
                    modelCode: 'AV3-C45'
                },

                {
                    modelCode: 'AV3-C46'
                },

                {
                    modelCode: 'AV3-C47'
                },

                {
                    modelCode: 'AV3-C48'
                },

                {
                    modelCode: 'AV3-C49'
                },

                {
                    modelCode: 'AV3-C50'
                },

                {
                    modelCode: 'AV3-C51'
                },

                {
                    modelCode: 'AV3-C52'
                },

                {
                    modelCode: 'AV3-C53'
                },

                {
                    modelCode: 'AV3-C54'
                },

                {
                    modelCode: 'AV3-C55'
                },

                {
                    modelCode: 'AV3-C56'
                },

                {
                    modelCode: 'AV3-C57'
                },

                {
                    modelCode: 'AV3-C58'
                },

                {
                    modelCode: 'AV3-C59'
                },

                {
                    modelCode: 'AV3-C60'
                },

                {
                    modelCode: 'AV3-C61'
                },

                {
                    modelCode: 'AV3-C62'
                },

                {
                    modelCode: 'AV3-C63'
                },

                {
                    modelCode: 'AV3-C64'
                },

                {
                    modelCode: 'AV3-C65'
                },

                {
                    modelCode: 'AV3-C66'
                },

                {
                    modelCode: 'AV3-C67'
                },

                {
                    modelCode: 'AV3-C68'
                },

                {
                    modelCode: 'AV3-C69'
                },

                {
                    modelCode: 'AV3-C70'
                },

                {
                    modelCode: 'AV3-C71'
                },

                {
                    modelCode: 'AV3-C72'
                },

                {
                    modelCode: 'AV3-C73'
                },

                {
                    modelCode: 'AV3-C74'
                },

                {
                    modelCode: 'AV3-C75'
                },

                {
                    modelCode: 'AV3-C76'
                },

                {
                    modelCode: 'AV3-C77'
                },

                {
                    modelCode: 'AV3-C78'
                },

                {
                    modelCode: 'AV3-C79'
                },

                {
                    modelCode: 'AV3-C80'
                },

                {
                    modelCode: 'AV3-C81'
                },

                {
                    modelCode: 'AV3-C82'
                },

                {
                    modelCode: 'AV3-C83'
                },

                {
                    modelCode: 'AV3-C84'
                },


            ],
            altosVallePropertiesEtapa4: [
                // ETAPA 4:

                {
                    modelCode: 'AV4-G01'
                },

                {
                    modelCode: 'AV4-G02'
                },

                {
                    modelCode: 'AV4-G03'
                },

                {
                    modelCode: 'AV4-G04'
                },

                {
                    modelCode: 'AV4-G05'
                },

                {
                    modelCode: 'AV4-G06'
                },

                {
                    modelCode: 'AV4-G07'
                },

                {
                    modelCode: 'AV4-G08'
                },

                {
                    modelCode: 'AV4-G09'
                },

                {
                    modelCode: 'AV4-G10'
                },

                {
                    modelCode: 'AV4-G11'
                },

                {
                    modelCode: 'AV4-G12'
                },

                {
                    modelCode: 'AV4-G13'
                },

                {
                    modelCode: 'AV4-G14'
                },

                {
                    modelCode: 'AV4-G15'
                },

                {
                    modelCode: 'AV4-G16'
                },

                {
                    modelCode: 'AV4-G17'
                },

                {
                    modelCode: 'AV4-G18'
                },

                {
                    modelCode: 'AV4-G19'
                },

                {
                    modelCode: 'AV4-G20'
                },

                {
                    modelCode: 'AV4-G21'
                },

                {
                    modelCode: 'AV4-G22'
                },

                {
                    modelCode: 'AV4-G23'
                },

                {
                    modelCode: 'AV4-G24'
                },

                {
                    modelCode: 'AV4-G25'
                },

                {
                    modelCode: 'AV4-G26'
                },

                {
                    modelCode: 'AV4-G27'
                },

                {
                    modelCode: 'AV4-G28'
                },

                {
                    modelCode: 'AV4-G29'
                },

                {
                    modelCode: 'AV4-G30'
                },

                //////

                {
                    modelCode: 'AV4-K01'
                },

                {
                    modelCode: 'AV4-K02'
                },

                {
                    modelCode: 'AV4-K03'
                },

                {
                    modelCode: 'AV4-K04'
                },

                {
                    modelCode: 'AV4-K05'
                },

                {
                    modelCode: 'AV4-K06'
                },

                {
                    modelCode: 'AV4-K07'
                },

                {
                    modelCode: 'AV4-K08'
                },

                {
                    modelCode: 'AV4-K09'
                },

                {
                    modelCode: 'AV4-K10'
                },

                {
                    modelCode: 'AV4-K11'
                },

                {
                    modelCode: 'AV4-K12'
                },

                {
                    modelCode: 'AV4-K13'
                },

                {
                    modelCode: 'AV4-K14'
                },

                {
                    modelCode: 'AV4-K15'
                },

                {
                    modelCode: 'AV4-K16'
                },

                {
                    modelCode: 'AV4-K17'
                },

                {
                    modelCode: 'AV4-K18'
                },

                {
                    modelCode: 'AV4-K19'
                },

                {
                    modelCode: 'AV4-K20'
                },

                //////

                {
                    modelCode: 'AV4-L01'
                },

                {
                    modelCode: 'AV4-L02'
                },

                {
                    modelCode: 'AV4-L03'
                },

                {
                    modelCode: 'AV4-L04'
                },

                {
                    modelCode: 'AV4-L05'
                },

                {
                    modelCode: 'AV4-L06'
                },

                {
                    modelCode: 'AV4-L07'
                },

                {
                    modelCode: 'AV4-L08'
                },

                {
                    modelCode: 'AV4-L09'
                },

                {
                    modelCode: 'AV4-L10'
                },

                {
                    modelCode: 'AV4-L11'
                },

                {
                    modelCode: 'AV4-L12'
                },

                {
                    modelCode: 'AV4-L13'
                },

                {
                    modelCode: 'AV4-L14'
                },

                {
                    modelCode: 'AV4-L15'
                },

                {
                    modelCode: 'AV4-L16'
                },

                {
                    modelCode: 'AV4-L17'
                },

                {
                    modelCode: 'AV4-L18'
                },

                {
                    modelCode: 'AV4-L19'
                },

                {
                    modelCode: 'AV4-L20'
                },


            ],

            mattaSurFloor0: [
                {
                    modelCode: '001'
                },
                {
                    modelCode: '002'
                },
                {
                    modelCode: '003'
                },
                {
                    modelCode: '004'
                },
                {
                    modelCode: '005'
                },
                {
                    modelCode: '006'
                },
                {
                    modelCode: '007'
                },
            ],
            mattaSurFloor1: [
                {
                    modelCode: '101'
                },

                {
                    modelCode: '102'
                },

                {
                    modelCode: '103'
                },

                {
                    modelCode: '104'
                },

                {
                    modelCode: '105'
                },

                {
                    modelCode: '106'
                },

                {
                    modelCode: '107'
                },

                {
                    modelCode: '108'
                },

                {
                    modelCode: '109'
                },

                {
                    modelCode: '110'
                },

                {
                    modelCode: '111'
                },

                {
                    modelCode: '112'
                }
            ],
            mattaSurFloor2: [
                {
                    modelCode: '201'
                },

                {
                    modelCode: '202'
                },

                {
                    modelCode: '203'
                },

                {
                    modelCode: '204'
                },

                {
                    modelCode: '205'
                },

                {
                    modelCode: '206'
                },

                {
                    modelCode: '207'
                },

                {
                    modelCode: '208'
                },

                {
                    modelCode: '209'
                },

                {
                    modelCode: '210'
                },

                {
                    modelCode: '211'
                },

                {
                    modelCode: '212'
                }
            ],
            mattaSurFloor3: [
                {
                    modelCode: '301'
                },

                {
                    modelCode: '302'
                },

                {
                    modelCode: '303'
                },

                {
                    modelCode: '304'
                },

                {
                    modelCode: '305'
                },

                {
                    modelCode: '306'
                },

                {
                    modelCode: '307'
                },

                {
                    modelCode: '308'
                },

                {
                    modelCode: '309'
                },

                {
                    modelCode: '310'
                },

                {
                    modelCode: '311'
                },

                {
                    modelCode: '312'
                }
            ],
            mattaSurFloor4: [
                {
                    modelCode: '401'
                },

                {
                    modelCode: '402'
                },

                {
                    modelCode: '403'
                },

                {
                    modelCode: '404'
                },

                {
                    modelCode: '405'
                },

                {
                    modelCode: '406'
                },

                {
                    modelCode: '407'
                },

                {
                    modelCode: '408'
                },

                {
                    modelCode: '409'
                },

                {
                    modelCode: '410'
                },

                {
                    modelCode: '411'
                },

                {
                    modelCode: '412'
                }
            ],
            mattaSurFloor5: [
                {
                    modelCode: '501'
                },

                {
                    modelCode: '502'
                },

                {
                    modelCode: '503'
                },

                {
                    modelCode: '504'
                },

                {
                    modelCode: '505'
                },

                {
                    modelCode: '506'
                },

                {
                    modelCode: '507'
                },

                {
                    modelCode: '508'
                },

                {
                    modelCode: '509'
                },

                {
                    modelCode: '510'
                },

                {
                    modelCode: '511'
                },

                {
                    modelCode: '512'
                }
            ],

            bvcProperties: [

                // Etapa: 1
                {
                    modelCode: 'BVC1-A21'
                },
                {
                    modelCode: 'BVC1-A22'
                },
                {
                    modelCode: 'BVC1-A23'
                },
                {
                    modelCode: 'BVC1-A24'
                },
                {
                    modelCode: 'BVC1-A25'
                },
                {
                    modelCode: 'BVC1-A26'
                },
                {
                    modelCode: 'BVC1-A27'
                },
                {
                    modelCode: 'BVC1-A28'
                },
                {
                    modelCode: 'BVC1-A29'
                },
                {
                    modelCode: 'BVC1-A30'
                },
                {
                    modelCode: 'BVC1-A31'
                },
                {
                    modelCode: 'BVC1-A32'
                },
                {
                    modelCode: 'BVC1-D03'
                },

                {
                    modelCode: 'BVC1-D04'
                },

                {
                    modelCode: 'BVC1-D25'
                },

                {
                    modelCode: 'BVC1-D26'
                },

                {
                    modelCode: 'BVC1-D27'
                },

                {
                    modelCode: 'BVC1-D28'
                },

                {
                    modelCode: 'BVC1-D31'
                },

                {
                    modelCode: 'BVC1-D32'
                },

                {
                    modelCode: 'BVC1-D35'
                },

                {
                    modelCode: 'BVC1-D36'
                },

                {
                    modelCode: 'BVC1-D39'
                },

                {
                    modelCode: 'BVC1-D40'
                },

                {
                    modelCode: 'BVC1-D43'
                },

                {
                    modelCode: 'BVC1-D44'
                },

                {
                    modelCode: 'BVC1-D47'
                },

                {
                    modelCode: 'BVC1-D48'
                },

                {
                    modelCode: 'BVC1-D49'
                },

                {
                    modelCode: 'BVC1-D50'
                },

                {
                    modelCode: 'BVC1-D53'
                },

                {
                    modelCode: 'BVC1-D54'
                },

                {
                    modelCode: 'BVC1-D57'
                },

                {
                    modelCode: 'BVC1-D58'
                },

                {
                    modelCode: 'BVC1-D61'
                },

                {
                    modelCode: 'BVC1-D62'
                },

                {
                    modelCode: 'BVC1-D65'
                },

                {
                    modelCode: 'BVC1-D66'
                },

                {
                    modelCode: 'BVC1-D69'
                },

                {
                    modelCode: 'BVC1-D70'
                },

                // Etapa: 2

                {
                    modelCode: 'BVC2-A17'
                },

                {
                    modelCode: 'BVC2-A18'
                },

                {
                    modelCode: 'BVC2-A19'
                },

                {
                    modelCode: 'BVC2-A20'
                },

                {
                    modelCode: 'BVC2-C01'
                },

                {
                    modelCode: 'BVC2-C02'
                },

                {
                    modelCode: 'BVC2-C03'
                },

                {
                    modelCode: 'BVC2-C04'
                },

                {
                    modelCode: 'BVC2-C05'
                },

                {
                    modelCode: 'BVC2-C06'
                },

                {
                    modelCode: 'BVC2-C07'
                },

                {
                    modelCode: 'BVC2-C08'
                },

                {
                    modelCode: 'BVC2-C09'
                },

                {
                    modelCode: 'BVC2-C10'
                },

                {
                    modelCode: 'BVC2-C11'
                },

                {
                    modelCode: 'BVC2-C12'
                },

                {
                    modelCode: 'BVC2-D01'
                },

                {
                    modelCode: 'BVC2-D02'
                },

                {
                    modelCode: 'BVC2-D05'
                },

                {
                    modelCode: 'BVC2-D06'
                },

                {
                    modelCode: 'BVC2-D07'
                },

                {
                    modelCode: 'BVC2-D08'
                },

                {
                    modelCode: 'BVC2-D09'
                },

                {
                    modelCode: 'BVC2-D10'
                },

                {
                    modelCode: 'BVC2-D11'
                },

                {
                    modelCode: 'BVC2-D12'
                },

                {
                    modelCode: 'BVC2-D13'
                },

                {
                    modelCode: 'BVC2-D14'
                },

                {
                    modelCode: 'BVC2-D15'
                },

                {
                    modelCode: 'BVC2-D16'
                },

                {
                    modelCode: 'BVC2-D17'
                },

                {
                    modelCode: 'BVC2-D18'
                },

                {
                    modelCode: 'BVC2-D19'
                },

                {
                    modelCode: 'BVC2-D20'
                },

                {
                    modelCode: 'BVC2-D21'
                },

                {
                    modelCode: 'BVC2-D22'
                },

                {
                    modelCode: 'BVC2-D23'
                },

                {
                    modelCode: 'BVC2-D24'
                },

                {
                    modelCode: 'BVC2-D29'
                },

                {
                    modelCode: 'BVC2-D30'
                },

                {
                    modelCode: 'BVC2-D33'
                },

                {
                    modelCode: 'BVC2-D34'
                },

                {
                    modelCode: 'BVC2-D37'
                },

                {
                    modelCode: 'BVC2-D38'
                },

                {
                    modelCode: 'BVC2-D41'
                },

                {
                    modelCode: 'BVC2-D42'
                },

                {
                    modelCode: 'BVC2-D45'
                },

                {
                    modelCode: 'BVC2-D46'
                },

                {
                    modelCode: 'BVC2-F03'
                },

                {
                    modelCode: 'BVC2-F04'
                },

                {
                    modelCode: 'BVC2-F21'
                },

                {
                    modelCode: 'BVC2-F22'
                },

                {
                    modelCode: 'BVC2-F23'
                },

                {
                    modelCode: 'BVC2-F24'
                },

                {
                    modelCode: 'BVC2-F41'
                },

                {
                    modelCode: 'BVC2-F42'
                },

                {
                    modelCode: 'BVC2-F43'
                },

                {
                    modelCode: 'BVC2-F44'
                },

                // Etapa 3:

                {
                    modelCode: 'BVC3-H01'
                },

                {
                    modelCode: 'BVC3-H02'
                },

                {
                    modelCode: 'BVC3-H03'
                },

                {
                    modelCode: 'BVC3-H04'
                },

                {
                    modelCode: 'BVC3-H05'
                },

                {
                    modelCode: 'BVC3-H06'
                },

                {
                    modelCode: 'BVC3-F01'
                },

                {
                    modelCode: 'BVC3-F02'
                },

                {
                    modelCode: 'BVC3-F05'
                },

                {
                    modelCode: 'BVC3-F06'
                },

                {
                    modelCode: 'BVC3-F07'
                },

                {
                    modelCode: 'BVC3-F08'
                },

                {
                    modelCode: 'BVC3-F09'
                },

                {
                    modelCode: 'BVC3-F10'
                },

                {
                    modelCode: 'BVC3-F11'
                },

                {
                    modelCode: 'BVC3-F12'
                },

                {
                    modelCode: 'BVC3-F13'
                },

                {
                    modelCode: 'BVC3-F14'
                },

                {
                    modelCode: 'BVC3-F15'
                },

                {
                    modelCode: 'BVC3-F16'
                },

                {
                    modelCode: 'BVC3-F17'
                },

                {
                    modelCode: 'BVC3-F18'
                },

                {
                    modelCode: 'BVC3-F19'
                },

                {
                    modelCode: 'BVC3-F20'
                },

                {
                    modelCode: 'BVC3-F25'
                },

                {
                    modelCode: 'BVC3-F26'
                },

                {
                    modelCode: 'BVC3-F27'
                },

                {
                    modelCode: 'BVC3-F28'
                },

                {
                    modelCode: 'BVC3-F29'
                },

                {
                    modelCode: 'BVC3-F30'
                },

                {
                    modelCode: 'BVC3-F31'
                },

                {
                    modelCode: 'BVC3-F32'
                },

                {
                    modelCode: 'BVC3-F33'
                },

                {
                    modelCode: 'BVC3-F34'
                },

                {
                    modelCode: 'BVC3-F35'
                },

                {
                    modelCode: 'BVC3-F36'
                },

                {
                    modelCode: 'BVC3-F37'
                },

                {
                    modelCode: 'BVC3-F38'
                },

                {
                    modelCode: 'BVC3-F39'
                },

                {
                    modelCode: 'BVC3-F40'
                },

                {
                    modelCode: 'BVC3-F45'
                },

                {
                    modelCode: 'BVC3-F46'
                },

                {
                    modelCode: 'BVC3-F47'
                },

                {
                    modelCode: 'BVC3-F48'
                },

                {
                    modelCode: 'BVC3-F49'
                },

                {
                    modelCode: 'BVC3-F50'
                },

                {
                    modelCode: 'BVC3-F51'
                },

                {
                    modelCode: 'BVC3-F52'
                },

                {
                    modelCode: 'BVC3-F53'
                },

                {
                    modelCode: 'BVC3-F54'
                },

                {
                    modelCode: 'BVC3-F55'
                },

                {
                    modelCode: 'BVC3-F56'
                },

                {
                    modelCode: 'BVC3-F57'
                },

                {
                    modelCode: 'BVC3-F58'
                },

                {
                    modelCode: 'BVC3-F59'
                },

                {
                    modelCode: 'BVC3-F60'
                },

            ],

            pgFloor1: [
                {
                    modelCode: 'local-1'
                },

                {
                    modelCode: 'local-2'
                },

                {
                    modelCode: 'local-3'
                },

                {
                    modelCode: 'local-4'
                },

                {
                    modelCode: 'local-5'
                },

                {
                    modelCode: 'local-6'
                },

                {
                    modelCode: 'local-7'
                },

                {
                    modelCode: 'local-8'
                },

                {
                    modelCode: 'local-9'
                }
            ],
            pgFloor2: [
                {
                    modelCode: '205'
                },

                {
                    modelCode: '206'
                },

                {
                    modelCode: '207'
                },

                {
                    modelCode: '208'
                },

                {
                    modelCode: '209'
                },

                {
                    modelCode: '211'
                },

                {
                    modelCode: '212'
                },

                {
                    modelCode: '213'
                },

                {
                    modelCode: '214'
                },

                {
                    modelCode: '215'
                }
            ],
            pgFloor3: [
                {
                    modelCode: '305'
                },

                {
                    modelCode: '306'
                },

                {
                    modelCode: '307'
                },

                {
                    modelCode: '308'
                },

                {
                    modelCode: '309'
                },

                {
                    modelCode: '310'
                },

                {
                    modelCode: '311'
                },

                {
                    modelCode: '312'
                },

                {
                    modelCode: '313'
                },

                {
                    modelCode: '314'
                },

                {
                    modelCode: '315'
                }
            ],
            pgFloor4: [
                {
                    modelCode: '405'
                },

                {
                    modelCode: '406'
                },

                {
                    modelCode: '407'
                },

                {
                    modelCode: '408'
                },

                {
                    modelCode: '409'
                },

                {
                    modelCode: '410'
                },

                {
                    modelCode: '411'
                },

                {
                    modelCode: '412'
                },

                {
                    modelCode: '413'
                },

                {
                    modelCode: '414'
                },

                {
                    modelCode: '415'
                },

            ],
            pgFloor5: [
                {
                    modelCode: '505'
                },

                {
                    modelCode: '506'
                },

                {
                    modelCode: '507'
                },

                {
                    modelCode: '508'
                },

                {
                    modelCode: '509'
                },

                {
                    modelCode: '510'
                },

                {
                    modelCode: '511'
                },

                {
                    modelCode: '512'
                },

                {
                    modelCode: '513'
                },

                {
                    modelCode: '514'
                },

                {
                    modelCode: '515'
                },
            ],
            pgFloor6: [
                {
                    modelCode: '601'
                },

                {
                    modelCode: '602'
                },

                {
                    modelCode: '603'
                },

                {
                    modelCode: '604'
                },

                {
                    modelCode: '605'
                },

                {
                    modelCode: '606'
                },

                {
                    modelCode: '607'
                },

                {
                    modelCode: '608'
                },

                {
                    modelCode: '609'
                },

                {
                    modelCode: '610'
                },

                {
                    modelCode: '611'
                },

                {
                    modelCode: '612'
                },

                {
                    modelCode: '613'
                },

                {
                    modelCode: '614'
                },

                {
                    modelCode: '615'
                },

                {
                    modelCode: '616'
                },

                {
                    modelCode: '617'
                },

                {
                    modelCode: '618'
                },
            ],
            pgFloor7: [
                {
                    modelCode: '701'
                },

                {
                    modelCode: '702'
                },

                {
                    modelCode: '703'
                },

                {
                    modelCode: '704'
                },

                {
                    modelCode: '705'
                },

                {
                    modelCode: '706'
                },

                {
                    modelCode: '707'
                },

                {
                    modelCode: '708'
                },

                {
                    modelCode: '709'
                },

                {
                    modelCode: '710'
                },

                {
                    modelCode: '711'
                },

                {
                    modelCode: '712'
                },

                {
                    modelCode: '713'
                },

                {
                    modelCode: '714'
                },

                {
                    modelCode: '715'
                },

                {
                    modelCode: '716'
                },

                {
                    modelCode: '717'
                },

                {
                    modelCode: '718'
                },
            ],
            pgFloor8: [
                {
                    modelCode: '801'
                },

                {
                    modelCode: '802'
                },

                {
                    modelCode: '803'
                },

                {
                    modelCode: '804'
                },

                {
                    modelCode: '805'
                },

                {
                    modelCode: '806'
                },

                {
                    modelCode: '807'
                },

                {
                    modelCode: '808'
                },

                {
                    modelCode: '809'
                },

                {
                    modelCode: '810'
                },

                {
                    modelCode: '811'
                },

                {
                    modelCode: '812'
                },

                {
                    modelCode: '813'
                },

                {
                    modelCode: '814'
                },

                {
                    modelCode: '815'
                },

                {
                    modelCode: '816'
                },

                {
                    modelCode: '817'
                },

                {
                    modelCode: '818'
                },
            ],
            pgFloor9: [
                {
                    modelCode: '901'
                },

                {
                    modelCode: '902'
                },

                {
                    modelCode: '903'
                },

                {
                    modelCode: '904'
                },

                {
                    modelCode: '907'
                },

                {
                    modelCode: '908'
                },

                {
                    modelCode: '909'
                },

                {
                    modelCode: '910'
                },

                {
                    modelCode: '911'
                },

                {
                    modelCode: '912'
                },

                {
                    modelCode: '913'
                },

                {
                    modelCode: '914'
                },

                {
                    modelCode: '915'
                },

                {
                    modelCode: '916'
                },

                {
                    modelCode: '917'
                },

                {
                    modelCode: '918'
                },
            ],
            pgFloor10: [
                {
                    modelCode: '1001'
                },

                {
                    modelCode: '1002'
                },

                {
                    modelCode: '1003'
                },

                {
                    modelCode: '1007'
                },

                {
                    modelCode: '1008'
                },

                {
                    modelCode: '1009'
                },

                {
                    modelCode: '1010'
                },

                {
                    modelCode: '1011'
                },

                {
                    modelCode: '1012'
                },

                {
                    modelCode: '1013'
                },

                {
                    modelCode: '1014'
                },

                {
                    modelCode: '1015'
                },

                {
                    modelCode: '1016'
                },

                {
                    modelCode: '1017'
                },

                {
                    modelCode: '1018'
                },
            ],
            pgFloor11: [
                {
                    modelCode: '1101'
                },

                {
                    modelCode: '1102'
                },

                {
                    modelCode: '1103'
                },

                {
                    modelCode: '1107'
                },

                {
                    modelCode: '1108'
                },

                {
                    modelCode: '1109'
                },

                {
                    modelCode: '1110'
                },

                {
                    modelCode: '1111'
                },

                {
                    modelCode: '1112'
                },

                {
                    modelCode: '1113'
                },

                {
                    modelCode: '1116'
                },

                {
                    modelCode: '1117'
                },

                {
                    modelCode: '1118'
                },
            ],
            pgFloor12: [
                {
                    modelCode: '1201'
                },

                {
                    modelCode: '1202'
                },

                {
                    modelCode: '1203'
                },

                {
                    modelCode: '1207'
                },

                {
                    modelCode: '1208'
                },

                {
                    modelCode: '1209'
                },

                {
                    modelCode: '1210'
                },

                {
                    modelCode: '1211'
                },

                {
                    modelCode: '1212'
                },

                {
                    modelCode: '1213'
                },

                {
                    modelCode: '1217'
                },

                {
                    modelCode: '1218'
                },
            ],
            pgFloor13: [
                {
                    modelCode: '1301'
                },

                {
                    modelCode: '1302'
                },

                {
                    modelCode: '1303'
                },

                {
                    modelCode: '1307'
                },

                {
                    modelCode: '1308'
                },

                {
                    modelCode: '1309'
                },

                {
                    modelCode: '1310'
                },

                {
                    modelCode: '1311'
                },

                {
                    modelCode: '1312'
                },

                {
                    modelCode: '1313'
                },

                {
                    modelCode: '1317'
                },

                {
                    modelCode: '1318'
                },
            ],
            pgFloor14: [
                {
                    modelCode: '1401'
                },

                {
                    modelCode: '1402'
                },

                {
                    modelCode: '1403'
                },

                {
                    modelCode: '1407'
                },

                {
                    modelCode: '1408'
                },

                {
                    modelCode: '1409'
                },

                {
                    modelCode: '1410'
                },

                {
                    modelCode: '1411'
                },

                {
                    modelCode: '1412'
                },

                {
                    modelCode: '1413'
                },

                {
                    modelCode: '1417'
                },

                {
                    modelCode: '1418'
                },
            ],
            pgFloor15: [
                {
                    modelCode: '1501'
                },

                {
                    modelCode: '1502'
                },

                {
                    modelCode: '1503'
                },

                {
                    modelCode: '1507'
                },

                {
                    modelCode: '1508'
                },

                {
                    modelCode: '1509'
                },

                {
                    modelCode: '1510'
                },

                {
                    modelCode: '1511'
                },

                {
                    modelCode: '1512'
                },

                {
                    modelCode: '1513'
                },

                {
                    modelCode: '1517'
                },

                {
                    modelCode: '1518'
                },
            ],
            allProperties: null
        }
    },

    mixins: [
        mobileCheck
    ],

    computed: {
        filteredProperties() {
            if (this.projectInfo) {

                let inmueblesArray = '';

                if (this.projectId === '33583') {
                    inmueblesArray = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.ETAPA === '4');

                } else if (this.projectId === '805') {
                    inmueblesArray = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.ETAPA !== '4');
                } else {
                    inmueblesArray = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES;

                }

                if (this.filterSelected !== 'all') {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.showUnavailableProperties = false;
                    return inmueblesArray.filter(property => property.MODELO === this.filterSelected)

                } else {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.showUnavailableProperties = true;
                    return inmueblesArray;
                }
            } else {
                return []
            }
        },

        filteredApartments() {

            if (this.projectInfo) {
                let filteredProperties;

                if (this.filterSelected !== 'all') {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.showUnavailableProperties = false;
                    filteredProperties = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.PROGRAMA.toLowerCase().replace(/ /g, '-') === this.filterSelected);

                } else {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.showUnavailableProperties = true;
                    filteredProperties = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES
                }
                let floorSelected = this.floorSelected;

                switch (floorSelected) {
                    case "1" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === 'L');
                    case "2" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '2');
                    case "3" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '3');
                    case "4" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '4');
                    case "5" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '5');
                    case "6" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '6');
                    case "7" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '7');
                    case "8" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '8');
                    case "9" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '9');
                    case "10" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '0');
                    case "11" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '1');
                    case "12" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '2');
                    case "13" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '3');
                    case "14" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '4');
                    case "15" :
                        return filteredProperties.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '5');
                    default :
                        return [];
                }
            } else {
                return []
            }

        },

        filterProgram() {
            if (this.projectInfo) {
                let filteredProgramaArray;
                let programFilteredByFloor;
                let programNamesArray;
                let programaArray = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.map(property => ({
                    program: property.PROGRAMA,
                    floor: property.PISO
                }));
                console.log('programaArray: ', programaArray)
                let floorSelected = this.floorSelected;
                switch (floorSelected) {
                    case "1" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '1')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "2" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '2')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "3" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '3')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "4" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '4')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "5" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '5')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];

                        console.log('programFilteredByFloor: ', programFilteredByFloor)
                        console.log('programNamesArray: ', programNamesArray)
                        console.log('filteredProgramaArray: ', filteredProgramaArray)

                        return filteredProgramaArray;

                    case "6" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '6')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "7" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '7')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "8" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '8')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "9" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '9')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "10" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '10')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "11" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '11')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "12" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '12')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "13" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '1')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "14" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '14')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;

                    case "15" :
                        programFilteredByFloor = programaArray.filter(property => property.floor === '15')
                        programNamesArray = programFilteredByFloor.map(property => property.program);
                        filteredProgramaArray = [...new Set(programNamesArray)];
                        return filteredProgramaArray;
                    default :
                        return [];
                }

            } else {
                return []
            }

        },

        filteredParkings(parkingType) {
            if (this.projectInfo) {
                if (this.parkingTypeSelected !== 'Seleccionar') {
                    return this.projectInfo.DATA.PROYECTOS[0].ESTACIONAMIENTOS.ESTACIONAMIENTO.filter(parking => parking.UBICACION === parkingType)
                } else {
                    return this.projectInfo.DATA.PROYECTOS[0].ESTACIONAMIENTOS.ESTACIONAMIENTO
                }

            } else {
                return []
            }
        },

        luxModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'SF75');
            } else {
                return []
            }
        },
        terraModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'SF90');
            } else {
                return []
            }
        },
        aquaModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'SF100');
            } else {
                return []
            }
        },

        calbucoModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'Calbuco-AV09');
            } else {
                return []
            }
        },
        osornoModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'Osorno-AV07');
            } else {
                return []
            }
        },
        lonquimayModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'Lonquimay-AV03');
            } else {
                return []
            }
        },
        llaimaModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'Llaima-AV08');
            } else {
                return []
            }
        },
        sanJoseModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'SanJose-AV10');
            } else {
                return []
            }
        },

        barrenoModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'Barreno');
            } else {
                return []
            }
        },
        mayalModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'Mayal');
            } else {
                return []
            }
        },
        legonModelproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO === 'Legón');
            } else {
                return []
            }
        },
        tipoAproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO.toLowerCase().replace(/ /g, '-') === 'tipo-a');
            } else {
                return []
            }
        },
        tipoBproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO.toLowerCase().replace(/ /g, '-') === 'tipo-b');
            } else {
                return []
            }
        },
        tipoCproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO.toLowerCase().replace(/ /g, '-') === 'tipo-c');
            } else {
                return []
            }
        },
        tipoDproperties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.MODELO.toLowerCase().replace(/ /g, '-') === 'tipo-d');
            } else {
                return []
            }
        },

        // floor0properties() {
        //
        //     if (this.projectInfo) {
        //         return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '0');
        //     } else {
        //         return []
        //     }
        // },
        floor1properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === 'L');
            } else {
                return []
            }
        },
        floor2properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '2');
            } else {
                return []
            }
        },
        floor3properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '3');
            } else {
                return []
            }
        },
        floor4properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '4');
            } else {
                return []
            }
        },
        floor5properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '5');
            } else {
                return []
            }
        },
        floor6properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '6');
            } else {
                return []
            }
        },
        floor7properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '7');
            } else {
                return []
            }
        },
        floor8properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '8');
            } else {
                return []
            }
        },
        floor9properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '9');
            } else {
                return []
            }
        },
        floor10properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '0');
            } else {
                return []
            }
        },
        floor11properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '1');
            } else {
                return []
            }
        },
        floor12properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '2');
            } else {
                return []
            }
        },
        floor13properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '3');
            } else {
                return []
            }
        },
        floor14properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '4');
            } else {
                return []
            }
        },
        floor15properties() {

            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.NRO_INMUEBLE[0] === '1' && property.NRO_INMUEBLE[1] === '5');
            } else {
                return []
            }
        },

        currentProject() {
            if (this.projectInfo) {
                return this.projectInfo.DATA.PROYECTOS[0]
            } else {
                return null
            }
        },

        properties() {
            if (this.projectInfo) {
                let inmueblesArray = '';

                if (this.projectId === '33583') {
                    inmueblesArray = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.ETAPA === '4');
                } else if (this.projectId === '805') {
                    inmueblesArray = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.filter(property => property.ETAPA !== '4');
                } else {
                    inmueblesArray = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES;
                }

                console.log('projectInfo: ', this.projectInfo);
                console.log('data: ', inmueblesArray);
                return inmueblesArray;
            } else {
                return []
            }
        },
    },

    methods: {

        convertToSlug(texto) {
            // Convierte a minúsculas
            texto = texto.toLowerCase();

            // Reemplaza la "ñ" por "n"
            texto = texto.replace(/ñ/g, 'n');

            // Reemplaza espacios en blanco con guiones
            texto = texto.replace(/\s+/g, '-');

            // Elimina caracteres no deseados usando una expresión regular
            texto = texto.replace(/[^a-z0-9\-]/g, '');

            return texto;
        },

        submitFunction(url) {
            this.submitUrl = url;
        },

        parkingPricePesos(propertySelectedPrice) {
            return this.apartmentTotalPricePesos - propertySelectedPrice;
        },

        scrollWin() {

            let w = this.$refs.pointsContainer.offsetWidth / 2;

            this.$refs.masterPlanContainer.scroll(w, 0);
        },

        scrollWinDefaultView() {

            let w = this.$refs.defaultView.offsetWidth / 2;

            this.$refs.masterPlanContainer.scroll(w, 0);
        },

        async getParkingData(propertyId) {

            return await axios.post(
                dcms_vars.ajaxurl,
                qs.stringify({action: 'get_parking_data', IdInmueble: propertyId, IdEstacionamiento: this.parkingId}),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })


        },

        // closePropertyModal(){
        //
        //     this.deleteParking()
        // },

        addParking() {
            this.showParkingSelect = true;
            this.showQuoteButton = false;

        },

        async showParkingSelectedInfo(propertyId) {

            this.showAddParkingLoader = true;

            let res = await this.getParkingData(propertyId);

            this.parkingData = res.data;

            if (this.parkingData) {
                this.apartmentTotalPrice = this.parkingData.SIMULACIONES.SIMULACION_30[0].PRECIO_INMUEBLE;
                this.apartmentTotalPricePesos = parseInt(this.parkingData.SIMULACIONES.SIMULACION_30[1].PRECIO_INMUEBLE);
                this.dividendoTotalPrice = this.parkingData.SIMULACIONES.SIMULACION_30[1].VALOR_DIVIDENDO;
            }

            this.showParkingSelected = true;
            this.showQuoteButton = true;
        },

        deleteParking() {
            this.showAddParkingLoader = false;
            this.parkingSelected = 'Seleccionar';
            this.parkingTypeSelected = 'Seleccionar';
            this.showParkingSelect = false;
            this.showParkingSelected = false;
            this.apartmentTotalPrice = null;
            this.showQuoteButton = true;
        },

        selectFloor(floor) {
            this.floorSelected = floor;
            this.floorSelectOpen = false;
            this.deleteParking()
            this.selectProgram('all')
        },
        selectProgram(program) {
            this.changeFilterSelected(program);
            this.programSelected = program;
            this.programSelectOpen = false;
            this.deleteParking()
        },
        openFloorSelect() {
            this.floorSelectOpen = !this.floorSelectOpen;
            this.programSelectOpen = false;
        },
        openProgramSelect() {
            this.programSelectOpen = !this.programSelectOpen;
            this.floorSelectOpen = false;
        },

        selectparkingType(parkingType) {
            this.parkingTypeSelected = parkingType;
            this.parkingTypeSelectOpen = false;
            this.parkingSelected = 'Seleccionar';

            if (this.projectInfo) {
                this.filteredParkingsList = this.projectInfo.DATA.PROYECTOS[0].ESTACIONAMIENTOS.ESTACIONAMIENTO.filter(parking => parking.UBICACION === parkingType)
            }
        },

        selectparking(parkingNumber, parkingPrice, parkingId) {
            this.parkingId = parkingId;
            this.parkingSelected = parkingNumber;
            this.parkingSelectedPrice = parkingPrice;
            this.parkingSelectOpen = false;
        },

        myChangeEvent(val) {
            console.log(val);
        },
        mySelectEvent({id, text}) {
            console.log({id, text})
        },

        priceFromApiFormatter(priceValue) {
            // var formattedPrice = priceValue.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
            let formattedPrice = priceValue.toString();
            return parseInt(formattedPrice.substring(0, formattedPrice.length - 3));
        },

        discountFormatted(value) {
            return value.substring(0, value.length - 1);
        },

        minPrice(properties) {

            if (properties && properties.length) {

                // let allPrices = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.map(property => property.PROGRAMA );
                // this.programaInfo = [...new Set(programaArray)];

                let priceProperty = properties.reduce((prev, curr) => prev.PRECIO_LISTA < curr.PRECIO_LISTA ? prev : curr).PRECIO_LISTA;
                // var formattedValue = priceProperty.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");

                priceProperty.substring(0, priceProperty.length - 3);

                return parseInt(priceProperty, 10);
            }
            return 0
        },

        getModelName(modelCode) {
            if (modelCode === 'SF100') {
                return 'Aqua'
            } else if (modelCode === 'SF90') {
                return 'Terra'
            } else if (modelCode === 'SF75') {
                return 'Lux'
            } else if (modelCode === 'Calbuco-AV09') {
                return 'Calbuco'
            } else if (modelCode === 'Osorno-AV07') {
                return 'Osorno'
            } else if (modelCode === 'Lonquimay-AV03') {
                return 'Lonquimay'
            } else if (modelCode === 'Llaima-AV08') {
                return 'Llaima'
            } else if (modelCode === 'SanJose-AV10') {
                return 'San José'
            } else if (modelCode === 'TIPO A') {
                return 'Tipo A'
            } else if (modelCode === 'TIPO B') {
                return 'Tipo B'
            } else if (modelCode === 'TIPO C') {
                return 'Tipo C'
            }
        },

        getModelSlug(modelCode) {
            if (modelCode === 'SF100') {
                return 'Aqua'
            } else if (modelCode === 'SF90') {
                return 'Terra'
            } else if (modelCode === 'SF75') {
                return 'Lux'
            } else if (modelCode === 'Calbuco-AV09') {
                return 'Calbuco'
            } else if (modelCode === 'Osorno-AV07') {
                return 'Osorno'
            } else if (modelCode === 'Lonquimay-AV03') {
                return 'Lonquimay'
            } else if (modelCode === 'Llaima-AV08') {
                return 'Llaima'
            } else if (modelCode === 'SanJose-AV10') {
                return 'San José'
            }
        },

        getImagesName(modelCode) {
            if (modelCode === 'SF100') {
                return 'SF100.jpg'
            } else if (modelCode === 'SF90') {
                return 'SF90.jpg'
            } else if (modelCode === 'SF75') {
                return 'SF75.jpg'
            } else if (modelCode === 'Calbuco-AV09') {
                return 'calbuco.jpg'
            } else if (modelCode === 'Osorno-AV07') {
                return 'osorno.jpg'
            } else if (modelCode === 'Lonquimay-AV03') {
                return 'lonquimay.jpg'
            } else if (modelCode === 'Llaima-AV08') {
                return 'llaima.jpg'
            } else if (modelCode === 'SanJose-AV10') {
                return 'san-jose.jpg'
            } else if (modelCode === 'tipo-a') {
                return 'tipo-a.jpg'
            } else if (modelCode === 'tipo-b') {
                return 'tipo-b.jpg'
            } else if (modelCode === 'tipo-c') {
                return 'tipo-c.jpg'
            } else if (modelCode === 'tipo-d') {
                return 'tipo-d.png'
            } else if (modelCode === 'Barreno') {
                return 'Barreno.jpg'
            } else if (modelCode === 'Legón') {
                return 'Legón.jpg'
            } else if (modelCode === 'Mayal') {
                return 'Mayal.jpg'
            } else if (modelCode === 'A') {
                return 'Planta_A.jpg'
            } else if (modelCode === 'A1') {
                return 'Planta_A1.jpg'
            } else if (modelCode === 'A2') {
                return 'Planta_A2.jpg'
            } else if (modelCode === 'A4') {
                return 'Planta_A4.jpg'
            } else if (modelCode === 'A5') {
                return 'Planta_A5.jpg'
            } else if (modelCode === 'A6') {
                return 'Planta_A6.jpg'
            } else if (modelCode === 'B') {
                return 'Planta_B.jpg'
            } else if (modelCode === 'B1') {
                return 'Planta_B1.jpg'
            } else if (modelCode === 'C') {
                return 'Planta_C.jpg'
            } else if (modelCode === 'D') {
                return 'Planta_D.jpg'
            } else if (modelCode === 'E') {
                return 'Planta_E.jpg'
            } else if (modelCode === 'E1') {
                return 'Planta_E1.jpg'
            } else if (modelCode === 'F') {
                return 'Planta_F.jpg'
            } else if (modelCode === 'F1') {
                return 'Planta_F1.jpg'
            } else if (modelCode === 'F4') {
                return 'Planta_F4.jpg'
            } else if (modelCode === 'G') {
                return 'Planta_G.jpg'
            } else if (modelCode === 'H') {
                return 'Planta_H.jpg'
            } else if (modelCode === 'I') {
                return 'Planta_I.jpg'
            } else if (modelCode === 'I1') {
                return 'Planta_I1.jpg'
            } else if (modelCode === 'LOCAL') {
                return 'vendido-pg.jpg'
            }
        },
        changeFilterSelected(modelCode) {
            this.filterSelected = modelCode;

            if (this.isMobile()) {
                this.showProjectModels = false;
            }
        }
    },

    watch: {
        // floorSelected(newVal){
        //     if  (newVal !== 'Selecciona el piso a revisar' && !this.instructionModalShown && this.isMobile()){
        //
        //         this.$nextTick(() => {
        //
        //             this.scrollWin()
        //         });
        //
        //         this.$refs.instructionModal.show();
        //
        //         this.instructionModalShown = true;
        //
        //     }
        // },

        loading(newVal) {
            if (newVal === false && this.isMobile()) {
                this.$nextTick(() => {

                    this.scrollWinDefaultView()

                    this.$refs.instructionModal.show();

                    this.instructionModalShown = true;
                });


            }

            if (newVal === false && !this.isMobile()) {
                this.$nextTick(() => {

                    this.$refs.instructionModal.show();

                    this.instructionModalShown = true;
                });


            }

            // if(newVal === false && this.isMobile()){
            //   this.$refs.instructionModal.show();
            //   console.log('newVal funciona')
            //   this.instructionModalShown = true;
            // }
        }
    },

    mounted() {


        const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(monthNames[today.getMonth()]);
        var yyyy = today.getFullYear();
        today = dd + ' de ' + mm + ' de ' + yyyy;
        this.dateToday = today;
    },

    created() {

        var parts = window.location.search.substr(1).split("&");
        var $_GET = {};
        for (var i = 0; i < parts.length; i++) {
            var temp = parts[i].split("=");
            $_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
        }


        var modelCode = 'all';

        if ($_GET['modelo'] === 'lux') {
            modelCode = 'SF75';
        } else if ($_GET['modelo'] === 'terra') {
            modelCode = 'SF90';
        } else if ($_GET['modelo'] === 'aqua') {
            modelCode = 'SF100';
        } else if ($_GET['modelo'] === 'calbuco') {
            modelCode = 'Calbuco-AV09';
        } else if ($_GET['modelo'] === 'osorno') {
            modelCode = 'Osorno-AV07';
        } else if ($_GET['modelo'] === 'lonquimay') {
            modelCode = 'Lonquimay-AV03';
        } else if ($_GET['modelo'] === 'llaima') {
            modelCode = 'Llaima-AV08';
        } else if ($_GET['modelo'] === 'san josé') {
            modelCode = 'SanJose-AV10';
        } else if ($_GET['modelo'] === 'barreno') {
            modelCode = 'Barreno';
        } else if ($_GET['modelo'] === 'legÓn') {
            modelCode = 'Legón';
        } else if ($_GET['modelo'] === 'mayal') {
            modelCode = 'Mayal';
        }

        this.changeFilterSelected(modelCode);

        if ($_GET['id'] === '2') {
            this.projectId = '805';
        } else if ($_GET['id'] === '4') {
            this.projectId = '901';
        } else if ($_GET['id'] === '30') {
            this.projectId = '29238';
        } else if ($_GET['id'] === '23') {
            this.projectId = '644';
        } else if ($_GET['id'] === '3') {
            this.projectId = '29928';
        } else if ($_GET['id'] === '5') {
            this.projectId = '31063';
        } else if ($_GET['id'] === '6') {
            this.projectId = '33583';
        } else {
            this.projectId = $_GET['id'];
        }

        this.projectApiId = $_GET['id']


        axios.post(
            dcms_vars.ajaxurl,
            qs.stringify({action: 'get_project_info', id: this.projectApiId}),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then((res) => {
                if (res.data) {
                    this.loading = false;

                }

                this.projectInfo = res.data;
                this.allProperties = res.data.DATA.PROYECTOS[0].INMUEBLES;

                console.log(this.projectId)

                if ($_GET['id'] === '31063') {
                    document.body.style.backgroundColor = 'white';
                    document.body.classList.add('pg-master-plan-body');
                }

                // let programaArray = this.projectInfo.DATA.PROYECTOS[0].INMUEBLES.map(property => property.PROGRAMA );
                // this.programaInfo = [...new Set(programaArray)];
            });


    }

}
</script>

<style lang="scss">
p, span, a {
  font-family: 'Montserrat' !important;
}

.discount-indicator {
  z-index: 2;
  background: #FFDD17;
  color: #000;
  padding: 10px;
  position: absolute;
  right: 0;
  top: 42px;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  display: inline-block;
  width: auto;
  height: auto;
}

.property-info-tooltip .header-content .title .full-price {
  text-decoration: line-through;
  color: #979797;
  font-size: 15px;
  line-height: 28px;
}

.border-gray-bottom {
  border-bottom: 1px solid rgba(151, 151, 151, .2);
  margin-bottom: 16px;
}

.start-quote-button {
  background: transparent;
  position: fixed;
  width: 100vw;
  margin: 0;
  z-index: 5;
  bottom: 0;
  left: 0;
  padding: 13px;

  .start-quote-button-inner {
    background: #fff;
    padding: 29px 20px 17px;

    .project-info-title {
      h2 {
        font-size: 14px;
        margin-bottom: 0;
        line-height: 15px;
      }

      h1 {
        font-size: 14px;
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        line-height: 15px;
      }

      span {
        font-size: 14px;
        line-height: 15px;
        margin-bottom: 7px;
        display: block;
      }

      .price-info.item-with-icon {
        font-weight: 600;
        font-size: 23px;
        line-height: 28px;
        display: flex;
        align-items: center;

        .icon-box {
          width: 28px;
          margin: 0;

          img {
            width: 100%;
          }
        }
      }
    }

    .buttons-container {
      .button-call-action.button-yellow {
        width: 100%;
        text-align: center;
        line-height: 56px;
        padding: 0 18px;
        text-decoration: none;
        background: #F2D84D;
      }
    }
  }
}

.show-distribution-modal {
  text-decoration: underline;
  color: #000;
}

.model-info-Modal.ms-model-info-Modal {
  .modal-header {
    display: none;
  }
}

.close.custom-close {
  position: absolute;
  right: 12px;
  top: 14px;
  width: 12px;
  height: 12px;
  box-shadow: none;

  img {
    vertical-align: top;
    width: 100%;
  }

  &.back-button {
    left: 17px;
    display: flex;
    align-items: center;
    right: unset;
    opacity: 1;

    span {
      font-family: Montserrat;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      text-transform: capitalize;
    }

    img {
      width: auto;
      flex-shrink: 0;
      margin-right: 8px;
    }
  }
}

.model-info-Modal.distribution-apartment-modal {
  .modal-header {
    border-bottom: none;
    display: none;
  }

  .modal-body {
    padding: 22px 17px;

    .apartment-info-modal {
      .title-and-specs-info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title-continer {
          p {
            margin: 0;
            font-size: 14px;
            line-height: 17px;

            &:last-child {
              font-size: 31px;
              line-height: 38px;
              font-weight: 600;
            }
          }
        }

        .house-specs {
          display: flex;
          align-items: center;

          .spec-item {
            margin-right: 10px;

            img {
              margin-right: 5px;
            }

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }

      .description {
        p {
          font-size: 12px;
          opacity: .6;
        }
      }

      .modal-image {
        width: 100%;
      }
    }
  }
}

.mattasur-custom-select {
  position: relative;

  .ms-option-selected {
    text-decoration: none;
    border: 1px solid #696969;
    padding: 10px 52px 11px 16px;
    border-radius: 6px;
    cursor: pointer;
    height: 51px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .icon-arrow {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);

      &.pg-icon-arrow {
        top: 25px;
      }
    }
  }

  .option-title {
    font-size: 13px;
    line-height: 16px;
    font-family: Montserrat, Sans-Serif;
    margin-bottom: 0;
    width: 100%;
  }

  .floor-info {
    font-size: 11px;
    line-height: 17px;
    color: rgba(0, 0, 0, .5);
    font-family: Montserrat, Sans-Serif;
  }


  .ms-options-list {
    border: 1px solid #696969;
    border-radius: 0 0 6px 6px;
    border-top: none;
    margin-left: 0;
    list-style: none;
    margin-top: -5px;
    position: absolute;
    z-index: 5;
    background: #fff;
    width: 100%;
    left: 0;
    top: 52px;

    &.pg-select {
      overflow-y: auto;
      max-height: 230px;
    }


    li {
      border-bottom: none !important;
      padding: 0 !important;

      a {
        display: block;
        text-decoration: none;
        padding: 10px 52px 11px 16px;
      }

      &:hover {
        background: rgba(255, 221, 23, 0.21);
      }
    }
  }
}

.add-parking-button {
  margin-top: 26px;

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}

.parking-select-container {
  p, a {
    font-style: normal;
  }
}

.add-parking {
  p {
    margin-bottom: 13px;
  }

  a {
    color: #000;
    line-height: 17px;
    text-decoration: underline;
    margin-bottom: 22px;
    font-size: 14px;
    display: flex;
    align-items: center;

    img {
      margin-right: 11px;
    }
  }
}


.parking-select {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  .mattasur-custom-select {
    position: relative;

    &.parking-type-select {
      width: 48%;
    }

    &.parking-list-select {
      width: 48%;
    }

    .ms-option-selected {
      text-decoration: none;
      border: 1px solid #696969;
      padding: 10px 16px 11px 16px;
      color: #000;
      border-radius: 6px;
      cursor: pointer;
      height: 51px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      p {
        margin-bottom: 0;
        font-style: normal;
      }

      .icon-arrow {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .option-title {
      font-size: 13px;
      line-height: 16px;
      font-family: Montserrat, Sans-Serif;
      margin-bottom: 0;
      width: 100%;
      font-style: normal;
    }

    .floor-info {
      font-size: 11px;
      line-height: 17px;
      color: rgba(0, 0, 0, .5);
      font-family: Montserrat, Sans-Serif;
    }


    .ms-options-list {
      border: 1px solid #696969;
      border-radius: 0 0 6px 6px;
      border-top: none;
      margin-left: 0;
      list-style: none;
      margin-top: -5px;
      position: absolute;
      z-index: 5;
      background: #fff;
      width: 100%;
      left: 0;
      top: 52px;

      li {
        border-bottom: none !important;
        padding: 0;

        a {
          font-style: normal;
          display: block;
          text-decoration: none;
          padding: 10px 16px 11px 16px;
          color: #000;

          p {
            margin-bottom: 0;
            font-style: normal;
          }
        }

        &:hover {
          background: rgba(255, 221, 23, 0.21);
        }
      }
    }
  }
}


.modal.fade.show {
  opacity: 1 !important;
}

.master-plan-page {
  overflow: hidden;
  min-height: 915px;
  position: relative;


  &.loading-view {
    min-height: 100vh;
    height: 100vh;
  }

  .lds-loader {
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    div {
      display: inline-block;
      position: absolute;
      left: 8px;
      width: 16px;
      background: #000;
      animation: lds-loader 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    }
  }

  .lds-loader div:nth-child(1) {
    left: 8px;
    animation-delay: -0.24s;
  }

  .lds-loader div:nth-child(2) {
    left: 32px;
    animation-delay: -0.12s;
  }

  .lds-loader div:nth-child(3) {
    left: 56px;
    animation-delay: 0;
  }

  @keyframes lds-loader {
    0% {
      top: 8px;
      height: 64px;
    }
    50%, 100% {
      top: 24px;
      height: 32px;
    }
  }

  &.altos-del-valle-project {
    min-height: 865px;

    &.loading-view {
      min-height: 100vh;
      height: 100vh;
    }

    .project-info-sidebar .info-items-container li .stages-container p .icon-box .color-point.stage-1 {
      background: #224496;
    }

    .project-info-sidebar .info-items-container li .stages-container p .icon-box .color-point.stage-2 {
      background: #E10D21;
    }

    .project-info-sidebar .info-items-container li .stages-container p .icon-box .color-point.stage-3 {
      background: #16CEC6;
    }

    .project-info-sidebar .info-items-container li .stages-container p .icon-box .color-point.stage-4 {
      background: #30CE16;
    }

    .project-models {
      .esepe-custom-container {
        max-width: 1250px;

        .col-md-2 {
          padding-left: 5px;
          padding-right: 5px;
        }
      }
    }
  }

  &.matta-sur-project {
    min-height: 710px;

    .project-models {
      .esepe-custom-container {
        max-width: 1250px;

        .col-md-2 {
          padding-left: 5px;
          padding-right: 5px;
        }
      }

      .model-item .model-info .color-indicator {
        margin-right: 7px;
      }
    }

    &.parque-germania-mp {
      padding-bottom: 150px;

      .master-plan-container {
        margin-bottom: 0;
      }
    }
  }


  .master-plan-container {
    width: 100%;
    position: relative;
    margin-bottom: 83px;

    .points-container {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      z-index: 2;
    }

    .map-image {
      width: 100%;
    }

    &.matta-sur-default-view {
      margin-bottom: 0;
    }

  }

  .project-models {
    z-index: 4;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    width: 100%;

    .row {
      & > [class^="col-"],
      & > [class*=" col-"] {
        &:first-child {
          .model-item {
            align-items: center;
          }
        }
      }
    }

    .model-item {
      cursor: pointer;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 19px 14px 18px;
      height: 100%;
      position: relative;

      .down-arrow {
        display: none;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      .model-info {
        display: flex;
        align-items: flex-start;

        .color-indicator {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          display: inline-block;
          margin-right: 14px;
          flex-shrink: 0;
        }
      }

      .model-icon-active {
        display: none;
      }

      &.active {
        background: #2C2C2C;

        .down-arrow {
          display: inline-block;
        }

        .model-icon-active {
          display: inline-block;
        }

        .model-icon {
          display: none;
        }

        &:before {
          content: '';
          width: 100%;
          background: #2C2C2C;
          height: 7px;
          position: absolute;
          top: -7px;
          left: 0;
          z-index: 1;
        }

        p {
          color: #fff;
        }

        h4 {
          color: #fff;
        }
      }

      p {
        font-size: 13px;
        line-height: 14px;
        color: #000;
        font-family: 'Montserrat', sans-serif;
        font-weight: 400;
        margin-bottom: 0;
      }

      h4 {
        font-size: 14px;
        font-family: 'Montserrat', sans-serif;
        line-height: 18px;
        font-weight: 700;
        margin-bottom: 0;
      }

    }
  }

  .project-info-sidebar {
    z-index: 2;
    background: #fff;
    width: 292px;
    position: absolute;
    left: 30px;
    top: 15px;

    .master-plan-page.parque-germania-mp & {
      box-shadow: 0 2px 13px 5px #00000017;
    }

    &.mobile-sidebar {
      display: none;

      .logo-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .filter-menu {
          display: inline-flex;
          align-items: center;
          font-size: 12px;
          line-height: 20px;
          font-family: 'Montserrat', sans-serif;
          font-weight: 400;
          color: #fff;

          img {
            width: 16px;
            margin-left: 5px;
          }
        }
      }

      .show-content-collapsed {
        display: inline-block;
        position: absolute;
        bottom: -14px;
        margin: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 33px;
        height: 33px;
        border-radius: 50%;
        background: #fff;

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 25px;
        }
      }
    }

    .logo-container {
      padding: 13px 28px 7px;
      background: #000;

      img {
        width: 89px;
      }
    }

    .info-items-container {
      list-style: none;
      padding: 26px 17px 24px;
      margin: 0;

      &.collapse-content {
        padding: 26px 0 24px;
        height: calc(100vh - 180px);
        overflow-y: auto;
      }

      li {
        padding: 15px 0 15px;
        border-bottom: 1px solid rgba(151, 151, 151, 0.2);

        .close-collapsed-content {
          width: 100%;
          text-align: center;
          margin-top: 20px;
        }

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          padding-bottom: 0;
          border-bottom: none;
        }

        h1, h2 {
          font-size: 14px;
          line-height: 17px;
          font-family: 'Montserrat', Sans-Serif;
          font-weight: 500;
          margin-top: 0;
        }

        h2 {
          font-weight: 400;
        }

        h3 {
          font-size: 18px;
          line-height: 17px;
          font-family: 'Montserrat', Sans-Serif;
          font-weight: 700;
        }

        h4 {
          font-size: 13px;
          line-height: 21px;
          font-family: 'Montserrat', Sans-Serif;
          font-weight: 700;
        }

        p {
          font-size: 13px;
          line-height: 16px;
          font-family: 'Montserrat', Sans-Serif;
          font-weight: 400;
        }

        a {
          color: #000;
          font-size: 13px;

          &:hover {
            text-decoration: none;
          }
        }

        .item-with-icon {
          position: relative;
          padding-left: 35px;

          .icon-box {
            position: absolute;
            left: 0;
            top: 0;
            width: 27px;
            text-align: center;

            img {
              max-width: 27px;
            }
          }
        }

        .project-info-title {
          position: relative;

          h1, h2 {
            margin-bottom: 0;
            text-transform: uppercase;
          }

          span {
            font-size: 12px;
            line-height: 20px;
            font-family: 'Montserrat', Sans-Serif;
            font-weight: 400;
            display: block;
            margin-bottom: 10px;
          }

          p {
            font-size: 20px;
            line-height: 21px;
            font-family: 'Montserrat', Sans-Serif;
            font-weight: 500;
            margin-bottom: 0;
          }
        }

        .property-counter-item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;

          h3 {
            font-weight: 700;
            margin-bottom: 9px;
          }

          p {
            margin-bottom: 0;
          }

          span {
            font-size: 18px;
            line-height: 17px;
            font-family: 'Montserrat', Sans-Serif;
          }
        }

        .stages-container {
          p {
            margin-bottom: 8px;

            &:last-child {
              margin-bottom: 0;
            }

            .icon-box {
              display: flex;
              align-items: center;
              height: 100%;
              justify-content: center;

              .color-point {
                width: 16px;
                height: 3px;
                display: inline-block;

                &.stage-1 {
                  background: #00FFCD;
                }

                &.stage-2 {
                  background: #FF0000;
                }

                &.stage-3 {
                  background: #FDEA09;
                }
              }
            }


          }
        }

        .contact-info-container {
          h4 {
            margin-bottom: 15px;
          }

          p {
            margin-bottom: 15px;

            &:last-child {
              margin-bottom: 0;
            }
          }

          .item-with-icon {
            .icon-box {
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

        .example-instruction-container {
          h3 {
            margin-bottom: 24px;
          }

          .instruction-content {
            display: flex;
            align-items: flex-start;

            img {
              margin-right: 10px;
            }
          }
        }


        .share-icon {
          display: block;
          line-height: 24px;
        }
      }
    }
  }


}

body {
  .tooltip.b-tooltip {
    opacity: 1;
    z-index: 1000;
  }

  .tooltip .tooltip-inner {
    background: #fff;
    max-width: 413px;
    border-radius: 0;
  }

  .bs-tooltip-bottom .arrow::before {
    border-bottom-color: #fff;
  }

  .bs-tooltip-top .arrow::before {
    border-top-color: #fff;
  }
}

.property-info-tooltip {
  color: #000;
  text-align: left;
  padding: 27px 14px 18px;

  &.sold-property-card {
    .header-content {
      border: none;
    }

    .header-content .financing-info h4 {
      color: #D7B700;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: -0.18px;
      line-height: 22px;
      text-align: right;
    }
  }

  .image-container {
    height: 136.51px;
    overflow: hidden;
    margin-bottom: 16.49px;
    display: flex;
    align-items: center;

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .header-content {
    display: flex;
    align-items: center;
    padding-bottom: 12.25px;
    border-bottom: 2px solid rgba(151, 151, 151, 0.2);
    justify-content: space-between;

    .title {
      width: auto;

      &.promos-prices {
        width: 58%;

        .price {
          font-size: 18px;
          line-height: 28px;
          font-weight: 600;
        }
      }

      .model-name {
        font-size: 18px;
        line-height: 22px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        margin-bottom: 2px;
        text-transform: uppercase;
      }

      .price {
        font-size: 27px;
        line-height: 28px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 400;
        margin-bottom: 0;
      }
    }

    .financing-info {
      width: 55%;

      h4 {
        font-size: 14px;
        line-height: 21px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        margin-bottom: 3px;
      }

      span {
        font-size: 12px;
        line-height: 13px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 300;
      }
    }
  }

  .body-content {
    padding-top: 14.35px;

    p {
      font-style: normal;
      font-size: 12px;
      line-height: 21px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 400;
      margin-bottom: 15px;

      span {
        font-style: normal;
        text-transform: lowercase;
      }
    }

    .house-specs {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 18px;

      .spec-item {
        display: flex;
        align-items: center;

        img {
          margin-right: 7px;
        }
      }
    }

    .show-distribution-link {
      display: flex;
      align-items: center;
      margin-bottom: 23.25px;

      img {
        margin-right: 12.9px;
      }

      a {
        color: #000;
        font-size: 12px;
        text-decoration: underline;
      }
    }

    .buttons-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.buttons-w-48 {
        .button-call-action {
          width: 48%;
        }
      }

      &.add-parking-button-container {
        justify-content: center;
        flex-wrap: wrap;
      }

      .button-call-action {
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
        background: transparent;
        border: 1px solid #fff;
        color: #000;
        font-family: "Montserrat", Sans-serif;
        font-size: 15px;
        line-height: 19px;
        font-weight: 400;
        padding: 14.5px 18px;
        display: inline-block;
        min-width: 176px;
        text-align: center;

        &.button-yellow {
          background: #FFDD17;
          border-color: transparent;
        }

        &.button-outline {
          border-color: #000;

          &:hover {
            background: #FFDD17;
            color: #000 !important;
            border-color: #FFDD17;
          }
        }

        &:hover {
          text-decoration: none;
        }

        &:focus {
          outline: none;
        }
      }

    }

    .terms-info {
      font-size: 11px;
      line-height: 15px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 200;
    }
  }

  .color-point {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: inline-block;

    &.stage-1 {
      background: #00FFCD;
    }

    &.stage-2 {
      background: #FF0000;
    }
  }
}

.color-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid;
  padding: 0;
  background: transparent;

  .circle-inner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: inline-block;
  }

  .master-plan-page.parque-germania-mp & {
    border-color: #000000;

    .circle-inner {
      background: #000000;
    }
  }

  &:focus {
    box-shadow: none;
    outline: none;
  }

  &.sold-property {
    border-color: #2C2C2C;

    .circle-inner {
      background: #2C2C2C;
    }

    .master-plan-page.parque-germania-mp & {
      border-color: #9c9c9c;

      .circle-inner {
        background: #9c9c9c;
      }
    }
  }

  &.model-SF100 {
    border-color: #17C9FF;

    .circle-inner {
      background: #17C9FF;
    }
  }

  &.model-SF90 {
    border-color: #1FFF17;

    .circle-inner {
      background: #1FFF17;
    }
  }

  &.model-SF75 {
    border-color: #FF7F17;

    .circle-inner {
      background: #FF7F17;
    }
  }

  &.model-Calbuco-AV09 {
    border-color: #17C9FF;

    .circle-inner {
      background: #17C9FF;
    }
  }

  &.model-Osorno-AV07 {
    border-color: #1FFF17;

    .circle-inner {
      background: #1FFF17;
    }
  }

  &.model-Lonquimay-AV03 {
    border-color: #FF7F17;

    .circle-inner {
      background: #FF7F17;
    }
  }

  &.model-Llaima-AV08 {
    border-color: #ff4f4d;

    .circle-inner {
      background: #ff4f4d;
    }
  }

  &.model-SanJose-AV10 {
    border-color: #28259a;

    .circle-inner {
      background: #28259a;
    }
  }

  &.model-tipo-a {
    border-color: #EF8639;

    .circle-inner {
      background: #EF8639;
    }
  }

  &.model-tipo-b {
    border-color: #78FA50;

    .circle-inner {
      background: #78FA50;
    }
  }

  &.model-tipo-c {
    border-color: #5EC6FA;

    .circle-inner {
      background: #5EC6FA;
    }
  }

  &.model-tipo-d {
    border-color: #ff4f4d;

    .circle-inner {
      background: #ff4f4d;
    }
  }

  &.model-Mayal {
    border-color: #17C9FF;

    .circle-inner {
      background: #17C9FF;
    }
  }

  &.model-Legón {
    border-color: #1FFF17;

    .circle-inner {
      background: #1FFF17;
    }
  }

  &.model-Barreno {
    border-color: #FF7F17;

    .circle-inner {
      background: #FF7F17;
    }
  }

  &.indicator-in-map {
    position: absolute;
    left: 35px;
    top: 35px;
    z-index: 4;

    &.sold-property {
      z-index: 3;
    }

    //Propiedades Etapa 2://///////////

    &.property-SF2-A36 {
      top: 18.54%;
      left: 28.7%;
    }

    &.property-SF2-A35 {
      top: 21.5%;
      left: 27%;
    }

    &.property-SF2-A34 {
      top: 25.1%;
      left: 26.3%;
    }

    &.property-SF2-A33 {
      top: 28.4%;
      left: 26.5%;
    }

    &.property-SF2-A32 {
      top: 30.8%;
      left: 27.2%;
    }

    &.property-SF2-A31 {
      top: 33.6%;
      left: 28%;
    }

    &.property-SF2-A30 {
      top: 36.3%;
      left: 28.9%;
    }

    &.property-SF2-A29 {
      top: 38.7%;
      left: 29.9%;
    }

    &.property-SF2-A28 {
      top: 40.7%;
      left: 30.6%;
    }

    &.property-SF2-A27 {
      top: 44%;
      left: 31.3%;
    }

    &.property-SF2-A26 {
      top: 46.7%;
      left: 32.1%;
    }

    &.property-SF2-A25 {
      top: 49.3%;
      left: 33%;
    }

    &.property-SF2-A24 {
      top: 52.1%;
      left: 33.9%;
    }


    &.property-SF2-D20 {
      top: 39.7%;
      left: 37.2%;
    }

    &.property-SF2-D19 {
      top: 39.7%;
      left: 38.7%;
    }

    &.property-SF2-D18 {
      top: 39.7%;
      left: 41%;
    }

    &.property-SF2-D17 {
      top: 39.7%;
      left: 42.5%;
    }

    &.property-SF2-D16 {
      top: 39.7%;
      left: 45%;
    }

    &.property-SF2-D15 {
      top: 39.7%;
      left: 47%;
    }

    &.property-SF2-D14 {
      top: 39.7%;
      left: 48.5%;
    }

    &.property-SF2-D13 {
      top: 39.9%;
      left: 50.9%;
    }

    &.property-SF2-D12 {
      top: 39.9%;
      left: 53.1%;
    }

    &.property-SF2-D11 {
      top: 39.9%;
      left: 55.1%;
    }

    &.property-SF2-D10 {
      top: 39.9%;
      left: 56.7%;
    }

    &.property-SF2-D09 {
      top: 46.9%;
      left: 56.7%;
    }

    &.property-SF2-D08 {
      top: 46.9%;
      left: 55.2%;
    }

    &.property-SF2-D07 {
      top: 46.9%;
      left: 53.2%;
    }

    &.property-SF2-D06 {
      top: 46.9%;
      left: 51%;
    }

    &.property-SF2-D05 {
      top: 46.9%;
      left: 48.8%;
    }

    &.property-SF2-D04 {
      top: 46.9%;
      left: 46.6%;
    }

    &.property-SF2-D03 {
      top: 46.8%;
      left: 44.4%;
    }

    &.property-SF2-D02 {
      top: 46.8%;
      left: 42.3%;
    }

    &.property-SF2-D01 {
      top: 46.8%;
      left: 40.1%;
    }

    /////////////////////////////////

    &.property-SF2-G01 {
      top: 47.3%;
      left: 80%;
    }

    &.property-SF2-G02 {
      top: 47.3%;
      left: 78.5%;
    }

    &.property-SF2-G03 {
      top: 47.3%;
      left: 76.5%;
    }

    &.property-SF2-G04 {
      top: 47.3%;
      left: 74%;
    }

    &.property-SF2-G05 {
      top: 47.3%;
      left: 72.5%;
    }

    &.property-SF2-G06 {
      top: 47.3%;
      left: 70.5%;
    }

    &.property-SF2-G07 {
      top: 47.3%;
      left: 68%;
    }

    &.property-SF2-G08 {
      top: 47.3%;
      left: 66.5%;
    }

    &.property-SF2-G09 {
      top: 47.5%;
      left: 63%;
    }

    &.property-SF2-G10 {
      top: 44.7%;
      left: 63.1%;
    }

    &.property-SF2-G11 {
      top: 42.5%;
      left: 63.1%;
    }

    &.property-SF2-G12 {
      top: 39.7%;
      left: 63.1%;
    }

    &.property-SF2-G13 {
      top: 40.1%;
      left: 66.6%;
    }

    &.property-SF2-G14 {
      top: 40.1%;
      left: 68%;
    }

    &.property-SF2-G15 {
      top: 40.1%;
      left: 70.5%;
    }

    &.property-SF2-G16 {
      top: 40.2%;
      left: 72.5%;
    }

    &.property-SF2-G17 {
      top: 40.2%;
      left: 74%;
    }

    &.property-SF2-G18 {
      top: 40.2%;
      left: 76.5%;
    }

    &.property-SF2-G19 {
      top: 40.2%;
      left: 78.5%;
    }

    &.property-SF2-G20 {
      top: 40.2%;
      left: 80%;
    }

    &.property-SF2-G21 {
      top: 40%;
      left: 83.5%;
    }

    &.property-SF2-G22 {
      top: 42.8%;
      left: 83.5%;
    }

    &.property-SF2-G23 {
      top: 44.8%;
      left: 83.5%;
    }

    &.property-SF2-G24 {
      top: 47.8%;
      left: 83.5%;
    }


    &.property-SF2-A70 {
      top: 36.5%;
      left: 90.7%;
    }

    &.property-SF2-A71 {
      top: 39.3%;
      left: 90.7%;
    }

    &.property-SF2-A72 {
      top: 42.3%;
      left: 90.4%;
    }

    &.property-SF2-A73 {
      top: 44.3%;
      left: 90.4%;
    }

    &.property-SF2-A74 {
      top: 47.3%;
      left: 90.6%;
    }

    &.property-SF2-A75 {
      top: 50%;
      left: 90.6%;
    }

    //Propiedades Etapa 1://///////////

    &.property-SF1-A23 {
      top: 55%;
      left: 34.9%;
    }

    &.property-SF1-A22 {
      top: 58%;
      left: 35.9%;
    }

    &.property-SF1-A21 {
      top: 61%;
      left: 37.8%;
    }

    &.property-SF1-A20 {
      top: 62.7%;
      left: 39.5%;
    }

    &.property-SF1-A19 {
      top: 64.7%;
      left: 41.2%;
    }

    &.property-SF1-A18 {
      top: 66.5%;
      left: 42.9%;
    }

    &.property-SF1-A17 {
      top: 68.5%;
      left: 44.5%;
    }

    &.property-SF1-A16 {
      top: 70.3%;
      left: 46.2%;
    }

    &.property-SF1-A15 {
      top: 72.2%;
      left: 47.8%;
    }

    &.property-SF1-A14 {
      top: 74.3%;
      left: 49.6%;
    }

    &.property-SF1-A13 {
      top: 75.8%;
      left: 51.3%;
    }

    &.property-SF1-A12 {
      top: 77.1%;
      left: 52.5%;
    }

    &.property-SF1-A11 {
      top: 79.1%;
      left: 53.9%;
    }

    &.property-SF1-A10 {
      top: 81%;
      left: 55.5%;
    }

    &.property-SF1-A09 {
      top: 86.2%;
      left: 52.8%;
    }


    &.property-SF1-A08 {
      top: 84.8%;
      left: 51.6%;
    }

    &.property-SF1-A07 {
      top: 82.8%;
      left: 49.8%;
    }

    &.property-SF1-A06 {
      top: 81.5%;
      left: 48.6%;
    }

    &.property-SF1-A05 {
      top: 79.5%;
      left: 46.9%;
    }

    &.property-SF1-A04 {
      top: 78.2%;
      left: 45.7%;
    }

    &.property-SF1-A03 {
      top: 76.1%;
      left: 43.9%;
    }

    &.property-SF1-A02 {
      top: 74.8%;
      left: 42.7%;
    }

    &.property-SF1-A01 {
      top: 71.4%;
      left: 41%;
    }

    ///////////////////////////////////////////////////////////////////////

    &.property-SF1-C13 {
      top: 55.2%;
      left: 43.2%;
    }

    &.property-SF1-C12 {
      top: 55.2%;
      left: 45.2%;
    }

    &.property-SF1-C11 {
      top: 55.2%;
      left: 46.8%;
    }

    &.property-SF1-C10 {
      top: 55.2%;
      left: 49.2%;
    }

    &.property-SF1-C09 {
      top: 55.3%;
      left: 51.2%;
    }

    &.property-SF1-C08 {
      top: 55.3%;
      left: 52.8%;
    }

    &.property-SF1-C07 {
      top: 55.4%;
      left: 55%;
    }

    &.property-SF1-C06 {
      top: 55.4%;
      left: 56.6%;
    }

    &.property-SF1-C05 {
      top: 62.6%;
      left: 56.6%;
    }

    &.property-SF1-C04 {
      top: 62.6%;
      left: 55%;
    }

    &.property-SF1-C03 {
      top: 62.5%;
      left: 52.7%;
    }

    &.property-SF1-C02 {
      top: 62.5%;
      left: 51.2%;
    }

    &.property-SF1-C01 {
      top: 62%;
      left: 49.2%;
    }

    /////////////////////////////////////

    &.property-SF1-F01 {
      top: 62.8%;
      left: 79.9%;
    }

    &.property-SF1-F02 {
      top: 62.8%;
      left: 78.4%;
    }

    &.property-SF1-F03 {
      top: 62.8%;
      left: 76.4%;
    }

    &.property-SF1-F04 {
      top: 62.7%;
      left: 73.9%;
    }

    &.property-SF1-F05 {
      top: 62.7%;
      left: 72.4%;
    }

    &.property-SF1-F06 {
      top: 62.7%;
      left: 70.4%;
    }

    &.property-SF1-F07 {
      top: 62.7%;
      left: 67.9%;
    }

    &.property-SF1-F08 {
      top: 62.7%;
      left: 66.4%;
    }

    &.property-SF1-F09 {
      top: 62.7%;
      left: 63%;
    }

    &.property-SF1-F10 {
      top: 60.2%;
      left: 63%;
    }

    &.property-SF1-F11 {
      top: 58%;
      left: 63%;
    }

    &.property-SF1-F12 {
      top: 55.1%;
      left: 63%;
    }

    &.property-SF1-F13 {
      top: 55.6%;
      left: 66.4%;
    }

    &.property-SF1-F14 {
      top: 55.6%;
      left: 68%;
    }

    &.property-SF1-F15 {
      top: 55.6%;
      left: 70.4%;
    }

    &.property-SF1-F16 {
      top: 55.6%;
      left: 72.4%;
    }

    &.property-SF1-F17 {
      top: 55.6%;
      left: 74%;
    }

    &.property-SF1-F18 {
      top: 55.6%;
      left: 76.4%;
    }

    &.property-SF1-F19 {
      top: 55.7%;
      left: 78.4%;
    }

    &.property-SF1-F20 {
      top: 55.7%;
      left: 80%;
    }

    &.property-SF1-F21 {
      top: 55.3%;
      left: 83.5%;
    }

    &.property-SF1-F22 {
      top: 58.2%;
      left: 83.4%;
    }

    &.property-SF1-F23 {
      top: 60.3%;
      left: 83.4%;
    }

    &.property-SF1-F24 {
      top: 63%;
      left: 83.4%;
    }


    &.property-SF1-A76 {
      top: 53.6%;
      left: 90.4%;
    }

    &.property-SF1-A77 {
      top: 55.6%;
      left: 90.4%;
    }

    &.property-SF1-A78 {
      top: 58.5%;
      left: 90.5%;
    }

    &.property-SF1-A79 {
      top: 61.7%;
      left: 90.3%;
    }

    &.property-SF1-A80 {
      top: 63.8%;
      left: 90.3%;
    }

    &.property-SF1-A81 {
      top: 66.7%;
      left: 90.5%;
    }

    ////////////////////////////

    &.property-SF3-E01 {
      top: 31.2%;
      left: 34.7%;
    }

    &.property-SF3-E02 {
      top: 31.2%;
      left: 36.2%;
    }

    &.property-SF3-E03 {
      top: 31.2%;
      left: 38.6%;
    }

    &.property-SF3-E04 {
      top: 31.2%;
      left: 40.8%;
    }

    &.property-SF3-E05 {
      top: 31.2%;
      left: 43%;
    }

    &.property-SF3-E06 {
      top: 31.2%;
      left: 45.2%;
    }

    &.property-SF3-E07 {
      top: 31.3%;
      left: 47.2%;
    }

    &.property-SF3-E08 {
      top: 31.3%;
      left: 48.7%;
    }

    &.property-SF3-E09 {
      top: 31.4%;
      left: 51.2%;
    }

    &.property-SF3-E10 {
      top: 31.4%;
      left: 53.4%;
    }

    &.property-SF3-E11 {
      top: 31.5%;
      left: 55.4%;
    }

    &.property-SF3-E12 {
      top: 31.5%;
      left: 56.9%;
    }

    &.property-SF3-E13 {
      top: 25.2%;
      left: 56.5%;
    }

    &.property-SF3-E14 {
      top: 25.2%;
      left: 54.5%;
    }

    &.property-SF3-E15 {
      top: 25.2%;
      left: 52.9%;
    }

    &.property-SF3-E16 {
      top: 25.2%;
      left: 50.6%;
    }

    &.property-SF3-E17 {
      top: 25.1%;
      left: 48.3%;
    }

    &.property-SF3-E18 {
      top: 25.1%;
      left: 46.3%;
    }

    &.property-SF3-E19 {
      top: 25%;
      left: 44.1%;
    }

    &.property-SF3-E20 {
      top: 25%;
      left: 41.9%;
    }

    &.property-SF3-E21 {
      top: 25%;
      left: 39.7%;
    }

    &.property-SF3-E22 {
      top: 25%;
      left: 37.7%;
    }

    &.property-SF3-E23 {
      top: 25%;
      left: 36.1%;
    }

    &.property-SF3-E24 {
      top: 24.9%;
      left: 34.1%;
    }

    ///////////////

    &.property-SF3-H01 {
      top: 31.9%;
      left: 80.2%;
    }

    &.property-SF3-H02 {
      top: 31.9%;
      left: 78.6%;
    }

    &.property-SF3-H03 {
      top: 31.9%;
      left: 76.6%;
    }

    &.property-SF3-H04 {
      top: 31.9%;
      left: 74.1%;
    }

    &.property-SF3-H05 {
      top: 31.9%;
      left: 72.6%;
    }

    &.property-SF3-H06 {
      top: 31.9%;
      left: 70.6%;
    }

    &.property-SF3-H07 {
      top: 31.8%;
      left: 68.1%;
    }

    &.property-SF3-H08 {
      top: 31.8%;
      left: 66.6%;
    }

    &.property-SF3-H09 {
      top: 32.1%;
      left: 63.1%;
    }

    &.property-SF3-H10 {
      top: 29.3%;
      left: 63.2%;
    }

    &.property-SF3-H11 {
      top: 27.2%;
      left: 63.2%;

    }

    &.property-SF3-H12 {
      top: 24.8%;
      left: 63.2%;
    }

    &.property-SF3-H13 {
      top: 25.3%;
      left: 66.6%;
    }

    &.property-SF3-H14 {
      top: 25.3%;
      left: 68.1%;
    }

    &.property-SF3-H15 {
      top: 25.3%;
      left: 70.6%;
    }

    &.property-SF3-H16 {
      top: 25.3%;
      left: 72.6%;
    }

    &.property-SF3-H17 {
      top: 25.3%;
      left: 74.1%;
    }

    &.property-SF3-H18 {
      top: 25.3%;
      left: 76.6%;
    }

    &.property-SF3-H19 {
      top: 25.4%;
      left: 78.5%;
    }

    &.property-SF3-H20 {
      top: 25.4%;
      left: 80.1%;
    }

    &.property-SF3-H21 {
      top: 25.2%;
      left: 83.5%;
    }

    &.property-SF3-H22 {
      top: 27.8%;
      left: 83.6%;
    }

    &.property-SF3-H23 {
      top: 29.7%;
      left: 83.6%;
    }

    &.property-SF3-H24 {
      top: 32.3%;
      left: 83.6%;
    }


    ////////////////////////////


    &.property-SF3-A37 {
      top: 15.6%;
      left: 33.7%;
    }

    &.property-SF3-A38 {
      top: 15.6%;
      left: 35.2%;
    }

    &.property-SF3-A39 {
      top: 15.4%;
      left: 37.6%;
    }

    &.property-SF3-A40 {
      top: 15.4%;
      left: 39.8%;
    }

    &.property-SF3-A41 {
      top: 15.4%;
      left: 42%;
    }

    &.property-SF3-A42 {
      top: 15.4%;
      left: 44.1%;
    }

    &.property-SF3-A43 {
      top: 15.4%;
      left: 46.3%;
    }

    &.property-SF3-A44 {
      top: 15.8%;
      left: 48.3%;
    }

    &.property-SF3-A45 {
      top: 15.8%;
      left: 49.9%;
    }

    &.property-SF3-A46 {
      top: 15.5%;
      left: 51.9%;
    }

    &.property-SF3-A47 {
      top: 15.5%;
      left: 54.1%;
    }

    &.property-SF3-A48 {
      top: 15.5%;
      left: 56.3%;
    }

    &.property-SF3-A49 {
      top: 15.5%;
      left: 58.5%;
    }

    &.property-SF3-A50 {
      top: 15.5%;
      left: 61%;
    }

    &.property-SF3-A51 {
      top: 15.5%;
      left: 63.1%;
    }

    &.property-SF3-A52 {
      top: 15.8%;
      left: 65.2%;
    }

    &.property-SF3-A53 {
      top: 15.8%;
      left: 66.7%;
    }

    &.property-SF3-A54 {
      top: 15.6%;
      left: 68.8%;
    }

    &.property-SF3-A55 {
      top: 15.6%;
      left: 71%;
    }

    &.property-SF3-A56 {
      top: 15.6%;
      left: 73.1%;
    }

    &.property-SF3-A57 {
      top: 15.6%;
      left: 75.3%;
    }

    &.property-SF3-A58 {
      top: 15.6%;
      left: 77.5%;
    }

    &.property-SF3-A59 {
      top: 15.6%;
      left: 79.6%;
    }

    &.property-SF3-A60 {
      top: 15.6%;
      left: 81.8%;
    }

    &.property-SF3-A61 {
      top: 16%;
      left: 84.2%;
    }

    &.property-SF3-A62 {
      top: 16%;
      left: 85.7%;
    }

    &.property-SF3-A63 {
      top: 15.7%;
      left: 87.8%;
    }

    &.property-SF3-A64 {
      top: 19.7%;
      left: 90.7%;
    }

    &.property-SF3-A65 {
      top: 22.5%;
      left: 90.5%;
    }

    &.property-SF3-A66 {
      top: 24.5%;
      left: 90.5%;
    }

    &.property-SF3-A67 {
      top: 27.8%;
      left: 90.7%;
    }

    &.property-SF3-A68 {
      top: 30.8%;
      left: 90.7%;
    }

    &.property-SF3-A69 {
      top: 33.2%;
      left: 90.7%;
    }

    ////////////////////////


    &.property-SF3-A127 {
      top: 8.6%;
      left: 43.4%;
    }

    &.property-SF3-A128 {
      top: 8.6%;
      left: 41.9%;
    }

    &.property-SF3-A129 {
      top: 9%;
      left: 39.9%;
    }

    &.property-SF3-A130 {
      top: 9%;
      left: 37.7%;
    }

    &.property-SF3-A131 {
      top: 8.5%;
      left: 35.2%;
    }

    &.property-SF3-A132 {
      top: 8.5%;
      left: 33.8%;
    }


    /*ALTOS DEL VALLE*/

    &.property-AV1-B01 {
      top: 24.8%;
      left: 42.5%;
    }

    &.property-AV1-B02 {
      top: 26.1%;
      left: 41.9%;
    }

    &.property-AV1-B03 {
      top: 27.2%;
      left: 44.3%;
    }

    &.property-AV1-B04 {
      top: 28%;
      left: 45.1%;
    }

    &.property-AV1-B05 {
      top: 29.6%;
      left: 46.1%;
    }

    &.property-AV1-B06 {
      top: 30.3%;
      left: 46.8%;
    }

    &.property-AV1-B07 {
      top: 31.5%;
      left: 48.1%;
    }

    &.property-AV1-B08 {
      top: 32.4%;
      left: 48.9%;
    }

    &.property-AV1-B09 {
      top: 34%;
      left: 50%;
    }

    &.property-AV1-B10 {
      top: 34.8%;
      left: 50.8%;
    }

    &.property-AV1-B11 {
      top: 36.8%;
      left: 52.5%;
    }

    &.property-AV1-B12 {
      top: 37.8%;
      left: 52.1%;
    }

    &.property-AV1-B13 {
      top: 40.2%;
      left: 51.1%;
    }

    &.property-AV1-B14 {
      top: 41.4%;
      left: 50.6%;
    }

    &.property-AV1-B15 {
      top: 39.1%;
      left: 48.9%;
    }

    &.property-AV1-B16 {
      top: 38.3%;
      left: 48.1%;
    }

    &.property-AV1-B17 {
      top: 36.7%;
      left: 47%;
    }

    &.property-AV1-B18 {
      top: 35.8%;
      left: 46.3%;
    }

    &.property-AV1-B19 {
      top: 34.6%;
      left: 44.9%;
    }

    &.property-AV1-B20 {
      top: 33.9%;
      left: 44.2%;
    }

    &.property-AV1-B21 {
      top: 32.4%;
      left: 43.2%;
    }

    &.property-AV1-B22 {
      top: 31.5%;
      left: 42.5%;
    }

    &.property-AV1-B23 {
      top: 29.5%;
      left: 40.6%;
    }

    &.property-AV1-B24 {
      top: 28.4%;
      left: 41.2%;
    }


    &.property-AV1-B25 {
      top: 33.7%;
      left: 38.8%;
    }

    &.property-AV1-B26 {
      top: 34.8%;
      left: 38.3%;
    }

    &.property-AV1-B27 {
      top: 35.7%;
      left: 40.6%;
    }

    &.property-AV1-B28 {
      top: 36.5%;
      left: 41.4%;
    }

    &.property-AV1-B29 {
      top: 38%;
      left: 42.4%;
    }

    &.property-AV1-B30 {
      top: 38.8%;
      left: 43.2%;
    }

    &.property-AV1-B31 {
      top: 40%;
      left: 44.3%;
    }

    &.property-AV1-B32 {
      top: 40.9%;
      left: 45.1%;
    }

    &.property-AV1-B33 {
      top: 42.4%;
      left: 46.1%;
    }

    &.property-AV1-B34 {
      top: 43.3%;
      left: 46.9%;
    }

    &.property-AV1-B35 {
      top: 45.3%;
      left: 49%;
    }

    &.property-AV1-B36 {
      top: 46.6%;
      left: 48.5%;
    }

    &.property-AV1-B37 {
      top: 48.1%;
      left: 45.8%;
    }

    &.property-AV1-B38 {
      top: 47.2%;
      left: 45.1%;
    }

    &.property-AV1-B39 {
      top: 45.6%;
      left: 43.7%;
    }

    &.property-AV1-B40 {
      top: 44.8%;
      left: 42.9%;
    }

    &.property-AV1-B41 {
      top: 43.2%;
      left: 41.5%;
    }

    &.property-AV1-B42 {
      top: 42.4%;
      left: 40.8%;
    }

    &.property-AV1-B43 {
      top: 41.1%;
      left: 39.4%;
    }

    &.property-AV1-B44 {
      top: 40.2%;
      left: 38.6%;
    }

    &.property-AV1-B45 {
      top: 38%;
      left: 36.8%;
    }

    &.property-AV1-B46 {
      top: 37%;
      left: 37.4%;
    }


    &.property-AV1-C01 {
      top: 64.6%;
      left: 25.2%;
    }

    &.property-AV1-C02 {
      top: 63.7%;
      left: 26%;
    }

    &.property-AV1-C03 {
      top: 60.8%;
      left: 26.5%;
    }

    &.property-AV1-C04 {
      top: 60%;
      left: 27.3%;
    }

    &.property-AV1-C05 {
      top: 57.6%;
      left: 28.1%;
    }

    &.property-AV1-C06 {
      top: 56.8%;
      left: 28.8%;
    }

    &.property-AV1-C07 {
      top: 58.4%;
      left: 31.8%;
    }

    &.property-AV1-C08 {
      top: 57.7%;
      left: 32.6%;
    }

    &.property-AV1-C09 {
      top: 56.5%;
      left: 34.4%;
    }

    &.property-AV1-C10 {
      top: 56.1%;
      left: 35.3%;
    }

    &.property-AV1-C11 {
      top: 55.5%;
      left: 37%;
    }

    &.property-AV1-C12 {
      top: 55.2%;
      left: 37.8%;
    }

    &.property-AV1-C13 {
      top: 54.3%;
      left: 39.3%;
    }

    &.property-AV1-C14 {
      top: 54%;
      left: 40.2%;
    }

    &.property-AV1-C15 {
      top: 53.8%;
      left: 42.6%;
    }

    &.property-AV1-C16 {
      top: 54%;
      left: 43.6%;
    }

    &.property-AV1-C17 {
      top: 54.2%;
      left: 45.1%;
    }

    &.property-AV1-C18 {
      top: 54.4%;
      left: 46%;
    }

    &.property-AV1-C19 {
      top: 54.9%;
      left: 47.7%;
    }

    &.property-AV1-C20 {
      top: 55%;
      left: 48.6%;
    }


    &.property-AV2-A01 {
      top: 20.4%;
      left: 44.8%;
    }

    &.property-AV2-A02 {
      top: 21.2%;
      left: 45.5%;
    }

    &.property-AV2-A03 {
      top: 22.8%;
      left: 46.5%;
    }

    &.property-AV2-A04 {
      top: 23.6%;
      left: 47.3%;
    }

    &.property-AV2-A05 {
      top: 24.8%;
      left: 48.4%;
    }

    &.property-AV2-A06 {
      top: 25.6%;
      left: 49.2%;
    }

    &.property-AV2-A07 {
      top: 27%;
      left: 50.3%;
    }

    &.property-AV2-A08 {
      top: 27.8%;
      left: 51.1%;
    }

    &.property-AV2-A09 {
      top: 28.9%;
      left: 52.2%;
    }

    &.property-AV2-A10 {
      top: 29.8%;
      left: 53%;
    }

    &.property-AV2-A11 {
      top: 30.8%;
      left: 55%;
    }

    &.property-AV2-A12 {
      top: 32%;
      left: 54.4%;
    }


    &.property-AV2-D01 {
      top: 26.1%;
      left: 61.6%;
    }

    &.property-AV2-D02 {
      top: 27%;
      left: 62.5%;
    }

    &.property-AV2-D03 {
      top: 28.5%;
      left: 63.6%;
    }

    &.property-AV2-D04 {
      top: 29.2%;
      left: 64.4%;
    }

    &.property-AV2-D05 {
      top: 32.3%;
      left: 63.1%;
    }

    &.property-AV2-D06 {
      top: 33.5%;
      left: 62.6%;
    }

    &.property-AV2-D07 {
      top: 35.6%;
      left: 61.5%;
    }

    &.property-AV2-D08 {
      top: 36.8%;
      left: 61%;
    }

    &.property-AV2-D09 {
      top: 39.8%;
      left: 59.8%;
    }

    &.property-AV2-D10 {
      top: 39%;
      left: 58.9%;
    }

    &.property-AV2-D11 {
      top: 37.6%;
      left: 57.7%;
    }

    &.property-AV2-D12 {
      top: 36.8%;
      left: 57%;
    }

    &.property-AV2-D13 {
      top: 33.9%;
      left: 58.4%;
    }

    &.property-AV2-D14 {
      top: 32.7%;
      left: 59%;
    }

    &.property-AV2-D15 {
      top: 30.7%;
      left: 59.9%;
    }

    &.property-AV2-D16 {
      top: 29.5%;
      left: 60.5%;
    }


    &.property-AV2-E01 {
      top: 49%;
      left: 51.5%;
    }

    &.property-AV2-E02 {
      top: 47.8%;
      left: 52.1%;
    }

    &.property-AV2-E03 {
      top: 45.8%;
      left: 53.2%;
    }

    &.property-AV2-E04 {
      top: 44.8%;
      left: 53.7%;
    }

    &.property-AV2-E05 {
      top: 42.7%;
      left: 54.5%;
    }

    &.property-AV2-E06 {
      top: 41.7%;
      left: 55.1%;
    }

    &.property-AV2-E07 {
      top: 43.9%;
      left: 56.8%;
    }

    &.property-AV2-E08 {
      top: 44.8%;
      left: 57.5%;
    }

    &.property-AV2-E09 {
      top: 45.8%;
      left: 59.2%;
    }

    &.property-AV2-E10 {
      top: 46%;
      left: 60.1%;
    }

    &.property-AV2-E11 {
      top: 46.7%;
      left: 61.5%;
    }

    &.property-AV2-E12 {
      top: 46.8%;
      left: 62.3%;
    }


    &.property-AV2-D17 {
      top: 32.3%;
      left: 66.7%;
    }

    &.property-AV2-D18 {
      top: 33.1%;
      left: 67.5%;
    }

    &.property-AV2-D31 {
      top: 40.9%;
      left: 64.1%;
    }

    &.property-AV2-D32 {
      top: 40%;
      left: 63.3%;
    }

    &.property-AV2-D33 {
      top: 36.8%;
      left: 65.1%;
    }

    &.property-AV2-D34 {
      top: 35.7%;
      left: 65.7%;
    }


    &.property-AV2-C85 {
      top: 27.2%;
      left: 69%;
    }

    &.property-AV2-C86 {
      top: 26.5%;
      left: 68.3%;
    }

    &.property-AV2-C87 {
      top: 25%;
      left: 66.9%;
    }

    &.property-AV2-C88 {
      top: 24.2%;
      left: 66.2%;
    }

    &.property-AV2-C89 {
      top: 22.4%;
      left: 64.9%;
    }

    &.property-AV2-C90 {
      top: 21.5%;
      left: 64.1%;
    }


    //Propiedades Etapa 3://///////////


    &.property-AV3-D19 {
      top: 34.7%;
      left: 69%;
    }

    &.property-AV3-D20 {
      top: 35.4%;
      left: 69.8%;
    }

    &.property-AV3-D21 {
      top: 37%;
      left: 71.1%;
    }

    &.property-AV3-D22 {
      top: 37.9%;
      left: 71.9%;
    }

    &.property-AV3-D23 {
      top: 40.5%;
      left: 74.6%;
    }

    &.property-AV3-D24 {
      top: 41.7%;
      left: 74.1%;
    }

    &.property-AV3-D25 {
      top: 43.8%;
      left: 72.5%;
    }

    &.property-AV3-D26 {
      top: 42.9%;
      left: 71.7%;
    }

    &.property-AV3-D27 {
      top: 42.7%;
      left: 69.7%;
    }

    &.property-AV3-D28 {
      top: 41.9%;
      left: 69%;
    }

    &.property-AV3-D29 {
      top: 41.5%;
      left: 67.1%;
    }

    &.property-AV3-D30 {
      top: 40.7%;
      left: 66.3%;
    }


    &.property-AV3-E13 {
      left: 63.8%;
      top: 46.8%;
    }

    &.property-AV3-E14 {
      left: 64.7%;
      top: 47%;
    }

    &.property-AV3-E15 {
      left: 66.3%;
      top: 47.7%;
    }

    &.property-AV3-E16 {
      left: 67.1%;
      top: 47.9%;
    }

    &.property-AV3-E17 {
      left: 68.6%;
      top: 48.3%;
    }

    &.property-AV3-E18 {
      left: 69.4%;
      top: 48.7%;
    }

    &.property-AV3-E19 {
      left: 70.9%;
      top: 49.5%;
    }

    &.property-AV3-E20 {
      left: 71.7%;
      top: 49.8%;
    }

    &.property-AV3-E21 {
      left: 73.1%;
      top: 50.2%;
    }

    &.property-AV3-E22 {
      left: 74%;
      top: 50.5%;
    }

    &.property-AV3-E23 {
      left: 75.7%;
      top: 48.5%;
    }

    &.property-AV3-E24 {
      left: 76.3%;
      top: 47.5%;
    }

    &.property-AV3-E25 {
      left: 77.3%;
      top: 44.2%;
    }

    &.property-AV3-E26 {
      left: 78.1%;
      top: 45.1%;
    }

    &.property-AV3-E27 {
      left: 79.3%;
      top: 46.7%;
    }

    &.property-AV3-E28 {
      left: 80%;
      top: 47.3%;
    }

    &.property-AV3-E29 {
      left: 78%;
      top: 51%;
    }

    &.property-AV3-E30 {
      left: 77.5%;
      top: 52%;
    }

    &.property-AV3-E31 {
      left: 75.8%;
      top: 56%;
    }

    &.property-AV3-E32 {
      left: 74.9%;
      top: 55.7%;
    }

    &.property-AV3-E33 {
      left: 73.3%;
      top: 55.1%;
    }

    &.property-AV3-E34 {
      left: 72.4%;
      top: 54.8%;
    }

    &.property-AV3-E35 {
      left: 70.8%;
      top: 54.4%;
    }

    &.property-AV3-E36 {
      left: 69.8%;
      top: 54%;
    }

    &.property-AV3-E37 {
      left: 68.4%;
      top: 53%;
    }

    &.property-AV3-E38 {
      left: 67.5%;
      top: 52.8%;
    }

    &.property-AV3-E39 {
      left: 65.8%;
      top: 52.2%;
    }

    &.property-AV3-E40 {
      left: 65%;
      top: 51.9%;
    }

    &.property-AV3-E41 {
      left: 63.3%;
      top: 51.5%;
    }

    &.property-AV3-E42 {
      left: 62.5%;
      top: 51.3%;
    }

    &.property-AV3-E43 {
      left: 60.8%;
      top: 51.3%;
    }

    &.property-AV3-E44 {
      left: 59.8%;
      top: 51.1%;
    }

    &.property-AV3-E45 {
      left: 58.3%;
      top: 50.6%;
    }

    &.property-AV3-E46 {
      left: 57.3%;
      top: 50.4%;
    }

    &.property-AV3-E47 {
      left: 55.1%;
      top: 50%;
    }

    &.property-AV3-E48 {
      left: 54.3%;
      top: 49%;
    }


    &.property-AV3-E49 {
      left: 82.5%;
      top: 50.2%;
    }

    &.property-AV3-E50 {
      left: 83.2%;
      top: 51%;
    }

    &.property-AV3-E51 {
      left: 84.5%;
      top: 52.4%;
    }

    &.property-AV3-E52 {
      left: 85.3%;
      top: 53.2%;
    }

    &.property-AV3-E53 {
      left: 86.5%;
      top: 54.9%;
    }

    &.property-AV3-E54 {
      left: 87.2%;
      top: 55.6%;
    }

    &.property-AV3-E55 {
      left: 88.4%;
      top: 57%;
    }

    &.property-AV3-E56 {
      left: 89.1%;
      top: 57.7%;
    }

    &.property-AV3-E57 {
      left: 87.6%;
      top: 61.2%;
    }

    &.property-AV3-E58 {
      left: 86.8%;
      top: 60.4%;
    }

    &.property-AV3-E59 {
      left: 85.3%;
      top: 59.8%;
    }

    &.property-AV3-E60 {
      left: 84.5%;
      top: 59.1%;
    }

    &.property-AV3-E61 {
      left: 82.7%;
      top: 59.1%;
    }

    &.property-AV3-E62 {
      left: 81.9%;
      top: 58.1%;
    }

    &.property-AV3-E63 {
      left: 80.2%;
      top: 57.8%;
    }

    &.property-AV3-E64 {
      left: 79.4%;
      top: 57%;
    }

    &.property-AV3-E65 {
      left: 80.7%;
      top: 54%;
    }

    &.property-AV3-E66 {
      left: 81.2%;
      top: 53%;
    }


    &.property-AV3-C21 {
      top: 55.4%;
      left: 50.2%;
    }

    &.property-AV3-C22 {
      top: 55.5%;
      left: 51.1%;
    }

    &.property-AV3-C23 {
      top: 55.9%;
      left: 52.8%;
    }

    &.property-AV3-C24 {
      top: 56.1%;
      left: 53.8%;
    }

    &.property-AV3-C25 {
      top: 56.5%;
      left: 55.4%;
    }

    &.property-AV3-C26 {
      top: 56.7%;
      left: 56.3%;
    }

    &.property-AV3-C27 {
      top: 56.9%;
      left: 58%;
    }

    &.property-AV3-C28 {
      top: 57.1%;
      left: 58.8%;
    }

    &.property-AV3-C29 {
      top: 57.4%;
      left: 60.5%;
    }

    &.property-AV3-C30 {
      top: 57.5%;
      left: 61.3%;
    }

    &.property-AV3-C31 {
      top: 57.9%;
      left: 63%;
    }

    &.property-AV3-C32 {
      top: 58.1%;
      left: 64%;
    }

    &.property-AV3-C33 {
      top: 58.6%;
      left: 66%;
    }

    &.property-AV3-C34 {
      top: 59%;
      left: 66.9%;
    }

    &.property-AV3-C35 {
      top: 59.8%;
      left: 68.4%;
    }

    &.property-AV3-C36 {
      top: 60.2%;
      left: 69.4%;
    }

    &.property-AV3-C37 {
      top: 60.7%;
      left: 71.2%;
    }

    &.property-AV3-C38 {
      top: 61%;
      left: 72.1%;
    }

    &.property-AV3-C39 {
      top: 61.8%;
      left: 73.8%;
    }

    &.property-AV3-C40 {
      top: 62.2%;
      left: 74.7%;
    }

    &.property-AV3-C41 {
      top: 63%;
      left: 76.4%;
    }

    &.property-AV3-C42 {
      top: 63.5%;
      left: 77.3%;
    }

    &.property-AV3-C43 {
      top: 64.1%;
      left: 79%;
    }

    &.property-AV3-C44 {
      top: 64.5%;
      left: 80%;
    }

    &.property-AV3-C45 {
      top: 65.2%;
      left: 81.6%;
    }

    &.property-AV3-C46 {
      top: 65.6%;
      left: 82.6%;
    }

    &.property-AV3-C47 {
      top: 66.3%;
      left: 84.4%;
    }

    &.property-AV3-C48 {
      top: 66.5%;
      left: 85.2%;
    }

    &.property-AV3-C49 {
      top: 67.4%;
      left: 86.8%;
    }

    &.property-AV3-C50 {
      top: 67.7%;
      left: 87.8%;
    }

    &.property-AV3-C51 {
      top: 68.5%;
      left: 89.5%;
    }

    &.property-AV3-C52 {
      top: 68.8%;
      left: 90.5%;
    }

    &.property-AV3-C53 {
      top: 69.5%;
      left: 92.3%;
    }

    &.property-AV3-C54 {
      top: 69.8%;
      left: 93%;
    }

    &.property-AV3-C55 {
      top: 70%;
      left: 95.2%;
    }

    &.property-AV3-C56 {
      top: 70.1%;
      left: 96%;
    }

    &.property-AV3-C57 {
      top: 65.4%;
      left: 95.5%;
    }

    &.property-AV3-C58 {
      top: 64%;
      left: 95.6%;
    }

    &.property-AV3-C59 {
      top: 61.5%;
      left: 95.8%;
    }

    &.property-AV3-C60 {
      top: 60%;
      left: 95.9%;
    }

    &.property-AV3-C61 {
      top: 56.7%;
      left: 94.3%;
    }

    &.property-AV3-C62 {
      top: 55.7%;
      left: 93.5%;
    }

    &.property-AV3-C63 {
      top: 53.9%;
      left: 92.3%;
    }

    &.property-AV3-C64 {
      top: 53%;
      left: 91.5%;
    }

    &.property-AV3-C65 {
      top: 51.5%;
      left: 90.1%;
    }

    &.property-AV3-C66 {
      top: 50.6%;
      left: 89.3%;
    }

    &.property-AV3-C67 {
      top: 49.3%;
      left: 88%;
    }

    &.property-AV3-C68 {
      top: 48.4%;
      left: 87.1%;
    }

    &.property-AV3-C69 {
      top: 47%;
      left: 85.8%;
    }

    &.property-AV3-C70 {
      top: 46%;
      left: 85%;
    }

    &.property-AV3-C71 {
      top: 44.2%;
      left: 83.8%;
    }

    &.property-AV3-C72 {
      top: 43.4%;
      left: 83%;
    }

    &.property-AV3-C73 {
      top: 41.8%;
      left: 81.7%;
    }

    &.property-AV3-C74 {
      top: 40.8%;
      left: 80.9%;
    }

    &.property-AV3-C75 {
      top: 39.4%;
      left: 79.4%;
    }

    &.property-AV3-C76 {
      top: 38.7%;
      left: 78.7%;
    }

    &.property-AV3-C77 {
      top: 37.3%;
      left: 77.3%;
    }

    &.property-AV3-C78 {
      top: 36.4%;
      left: 76.6%;
    }

    &.property-AV3-C79 {
      top: 34.8%;
      left: 75.3%;
    }

    &.property-AV3-C80 {
      top: 33.8%;
      left: 74.5%;
    }

    &.property-AV3-C81 {
      top: 32.2%;
      left: 73.3%;
    }

    &.property-AV3-C82 {
      top: 31.5%;
      left: 72.6%;
    }

    &.property-AV3-C83 {
      top: 29.9%;
      left: 71%;
    }

    &.property-AV3-C84 {
      top: 29.1%;
      left: 70.3%;
    }


    /// Etapa 4: ///

    &.property-AV4-G01 {
      top: 17.8%;
      left: 65.9%;

      &.stage-4-indicator {
        top: 18.8%;
        left: 34.5%;
      }
    }

    &.property-AV4-G02 {
      top: 18.5%;
      left: 66.6%;

      &.stage-4-indicator {
        top: 19.6%;
        left: 35.4%;
      }
    }

    &.property-AV4-G03 {
      top: 20.1%;
      left: 67.7%;

      &.stage-4-indicator {
        top: 21.9%;
        left: 36.9%;
      }
    }

    &.property-AV4-G04 {
      top: 20.8%;
      left: 68.3%;

      &.stage-4-indicator {
        top: 22.7%;
        left: 37.6%;
      }
    }

    &.property-AV4-G05 {
      top: 22.1%;
      left: 69.3%;

      &.stage-4-indicator {
        top: 24.5%;
        left: 39%;
      }
    }

    &.property-AV4-G06 {
      top: 22.8%;
      left: 70%;

      &.stage-4-indicator {
        top: 25.3%;
        left: 39.8%;
      }
    }

    &.property-AV4-G07 {
      top: 24.1%;
      left: 71%;

      &.stage-4-indicator {
        top: 26.9%;
        left: 41.2%;
      }
    }

    &.property-AV4-G08 {
      top: 24.8%;
      left: 71.6%;

      &.stage-4-indicator {
        top: 27.7%;
        left: 42%;
      }
    }

    &.property-AV4-G09 {
      top: 26.2%;
      left: 72.8%;

      &.stage-4-indicator {
        top: 29.7%;
        left: 43.6%;
      }
    }

    &.property-AV4-G10 {
      top: 26.8%;
      left: 73.4%;

      &.stage-4-indicator {
        top: 30.5%;
        left: 44.3%;
      }
    }

    &.property-AV4-G11 {
      top: 28.2%;
      left: 74.5%;

      &.stage-4-indicator {
        top: 32.4%;
        left: 45.8%;
      }
    }

    &.property-AV4-G12 {
      top: 28.9%;
      left: 75.2%;

      &.stage-4-indicator {
        top: 33.2%;
        left: 46.6%;
      }
    }

    &.property-AV4-G13 {
      top: 30.3%;
      left: 76.3%;

      &.stage-4-indicator {
        top: 35.1%;
        left: 48.2%;
      }
    }

    &.property-AV4-G14 {
      top: 30.9%;
      left: 77%;

      &.stage-4-indicator {
        top: 35.9%;
        left: 48.9%;
      }
    }

    &.property-AV4-G15 {
      top: 32.4%;
      left: 78.2%;

      &.stage-4-indicator {
        top: 37.8%;
        left: 50.5%;
      }
    }

    &.property-AV4-G16 {
      top: 33%;
      left: 78.8%;

      &.stage-4-indicator {
        top: 38.7%;
        left: 51.3%;
      }
    }

    &.property-AV4-G17 {
      top: 34.4%;
      left: 79.9%;

      &.stage-4-indicator {
        top: 40.5%;
        left: 52.9%;
      }
    }

    &.property-AV4-G18 {
      top: 35.1%;
      left: 80.6%;

      &.stage-4-indicator {
        top: 41.2%;
        left: 53.7%;
      }
    }

    &.property-AV4-G19 {
      top: 36.4%;
      left: 82%;

      &.stage-4-indicator {
        top: 43.1%;
        left: 55.5%;
      }
    }

    &.property-AV4-G20 {
      top: 37.1%;
      left: 82.6%;

      &.stage-4-indicator {
        top: 44%;
        left: 56.3%;
      }
    }

    &.property-AV4-G21 {
      top: 38.8%;
      left: 83.6%;

      &.stage-4-indicator {
        top: 46%;
        left: 57.8%;
      }
    }

    &.property-AV4-G22 {
      top: 39.4%;
      left: 84.3%;

      &.stage-4-indicator {
        top: 46.9%;
        left: 58.5%;
      }
    }

    &.property-AV4-G23 {
      top: 40.6%;
      left: 85.5%;

      &.stage-4-indicator {
        top: 48.5%;
        left: 60.2%;
      }
    }

    &.property-AV4-G24 {
      top: 41.3%;
      left: 86.2%;

      &.stage-4-indicator {
        top: 49.3%;
        left: 61%;
      }
    }

    &.property-AV4-G25 {
      top: 42.9%;
      left: 87.4%;

      &.stage-4-indicator {
        top: 51.7%;
        left: 62.6%;
      }
    }

    &.property-AV4-G26 {
      top: 43.7%;
      left: 88.1%;

      &.stage-4-indicator {
        top: 52.5%;
        left: 63.4%;
      }
    }

    &.property-AV4-G27 {
      top: 45%;
      left: 89.1%;

      &.stage-4-indicator {
        top: 54.4%;
        left: 64.9%;
      }
    }

    &.property-AV4-G28 {
      top: 45.8%;
      left: 89.8%;

      &.stage-4-indicator {
        top: 55.3%;
        left: 65.7%;
      }
    }

    &.property-AV4-G29 {
      top: 47%;
      left: 91%;

      &.stage-4-indicator {
        top: 56.8%;
        left: 67.4%;
      }
    }

    &.property-AV4-G30 {
      top: 47.7%;
      left: 91.7%;

      &.stage-4-indicator {
        top: 57.7%;
        left: 68.2%;
      }
    }

    /////

    &.property-AV4-K01 {
      top: 17.9%;
      left: 88.6%;

      &.stage-4-indicator {
        top: 18.9%;
        left: 64.3%;
      }
    }

    &.property-AV4-K02 {
      top: 18.6%;
      left: 89.3%;

      &.stage-4-indicator {
        top: 19.8%;
        left: 65.1%;
      }
    }

    &.property-AV4-K03 {
      top: 19.8%;
      left: 90.7%;

      &.stage-4-indicator {
        top: 21.4%;
        left: 66.9%;
      }
    }

    &.property-AV4-K04 {
      top: 20.5%;
      left: 91.4%;

      &.stage-4-indicator {
        top: 22.4%;
        left: 67.7%;
      }
    }

    &.property-AV4-K05 {
      top: 23.5%;
      left: 90%;

      &.stage-4-indicator {
        top: 26.2%;
        left: 66%;
      }
    }

    &.property-AV4-K06 {
      top: 24.6%;
      left: 89.6%;

      &.stage-4-indicator {
        top: 27.8%;
        left: 65.4%;
      }
    }

    &.property-AV4-K07 {
      top: 26.6%;
      left: 88.7%;

      &.stage-4-indicator {
        top: 30.3%;
        left: 64.3%;
      }
    }

    &.property-AV4-K08 {
      top: 27.6%;
      left: 88.3%;

      &.stage-4-indicator {
        top: 31.7%;
        left: 63.8%;
      }
    }

    &.property-AV4-K09 {
      top: 29.6%;
      left: 87.3%;

      &.stage-4-indicator {
        top: 34%;
        left: 62.4%;
      }
    }

    &.property-AV4-K10 {
      top: 30.4%;
      left: 86.8%;

      &.stage-4-indicator {
        top: 35%;
        left: 62%;
      }
    }

    &.property-AV4-K11 {
      top: 33.4%;
      left: 85.8%;

      &.stage-4-indicator {
        top: 38.9%;
        left: 60.5%;
      }
    }

    &.property-AV4-K12 {
      top: 32.6%;
      left: 85.1%;

      &.stage-4-indicator {
        top: 38%;
        left: 59.7%;
      }
    }

    &.property-AV4-K13 {
      top: 31%;
      left: 83.8%;

      &.stage-4-indicator {
        top: 35.9%;
        left: 57.9%;
      }
    }

    &.property-AV4-K14 {
      top: 30.2%;
      left: 83.1%;

      &.stage-4-indicator {
        top: 34.9%;
        left: 57%;
      }
    }

    &.property-AV4-K15 {
      top: 27.8%;
      left: 84.6%;

      &.stage-4-indicator {
        top: 31.8%;
        left: 58.9%;
      }
    }

    &.property-AV4-K16 {
      top: 26.8%;
      left: 85%;

      &.stage-4-indicator {
        top: 30.5%;
        left: 59.4%;
      }
    }

    &.property-AV4-K17 {
      top: 24.9%;
      left: 85.7%;

      &.stage-4-indicator {
        top: 27.8%;
        left: 60.4%;
      }
    }

    &.property-AV4-K18 {
      top: 23.8%;
      left: 86.2%;

      &.stage-4-indicator {
        top: 26.5%;
        left: 60.9%;
      }
    }

    &.property-AV4-K19 {
      top: 21.7%;
      left: 86.9%;

      &.stage-4-indicator {
        top: 23.9%;
        left: 62.1%;
      }
    }

    &.property-AV4-K20 {
      top: 20.6%;
      left: 87.5%;

      &.stage-4-indicator {
        top: 22.5%;
        left: 62.7%;
      }
    }

    ////

    &.property-AV4-L01 {
      top: 22.9%;
      left: 94.1%;

      &.stage-4-indicator {
        top: 25.5%;
        left: 71.4%;
      }
    }

    &.property-AV4-L02 {
      top: 23.6%;
      left: 94.8%;

      &.stage-4-indicator {
        top: 26.4%;
        left: 72.3%;
      }
    }

    &.property-AV4-L03 {
      top: 25.1%;
      left: 96.2%;

      &.stage-4-indicator {
        top: 28.2%;
        left: 74.2%;
      }
    }

    &.property-AV4-L04 {
      top: 25.9%;
      left: 97%;

      &.stage-4-indicator {
        top: 29.2%;
        left: 75%;
      }
    }

    &.property-AV4-L05 {
      top: 29.5%;
      left: 95.8%;

      &.stage-4-indicator {
        top: 34%;
        left: 73.6%;
      }
    }

    &.property-AV4-L06 {
      top: 30.5%;
      left: 95.4%;

      &.stage-4-indicator {
        top: 35.4%;
        left: 73.1%;
      }
    }

    &.property-AV4-L07 {
      top: 32.8%;
      left: 94.8%;

      &.stage-4-indicator {
        top: 38.4%;
        left: 72.3%;
      }
    }

    &.property-AV4-L08 {
      top: 33.9%;
      left: 94.4%;

      &.stage-4-indicator {
        top: 39.8%;
        left: 71.7%;
      }
    }

    &.property-AV4-L09 {
      top: 36.2%;
      left: 93.5%;

      &.stage-4-indicator {
        top: 42.8%;
        left: 70.6%;
      }
    }

    &.property-AV4-L10 {
      top: 37.2%;
      left: 93%;

      &.stage-4-indicator {
        top: 44%;
        left: 70.1%;
      }
    }

    &.property-AV4-L11 {
      top: 40.4%;
      left: 91.9%;

      &.stage-4-indicator {
        top: 48%;
        left: 68.5%;
      }
    }

    &.property-AV4-L12 {
      top: 39.5%;
      left: 91.2%;

      &.stage-4-indicator {
        top: 47.1%;
        left: 67.6%;
      }
    }

    &.property-AV4-L13 {
      top: 37.2%;
      left: 89.3%;

      &.stage-4-indicator {
        top: 44.1%;
        left: 65%;
      }
    }

    &.property-AV4-L14 {
      top: 36.5%;
      left: 88.5%;

      &.stage-4-indicator {
        top: 43.1%;
        left: 64.2%;
      }
    }

    &.property-AV4-L15 {
      top: 33.5%;
      left: 89.6%;

      &.stage-4-indicator {
        top: 39.1%;
        left: 65.6%;
      }
    }

    &.property-AV4-L16 {
      top: 32.2%;
      left: 90.1%;

      &.stage-4-indicator {
        top: 37.6%;
        left: 66.3%;
      }
    }

    &.property-AV4-L17 {
      top: 30.1%;
      left: 90.9%;

      &.stage-4-indicator {
        top: 34.6%;
        left: 67.2%;
      }
    }

    &.property-AV4-L18 {
      top: 29%;
      left: 91.4%;

      &.stage-4-indicator {
        top: 33.3%;
        left: 67.8%;
      }
    }

    &.property-AV4-L19 {
      top: 27.1%;
      left: 92.4%;

      &.stage-4-indicator {
        top: 30.8%;
        left: 69.2%;
      }
    }

    &.property-AV4-L20 {
      top: 26.1%;
      left: 92.9%;

      &.stage-4-indicator {
        top: 29.7%;
        left: 69.7%;
      }
    }

    // Matta Sur Project: /////////


    // Floor socalo: ///

    &.property-001 {
      left: 63.8%;
      top: 66.8%;
    }

    &.property-002 {
      left: 75.8%;
      top: 66.8%;
    }

    &.property-003 {
      left: 88.8%;
      top: 66.8%;
    }

    &.property-004 {
      left: 88.8%;
      top: 40.8%;
    }

    &.property-005 {
      left: 88.8%;
      top: 15.8%;
    }

    &.property-006 {
      left: 75.8%;
      top: 15.8%;
    }

    &.property-007 {
      left: 63.8%;
      top: 15.8%;
    }


    // Floor Piso1: ///

    &.property-101 {
      left: 58%;
      top: 61%;
    }

    &.property-102 {
      left: 71%;
      top: 61%;
    }

    &.property-103 {
      left: 82.5%;
      top: 61%;
    }

    &.property-104 {
      left: 82.5%;
      top: 37%;
    }

    &.property-105 {
      left: 82.5%;
      top: 13%;
    }

    &.property-106 {
      left: 71%;
      top: 13%;
    }

    &.property-107 {
      left: 58%;
      top: 13%;
    }

    &.property-108 {
      left: 45%;
      top: 13%;
    }

    &.property-109 {
      left: 33.5%;
      top: 13%;
    }

    &.property-110 {
      left: 33.5%;
      top: 37%;
    }

    &.property-111 {
      left: 33.5%;
      top: 61%;
    }

    &.property-112 {
      left: 47%;
      top: 61%;
    }


    // Floor Piso2: ///

    &.property-201 {
      left: 62%;
      top: 68%;
    }

    &.property-202 {
      left: 76.5%;
      top: 68%;
    }

    &.property-203 {
      left: 89.5%;
      top: 68%;
    }

    &.property-204 {
      left: 89.5%;
      top: 41%;
    }

    &.property-205 {
      left: 89.5%;
      top: 14%;

    }

    &.property-206 {
      left: 76.5%;
      top: 14%;
    }

    &.property-207 {
      left: 62%;
      top: 14%;
    }

    &.property-208 {
      left: 47%;
      top: 14%;
    }

    &.property-209 {
      left: 34%;
      top: 14%;
    }

    &.property-210 {
      left: 34%;
      top: 41%;
    }

    &.property-211 {
      left: 34%;
      top: 68%;
    }

    &.property-212 {
      left: 47%;
      top: 68%;
    }

    // Floor Piso3: ///

    &.property-301 {
      left: 62%;
      top: 68%;
    }

    &.property-302 {
      left: 76.5%;
      top: 68%;
    }

    &.property-303 {
      left: 89.5%;
      top: 68%;
    }

    &.property-304 {
      left: 89.5%;
      top: 41%;
    }

    &.property-305 {
      left: 89.5%;
      top: 14%;

    }

    &.property-306 {
      left: 76.5%;
      top: 14%;
    }

    &.property-307 {
      left: 62%;
      top: 14%;
    }

    &.property-308 {
      left: 47%;
      top: 14%;
    }

    &.property-309 {
      left: 34%;
      top: 14%;
    }

    &.property-310 {
      left: 34%;
      top: 41%;
    }

    &.property-311 {
      left: 34%;
      top: 68%;
    }

    &.property-312 {
      left: 47%;
      top: 68%;
    }

    // Floor Piso4: ///

    &.property-401 {
      left: 62%;
      top: 68%;
    }

    &.property-402 {
      left: 76.5%;
      top: 68%;
    }

    &.property-403 {
      left: 89.5%;
      top: 68%;
    }

    &.property-404 {
      left: 89.5%;
      top: 41%;
    }

    &.property-405 {
      left: 89.5%;
      top: 14%;

    }

    &.property-406 {
      left: 76.5%;
      top: 14%;
    }

    &.property-407 {
      left: 62%;
      top: 14%;
    }

    &.property-408 {
      left: 47%;
      top: 14%;
    }

    &.property-409 {
      left: 34%;
      top: 14%;
    }

    &.property-410 {
      left: 34%;
      top: 41%;
    }

    &.property-411 {
      left: 34%;
      top: 68%;
    }

    &.property-412 {
      left: 47%;
      top: 68%;
    }

    // Floor Piso5: ///

    &.property-501 {
      left: 62%;
      top: 68%;
    }

    &.property-502 {
      left: 76.5%;
      top: 68%;
    }

    &.property-503 {
      left: 89.5%;
      top: 68%;
    }

    &.property-504 {
      left: 89.5%;
      top: 41%;
    }

    &.property-505 {
      left: 89.5%;
      top: 14%;

    }

    &.property-506 {
      left: 76.5%;
      top: 14%;
    }

    &.property-507 {
      left: 62%;
      top: 14%;
    }

    &.property-508 {
      left: 47%;
      top: 14%;
    }

    &.property-509 {
      left: 34%;
      top: 14%;
    }

    &.property-510 {
      left: 34%;
      top: 41%;
    }

    &.property-511 {
      left: 34%;
      top: 68%;
    }

    &.property-512 {
      left: 47%;
      top: 68%;
    }


    /*BVC*/
    /*State 1:*/
    &.property-BVC1-A21 {
      top: 16.4%;
      left: 49.5%;
    }

    &.property-BVC1-A22 {
      top: 16.4%;
      left: 50.7%;
    }

    &.property-BVC1-A23 {
      top: 16.2%;
      left: 52.9%;
    }

    &.property-BVC1-A24 {
      top: 16.2%;
      left: 54.9%;
    }

    &.property-BVC1-A25 {
      top: 16.2%;
      left: 56.6%;
    }

    &.property-BVC1-A26 {
      top: 16.2%;
      left: 58.6%;
    }

    &.property-BVC1-A27 {
      top: 16.3%;
      left: 60.7%;
    }

    &.property-BVC1-A28 {
      top: 16.3%;
      left: 62%;
    }

    &.property-BVC1-A29 {
      top: 16.2%;
      left: 64.1%;
    }

    &.property-BVC1-A30 {
      top: 16.2%;
      left: 66.1%;
    }

    &.property-BVC1-A31 {
      top: 16.4%;
      left: 68.4%;
    }

    &.property-BVC1-A32 {
      top: 16.4%;
      left: 69.6%;
    }

    &.property-BVC1-D03 {
      top: 25.9%;
      left: 49.4%;
    }

    &.property-BVC1-D04 {
      top: 25.9%;
      left: 50.6%;
    }

    &.property-BVC1-D25 {
      top: 25.8%;
      left: 55.9%;
    }

    &.property-BVC1-D26 {
      top: 25.8%;
      left: 57%;
    }

    &.property-BVC1-D27 {
      top: 25.9%;
      left: 60.2%;
    }

    &.property-BVC1-D28 {
      top: 25.9%;
      left: 61.4%;
    }

    &.property-BVC1-D31 {
      top: 30.8%;
      left: 61%;
    }

    &.property-BVC1-D32 {
      top: 33.4%;
      left: 61%;
    }

    &.property-BVC1-D35 {
      top: 37.2%;
      left: 61.2%;
    }

    &.property-BVC1-D36 {
      top: 38.9%;
      left: 61.2%;
    }

    &.property-BVC1-D39 {
      top: 42.2%;
      left: 61%;
    }

    &.property-BVC1-D40 {
      top: 45%;
      left: 61%;
    }

    &.property-BVC1-D43 {
      top: 47.9%;
      left: 61%;
    }

    &.property-BVC1-D44 {
      top: 50.7%;
      left: 61%;
    }

    &.property-BVC1-D47 {
      top: 55.3%;
      left: 60.2%;
    }

    &.property-BVC1-D48 {
      top: 55.3%;
      left: 61.4%;
    }

    &.property-BVC1-D49 {
      top: 25.9%;
      left: 66.6%;
    }

    &.property-BVC1-D50 {
      top: 25.9%;
      left: 67.8%;
    }

    &.property-BVC1-D53 {
      top: 31.2%;
      left: 66.9%;
    }

    &.property-BVC1-D54 {
      top: 33%;
      left: 66.9%;
    }

    &.property-BVC1-D57 {
      top: 36.2%;
      left: 67.1%;
    }

    &.property-BVC1-D58 {
      top: 39.2%;
      left: 67.1%;
    }

    &.property-BVC1-D61 {
      top: 42.4%;
      left: 66.9%;
    }

    &.property-BVC1-D62 {
      top: 44.2%;
      left: 66.9%;
    }

    &.property-BVC1-D65 {
      top: 48.3%;
      left: 66.9%;
    }

    &.property-BVC1-D66 {
      top: 50.1%;
      left: 66.9%;
    }

    &.property-BVC1-D69 {
      top: 55.5%;
      left: 66.6%;
    }

    &.property-BVC1-D70 {
      top: 55.5%;
      left: 67.8%;
    }

    /*State 2:*/
    &.property-BVC2-A17 {
      top: 15.8%;
      left: 41.2%;
    }

    &.property-BVC2-A18 {
      top: 15.8%;
      left: 43.2%;
    }

    &.property-BVC2-A19 {
      top: 15.9%;
      left: 45.6%;
    }

    &.property-BVC2-A20 {
      top: 15.9%;
      left: 46.8%;
    }

    &.property-BVC2-C01 {
      top: 24.9%;
      left: 39%;
    }

    &.property-BVC2-C02 {
      top: 26.7%;
      left: 39%;
    }

    &.property-BVC2-C03 {
      top: 30.4%;
      left: 39%;
    }

    &.property-BVC2-C04 {
      top: 33.2%;
      left: 39%;
    }

    &.property-BVC2-C05 {
      top: 36.3%;
      left: 39%;
    }

    &.property-BVC2-C06 {
      top: 39.1%;
      left: 39%;

    }

    &.property-BVC2-C07 {
      top: 42%;
      left: 39%;
    }

    &.property-BVC2-C08 {
      top: 44.7%;
      left: 39%;
    }

    &.property-BVC2-C09 {
      top: 47.6%;
      left: 39%;
    }

    &.property-BVC2-C10 {
      top: 50.4%;
      left: 39%;
    }

    &.property-BVC2-C11 {
      top: 55.4%;
      left: 38%;
    }

    &.property-BVC2-C12 {
      top: 55.4%;
      left: 39.2%;
    }

    &.property-BVC2-D01 {
      top: 25.5%;
      left: 45.1%;
    }

    &.property-BVC2-D02 {
      top: 25.5%;
      left: 46.3%;
    }

    &.property-BVC2-D05 {
      top: 30.4%;
      left: 45.6%;
    }

    &.property-BVC2-D06 {
      top: 33.2%;
      left: 45.6%;
    }

    &.property-BVC2-D07 {
      top: 30.4%;
      left: 50.3%;
    }

    &.property-BVC2-D08 {
      top: 33.2%;
      left: 50.3%;
    }

    &.property-BVC2-D09 {
      top: 36%;
      left: 45.6%;
    }

    &.property-BVC2-D10 {
      top: 38.8%;
      left: 45.6%;
    }

    &.property-BVC2-D11 {
      top: 36.5%;
      left: 50.4%;
    }

    &.property-BVC2-D12 {
      top: 38.2%;
      left: 50.4%;
    }

    &.property-BVC2-D13 {
      top: 42.2%;
      left: 45.3%;
    }

    &.property-BVC2-D14 {
      top: 44%;
      left: 45.3%;
    }

    &.property-BVC2-D15 {
      top: 41.7%;
      left: 50.4%;
    }

    &.property-BVC2-D16 {
      top: 44.5%;
      left: 50.4%;
    }

    &.property-BVC2-D17 {
      top: 47.4%;
      left: 45.6%;
    }

    &.property-BVC2-D18 {
      top: 50.3%;
      left: 45.6%;
    }

    &.property-BVC2-D19 {
      top: 48.3%;
      left: 50.5%;
    }

    &.property-BVC2-D20 {
      top: 50.1%;
      left: 50.5%;
    }

    &.property-BVC2-D21 {
      top: 55.5%;
      left: 45.1%;
    }

    &.property-BVC2-D22 {
      top: 55.5%;
      left: 46.3%;
    }

    &.property-BVC2-D23 {
      top: 55.3%;
      left: 49.5%;
    }

    &.property-BVC2-D24 {
      top: 55.3%;
      left: 50.7%;
    }

    &.property-BVC2-D29 {
      top: 30.7%;
      left: 56.4%;
    }

    &.property-BVC2-D30 {
      top: 33.3%;
      left: 56.4%;
    }

    &.property-BVC2-D33 {
      top: 36.3%;
      left: 56.4%;
    }

    &.property-BVC2-D34 {
      top: 39.1%;
      left: 56.4%;
    }

    &.property-BVC2-D37 {
      top: 42.2%;
      left: 56.4%;
    }

    &.property-BVC2-D38 {
      top: 44.8%;
      left: 56.4%;
    }

    &.property-BVC2-D41 {
      top: 47.8%;
      left: 56.4%;
    }

    &.property-BVC2-D42 {
      top: 50.7%;
      left: 56.4%;
    }

    &.property-BVC2-D45 {
      top: 55.5%;
      left: 56.1%;
    }

    &.property-BVC2-D46 {
      top: 55.5%;
      left: 57.3%;
    }

    &.property-BVC2-F03 {
      top: 64.8%;
      left: 37.3%;
    }

    &.property-BVC2-F04 {
      top: 64.8%;
      left: 38.5%;
    }

    &.property-BVC2-F21 {
      top: 64.9%;
      left: 43.6%;
    }

    &.property-BVC2-F22 {
      top: 64.9%;
      left: 44.7%;
    }

    &.property-BVC2-F23 {
      top: 64.9%;
      left: 47.9%;
    }

    &.property-BVC2-F24 {
      top: 64.9%;
      left: 49%;
    }

    &.property-BVC2-F41 {
      top: 64.9%;
      left: 54.2%;
    }

    &.property-BVC2-F42 {
      top: 64.9%;
      left: 55.4%;
    }

    &.property-BVC2-F43 {
      top: 64.9%;
      left: 58.5%;
    }

    &.property-BVC2-F44 {
      top: 64.9%;
      left: 59.7%;
    }


    //ETAPA 3

    &.property-BVC3-H01 {
      top: 75.4%;
      left: 26.7%;
    }

    &.property-BVC3-H02 {
      top: 78.1%;
      left: 26.7%;
    }

    &.property-BVC3-H03 {
      top: 81.1%;
      left: 26.7%;
    }

    &.property-BVC3-H04 {
      top: 84.1%;
      left: 26.7%;
    }

    &.property-BVC3-H05 {
      top: 87.7%;
      left: 26.7%;
    }

    &.property-BVC3-H06 {
      top: 89.5%;
      left: 26.7%;
    }

    &.property-BVC3-F01 {
      top: 64.9%;
      left: 32.8%;
    }

    &.property-BVC3-F02 {
      top: 64.9%;
      left: 34%;
    }

    &.property-BVC3-F05 {
      top: 70.2%;
      left: 33.1%;
    }

    &.property-BVC3-F06 {
      top: 72%;
      left: 33.1%;
    }

    &.property-BVC3-F07 {
      top: 69.7%;
      left: 38.1%;
    }

    &.property-BVC3-F08 {
      top: 72.5%;
      left: 38.1%;
    }

    &.property-BVC3-F09 {
      top: 75.3%;
      left: 33.4%;
    }

    &.property-BVC3-F10 {
      top: 78.2%;
      left: 33.4%;
    }

    &.property-BVC3-F11 {
      top: 75.3%;
      left: 38.1%;
    }

    &.property-BVC3-F12 {
      top: 78.2%;
      left: 38.1%;
    }

    &.property-BVC3-F13 {
      top: 81.2%;
      left: 33.4%;
    }

    &.property-BVC3-F14 {
      top: 84%;
      left: 33.4%;
    }

    &.property-BVC3-F15 {
      top: 81.8%;
      left: 38.2%;
    }

    &.property-BVC3-F16 {
      top: 83.5%;
      left: 38.2%;
    }

    &.property-BVC3-F17 {
      top: 88.7%;
      left: 32.9%;
    }

    &.property-BVC3-F18 {
      top: 88.7%;
      left: 34%;
    }

    &.property-BVC3-F19 {
      top: 89.1%;
      left: 37.2%;
    }

    &.property-BVC3-F20 {
      top: 89.1%;
      left: 38.3%;
    }

    &.property-BVC3-F25{
      top: 69.7%;
      left: 44.1%;
    }

    &.property-BVC3-F26{
      top: 72.4%;
      left: 44.1%;
    }

    &.property-BVC3-F27{
      top: 69.8%;
      left: 48.8%;
    }

    &.property-BVC3-F28{
      top: 72.4%;
      left: 48.8%;
    }

    &.property-BVC3-F29{
      top: 75.9%;
      left: 43.8%;
    }

    &.property-BVC3-F30{
      top: 77.6%;
      left: 43.8%;
    }

    &.property-BVC3-F31{
      top: 75.3%;
      left: 48.8%;
    }

    &.property-BVC3-F32{
      top: 78.1%;
      left: 48.8%;
    }

    &.property-BVC3-F33{
      top: 81.1%;
      left: 44.1%;
    }

    &.property-BVC3-F34{
      top: 84.1%;
      left: 44.1%;
    }

    &.property-BVC3-F35{
      top: 81.7%;
      left: 48.9%;
    }

    &.property-BVC3-F36{
      top: 83.4%;
      left: 48.9%;
    }

    &.property-BVC3-F37{
      top: 88.8%;
      left: 43.5%;
    }

    &.property-BVC3-F38{
      top: 88.8%;
      left: 44.7%;
    }

    &.property-BVC3-F39{
      top: 89.1%;
      left: 47.9%;
    }

    &.property-BVC3-F40{
      top: 89.1%;
      left: 49%;
    }

    &.property-BVC3-F45{
      top: 69.8%;
      left: 54.6%;
    }

    &.property-BVC3-F46{
      top: 72.4%;
      left: 54.6%;
    }

    &.property-BVC3-F47{
      top: 69.8%;
      left: 59.5%;
    }

    &.property-BVC3-F48{
      top: 72.4%;
      left: 59.5%;
    }

    &.property-BVC3-F49{
      top: 75.8%;
      left: 54.5%;
    }

    &.property-BVC3-F50{
      top: 77.6%;
      left: 54.5%;
    }

    &.property-BVC3-F51{
      top: 75.4%;
      left: 59.5%;
    }

    &.property-BVC3-F52{
      top: 78.1%;
      left: 59.5%;
    }

    &.property-BVC3-F53{
      top: 81.1%;
      left: 54.8%;
    }

    &.property-BVC3-F54{
      top: 84.1%;
      left: 54.8%;
    }

    &.property-BVC3-F55{
      top: 81.7%;
      left: 59.6%;
    }

    &.property-BVC3-F56{
      top: 83.4%;
      left: 59.6%;
    }

    &.property-BVC3-F57{
      top: 88.7%;
      left: 54.2%;
    }

    &.property-BVC3-F58{
      top: 88.7%;
      left: 55.4%;
    }

    &.property-BVC3-F59{
      top: 89.1%;
      left: 58.6%;
    }

    &.property-BVC3-F60{
      top: 89.1%;
      left: 59.7%;
    }


    //Parque Germania:

    &.pg-property-local-1 {
      top: 56%;
      left: 39.5%;
    }

    &.pg-property-local-2 {
      top: 56%;
      left: 43.8%;
    }

    &.pg-property-local-3 {
      top: 56%;
      left: 48.2%;
    }

    &.pg-property-local-4 {
      top: 56%;
      left: 52.5%;
    }

    &.pg-property-local-5 {
      top: 56%;
      left: 63.8%;
    }

    &.pg-property-local-6 {
      top: 56%;
      left: 68%;
    }

    &.pg-property-local-7 {
      top: 56%;
      left: 72.5%;
    }

    &.pg-property-local-8 {
      top: 56%;
      left: 76.7%;
    }

    &.pg-property-local-9 {
      top: 56%;
      left: 81.7%;
    }


    &.pg-property-205 {
      top: 56.5%;
      left: 81.5%;
    }

    &.pg-property-206 {
      top: 56.5%;
      left: 76.8%;
    }

    &.pg-property-207 {
      top: 56.5%;
      left: 72.4%;
    }

    &.pg-property-208 {
      top: 56.5%;
      left: 68.1%;
    }

    &.pg-property-209 {
      top: 56.5%;
      left: 63.8%;
    }

    &.pg-property-211 {
      top: 56.5%;
      left: 52.6%;
    }

    &.pg-property-212 {
      top: 56.5%;
      left: 48.3%;
    }

    &.pg-property-213 {
      top: 56.5%;
      left: 44%;
    }

    &.pg-property-214 {
      top: 56.5%;
      left: 39.6%;
    }

    &.pg-property-215 {
      top: 56.5%;
      left: 34.6%;
    }

    &.pg-property-305 {
      top: 55%;
      left: 81.7%;
    }

    &.pg-property-306 {
      top: 55%;
      left: 76.7%;
    }

    &.pg-property-307 {
      top: 55%;
      left: 72.4%;
    }

    &.pg-property-308 {
      top: 55%;
      left: 67.9%;
    }

    &.pg-property-309 {
      top: 55%;
      left: 63.7%;
    }

    &.pg-property-310 {
      top: 55%;
      left: 58%;
    }

    &.pg-property-311 {
      top: 55%;
      left: 52.5%;
    }

    &.pg-property-312 {
      top: 55%;
      left: 48.2%;
    }

    &.pg-property-313 {
      top: 55%;
      left: 43.8%;
    }

    &.pg-property-314 {
      top: 55%;
      left: 39.5%;
    }

    &.pg-property-315 {
      top: 55%;
      left: 34.5%;
    }


    &.pg-property-405 {
      top: 55%;
      left: 81.5%;
    }

    &.pg-property-406 {
      top: 55%;
      left: 76.7%;
    }

    &.pg-property-407 {
      top: 55%;
      left: 72.4%;
    }

    &.pg-property-408 {
      top: 55%;
      left: 68%;
    }

    &.pg-property-409 {
      top: 55%;
      left: 63.7%;
    }

    &.pg-property-410 {
      top: 55%;
      left: 58%;
    }

    &.pg-property-411 {
      top: 55%;
      left: 52.5%;
    }

    &.pg-property-412 {
      top: 55%;
      left: 48.2%;
    }

    &.pg-property-413 {
      top: 55%;
      left: 43.8%;
    }

    &.pg-property-414 {
      top: 55%;
      left: 39.4%;
    }

    &.pg-property-415 {
      top: 55%;
      left: 35.2%;
    }

    &.pg-property-505 {
      top: 54%;
      left: 82.5%;
    }

    &.pg-property-506 {
      top: 54%;
      left: 77.3%;
    }

    &.pg-property-507 {
      top: 54%;
      left: 72.7%;
    }

    &.pg-property-508 {
      top: 54%;
      left: 68.6%;
    }

    &.pg-property-509 {
      top: 54%;
      left: 64%;
    }

    &.pg-property-510 {
      top: 54%;
      left: 58.4%;
    }

    &.pg-property-511 {
      top: 54%;
      left: 52.7%;
    }

    &.pg-property-512 {
      top: 54%;
      left: 48.1%;
    }

    &.pg-property-513 {
      top: 54%;
      left: 43.8%;
    }

    &.pg-property-514 {
      top: 54%;
      left: 39.2%;
    }

    &.pg-property-515 {
      top: 54%;
      left: 34.5%;
    }


    &.pg-property-601 {
      top: 42.5%;
      left: 68.2%;
    }

    &.pg-property-602 {
      top: 42.5%;
      left: 75%;
    }

    &.pg-property-603 {
      top: 42.5%;
      left: 82.3%;
    }

    &.pg-property-604 {
      top: 42.5%;
      left: 90.3%;
    }

    &.pg-property-605 {
      top: 54.5%;
      left: 86%;
    }

    &.pg-property-606 {
      top: 54.5%;
      left: 81%;
    }

    &.pg-property-607 {
      top: 54.5%;
      left: 76.3%;
    }

    &.pg-property-608 {
      top: 54.5%;
      left: 71.6%;
    }

    &.pg-property-609 {
      top: 54.5%;
      left: 66.9%;
    }

    &.pg-property-610 {
      top: 54.5%;
      left: 60.6%;
    }

    &.pg-property-611 {
      top: 54.5%;
      left: 54.8%;
    }

    &.pg-property-612 {
      top: 54.5%;
      left: 50%;
    }

    &.pg-property-613 {
      top: 54.5%;
      left: 45.2%;
    }

    &.pg-property-614 {
      top: 54.5%;
      left: 40.5%;
    }

    &.pg-property-615 {
      top: 54.5%;
      left: 35.7%;
    }

    &.pg-property-616 {
      top: 42.5%;
      left: 41%;
    }

    &.pg-property-617 {
      top: 42.5%;
      left: 46.5%;
    }

    &.pg-property-618 {
      top: 42.5%;
      left: 53.5%;
    }

    &.pg-property-701 {
      top: 39%;
      left: 68.1%;
    }

    &.pg-property-702 {
      top: 39%;
      left: 75.1%;
    }

    &.pg-property-703 {
      top: 39%;
      left: 82.4%;
    }

    &.pg-property-704 {
      top: 39%;
      left: 90.4%;
    }

    &.pg-property-705 {
      top: 50.9%;
      left: 86.3%;
    }

    &.pg-property-706 {
      top: 50.9%;
      left: 81%;
    }

    &.pg-property-707 {
      top: 50.9%;
      left: 76.4%;
    }

    &.pg-property-708 {
      top: 50.9%;
      left: 71.6%;
    }

    &.pg-property-709 {
      top: 50.9%;
      left: 66.9%;
    }

    &.pg-property-710 {
      top: 50.9%;
      left: 60.7%;
    }

    &.pg-property-711 {
      top: 50.9%;
      left: 54.7%;
    }

    &.pg-property-712 {
      top: 50.9%;
      left: 50%;
    }

    &.pg-property-713 {
      top: 50.9%;
      left: 45.2%;
    }

    &.pg-property-714 {
      top: 50.9%;
      left: 40.5%;
    }

    &.pg-property-715 {
      top: 50.9%;
      left: 35.8%;
    }

    &.pg-property-716 {
      top: 39%;
      left: 40.8%;
    }

    &.pg-property-717 {
      top: 39%;
      left: 46.5%;
    }

    &.pg-property-718 {
      top: 39%;
      left: 53.5%;
    }

    &.pg-property-801 {
      top: 42.7%;
      left: 68.3%;
    }

    &.pg-property-802 {
      top: 42.7%;
      left: 75.1%;
    }

    &.pg-property-803 {
      top: 42.7%;
      left: 82.4%;
    }

    &.pg-property-804 {
      top: 42.7%;
      left: 90.4%;
    }

    &.pg-property-805 {
      top: 54.7%;
      left: 86.3%;
    }

    &.pg-property-806 {
      top: 54.7%;
      left: 81.1%;
    }

    &.pg-property-807 {
      top: 54.7%;
      left: 76.3%;
    }

    &.pg-property-808 {
      top: 54.7%;
      left: 71.5%;
    }

    &.pg-property-809 {
      top: 54.7%;
      left: 66.8%;
    }

    &.pg-property-810 {
      top: 54.7%;
      left: 60.7%;
    }

    &.pg-property-811 {
      top: 54.7%;
      left: 54.9%;
    }

    &.pg-property-812 {
      top: 54.7%;
      left: 49.9%;
    }

    &.pg-property-813 {
      top: 54.7%;
      left: 45.3%;
    }

    &.pg-property-814 {
      top: 54.7%;
      left: 40.4%;
    }

    &.pg-property-815 {
      top: 54.7%;
      left: 35.7%;
    }

    &.pg-property-816 {
      top: 42.7%;
      left: 40.9%;
    }

    &.pg-property-817 {
      top: 42.7%;
      left: 46.4%;
    }

    &.pg-property-818 {
      top: 42.7%;
      left: 53.4%;
    }


    &.pg-property-901 {
      top: 42.7%;
      left: 68.3%;
    }

    &.pg-property-902 {
      top: 42.7%;
      left: 75.1%;
    }

    &.pg-property-903 {
      top: 42.7%;
      left: 82.4%;
    }

    &.pg-property-904 {
      top: 42.7%;
      left: 90.4%;
    }


    &.pg-property-907 {
      top: 54.7%;
      left: 76.3%;
    }

    &.pg-property-908 {
      top: 54.7%;
      left: 71.5%;
    }

    &.pg-property-909 {
      top: 54.7%;
      left: 66.8%;
    }

    &.pg-property-910 {
      top: 54.7%;
      left: 60.7%;
    }

    &.pg-property-911 {
      top: 54.7%;
      left: 54.9%;
    }

    &.pg-property-912 {
      top: 54.7%;
      left: 49.9%;
    }

    &.pg-property-913 {
      top: 54.7%;
      left: 45.3%;
    }

    &.pg-property-914 {
      top: 54.7%;
      left: 40.4%;
    }

    &.pg-property-915 {
      top: 54.7%;
      left: 35.7%;
    }

    &.pg-property-916 {
      top: 42.7%;
      left: 40.9%;
    }

    &.pg-property-917 {
      top: 42.7%;
      left: 46.4%;
    }

    &.pg-property-918 {
      top: 42.7%;
      left: 53.4%;
    }

    &.pg-property-1001 {
      top: 39.7%;
      left: 75.4%;
    }

    &.pg-property-1002 {
      top: 39.7%;
      left: 83.3%;
    }

    &.pg-property-1003 {
      top: 39.7%;
      left: 91.8%;
    }


    &.pg-property-1007 {
      top: 53.7%;
      left: 85.3%;
    }

    &.pg-property-1008 {
      top: 53.7%;
      left: 79.3%;
    }

    &.pg-property-1009 {
      top: 53.7%;
      left: 73.6%;
    }

    &.pg-property-1010 {
      top: 53.7%;
      left: 66.4%;
    }

    &.pg-property-1011 {
      top: 53.7%;
      left: 59.4%;
    }

    &.pg-property-1012 {
      top: 53.7%;
      left: 53.8%;
    }

    &.pg-property-1013 {
      top: 53.7%;
      left: 48.2%;
    }

    &.pg-property-1014 {
      top: 53.7%;
      left: 42.5%;
    }

    &.pg-property-1015 {
      top: 53.7%;
      left: 37.1%;
    }

    &.pg-property-1016 {
      top: 39.7%;
      left: 43%;
    }

    &.pg-property-1017 {
      top: 39.7%;
      left: 49.6%;
    }

    &.pg-property-1018 {
      top: 39.7%;
      left: 57.9%;
    }

    &.pg-property-1101 {
      top: 39.7%;
      left: 75.4%;
    }

    &.pg-property-1102 {
      top: 39.7%;
      left: 83.4%;
    }

    &.pg-property-1103 {
      top: 39.7%;
      left: 91.9%;
    }

    &.pg-property-1107 {
      top: 53.7%;
      left: 85.1%;
    }

    &.pg-property-1108 {
      top: 53.7%;
      left: 79.1%;
    }

    &.pg-property-1109 {
      top: 53.7%;
      left: 73.6%;
    }

    &.pg-property-1110 {
      top: 53.7%;
      left: 66.3%;
    }

    &.pg-property-1111 {
      top: 53.7%;
      left: 59.3%;
    }

    &.pg-property-1112 {
      top: 53.7%;
      left: 53.8%;
    }

    &.pg-property-1113 {
      top: 53.7%;
      left: 48.2%;
    }

    &.pg-property-1116 {
      top: 39.7%;
      left: 42.9%;
    }

    &.pg-property-1117 {
      top: 39.7%;
      left: 49.7%;
    }

    &.pg-property-1118 {
      top: 39.7%;
      left: 58%;
    }

    &.pg-property-1201 {
      top: 36.9%;
      left: 72.3%;
    }

    &.pg-property-1202 {
      top: 36.9%;
      left: 81.6%;
    }

    &.pg-property-1203 {
      top: 36.9%;
      left: 91.2%;
    }

    &.pg-property-1207 {
      top: 52.7%;
      left: 83.2%;
    }

    &.pg-property-1208 {
      top: 52.7%;
      left: 76.9%;
    }

    &.pg-property-1209 {
      top: 52.7%;
      left: 70.5%;
    }

    &.pg-property-1210 {
      top: 52.7%;
      left: 62.3%;
    }

    &.pg-property-1211 {
      top: 52.7%;
      left: 54.3%;
    }

    &.pg-property-1212 {
      top: 52.7%;
      left: 47.9%;
    }

    &.pg-property-1213 {
      top: 52.7%;
      left: 41.6%;
    }

    &.pg-property-1217 {
      top: 36.9%;
      left: 45.5%;
    }

    &.pg-property-1218 {
      top: 36.9%;
      left: 52.5%;
    }

    &.pg-property-1301 {
      top: 32.9%;
      left: 68.3%;
    }

    &.pg-property-1302 {
      top: 32.9%;
      left: 79.3%;
    }

    &.pg-property-1303 {
      top: 32.9%;
      left: 90.5%;
    }

    &.pg-property-1307 {
      top: 51.7%;
      left: 81.1%;
    }

    &.pg-property-1308 {
      top: 51.7%;
      left: 73.6%;
    }

    &.pg-property-1309 {
      top: 51.7%;
      left: 66.2%;
    }

    &.pg-property-1310 {
      top: 51.7%;
      left: 56.7%;
    }

    &.pg-property-1311 {
      top: 51.7%;
      left: 47.3%;
    }

    &.pg-property-1312 {
      top: 51.7%;
      left: 39.9%;
    }

    &.pg-property-1313 {
      top: 51.7%;
      left: 32.5%;
    }

    &.pg-property-1317 {
      display: none;
      top: 32.9%;
      left: 37.5%;
    }

    &.pg-property-1318 {
      top: 32.9%;
      left: 45.3%;
    }

    &.pg-property-1401 {
      top: 32.9%;
      left: 68.5%;
    }

    &.pg-property-1402 {
      top: 32.9%;
      left: 79.3%;
    }

    &.pg-property-1403 {
      top: 32.9%;
      left: 90.3%;
    }

    &.pg-property-1407 {
      top: 52.5%;
      left: 81.1%;
    }

    &.pg-property-1408 {
      top: 52.5%;
      left: 73.6%;
    }

    &.pg-property-1409 {
      top: 52.5%;
      left: 66.3%;
    }

    &.pg-property-1410 {
      top: 52.5%;
      left: 56.8%;
    }

    &.pg-property-1411 {
      top: 52.5%;
      left: 47.4%;
    }

    &.pg-property-1412 {
      top: 52.5%;
      left: 40%;
    }

    &.pg-property-1413 {
      top: 52.5%;
      left: 32.6%;
    }

    &.pg-property-1417 {
      top: 32.9%;
      left: 37.5%;
    }

    &.pg-property-1418 {
      top: 32.9%;
      left: 45.5%;
    }

    &.pg-property-1501 {
      top: 32.9%;
      left: 68.5%;
    }

    &.pg-property-1502 {
      top: 32.9%;
      left: 79.3%;
    }

    &.pg-property-1503 {
      top: 32.9%;
      left: 90.3%;
    }

    &.pg-property-1507 {
      top: 52.5%;
      left: 81.1%;
    }

    &.pg-property-1508 {
      top: 52.5%;
      left: 73.6%;
    }

    &.pg-property-1509 {
      top: 52.5%;
      left: 66.3%;
    }

    &.pg-property-1510 {
      top: 52.5%;
      left: 56.8%;
    }

    &.pg-property-1511 {
      top: 52.5%;
      left: 47.4%;
    }

    &.pg-property-1512 {
      top: 52.5%;
      left: 40%;
    }

    &.pg-property-1513 {
      top: 52.5%;
      left: 32.6%;
    }

    &.pg-property-1517 {
      display: none;
      top: 32.9%;
      left: 37.5%;
    }

    &.pg-property-1518 {
      top: 32.9%;
      left: 45.5%;
    }

  }

}

.matta-sur-project {
  .color-indicator {
    width: 22px;
    height: 22px;

    .circle-inner {
      width: 16px;
      height: 16px;
    }
  }
}

.model-info {
  .color-indicator {
    &.model-SF100 {
      background: #17C9FF;
    }

    &.model-SF90 {
      background: #1FFF17;
    }

    &.model-SF75 {
      background: #FF7F17;
    }

    &.model-Mayal {
      background: #17C9FF;
    }

    &.model-Legón {
      background: #1FFF17;
    }

    &.model-Barreno {
      background: #FF7F17;
    }

    &.model-Calbuco-AV09 {
      background: #17C9FF;
    }

    &.model-Osorno-AV07 {
      background: #1FFF17;
    }

    &.model-Lonquimay-AV03 {
      background: #FF7F17;
    }

    &.model-Llaima-AV08 {
      background: #ff4f4d;
    }

    &.model-SanJose-AV10 {
      background: #28259a;
    }

    &.model-tipo-a {
      background: #EF8639;
      border-color: #EF8639;
    }

    &.model-tipo-b {
      background: #78FA50;
      border-color: #78FA50;
    }

    &.model-tipo-c {
      background: #5EC6FA;
      border-color: #5EC6FA;
    }

    &.model-tipo-d {
      background: #ff4f4d;
      border-color: #ff4f4d;
    }
  }
}

@media (max-width: 767px) {

  .property-info-tooltip .body-content .buttons-container.buttons-w-48 .button-call-action {
    width: 100%;
  }
  .property-info-tooltip .body-content .buttons-container {
    display: block;
  }

  .property-info-tooltip .body-content .show-distribution-link {
    padding-bottom: 16px;
  }

  .guide-modal {
    .modal-backdrop {
      background: rgba(255, 255, 255, 0.4);
      opacity: 1;
    }

    .modal-content {
      border-radius: 0;
      max-width: 220px;
      position: absolute;
      right: 20px;
      top: 100px;
      border: none;
      box-shadow: none;

      &:before {
        content: '';
        position: absolute;
        left: 20px;
        top: -18px;
        width: 5px;
        height: 33px;
        background: #F2D84D;
      }
    }

    .modal-header {
      padding: 0 10px;
      display: flex !important;
    }

    .guide-modal-content {
      padding: 0 8px 8px;
      position: relative;

      .point-indicator-img {
        position: absolute;
        top: 0;
        left: -90px;
        width: 43px;
      }

      .header-content {
        border-bottom: 1px solid #00000033;
        padding-bottom: 19px;
        margin-bottom: 17px;
        text-align: center;

        p {
          font-size: 13px;
          text-align: left;
        }
      }

      .footer-content {
        img {
          width: 33.42px;
          margin-right: 18px;
          margin-left: 10px;
        }

        p {
          font-size: 11px;
          color: #000;
          font-weight: 400;
          line-height: 13px;
        }

        .button-call-action.button-yellow {
          background: #F2D84D;
          border: none;
          box-shadow: none;
          line-height: 56px;
          font-size: 13px;
          font-weight: 600;
          padding: 0 7px;
        }
      }

    }
  }

  .sidebar-modal {
    .modal-dialog {
      margin: 0;

      .modal-header {
        display: none;
      }

      .modal-content {
        border-radius: 0;
        min-height: 100vh;
        border: none;
        box-shadow: none;

        .modal-body {
          padding: 0;
        }
      }
    }

    .project-info-sidebar.mobile-sidebar {
      display: block;
      width: 100%;
      position: static;

      .logo-container {
        background: #000;
        padding: 10px 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        a:first-child {
          width: 90px;

          img {
            width: 100%;
          }
        }
      }

      .project-info-title {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 18px;

        h2 {
          font-size: 14px;
          margin-bottom: 0;
          line-height: 17.07px;
        }

        h1 {
          font-size: 14px;
          margin-bottom: 0;
          line-height: 17.07px;
          font-weight: 600;
          text-transform: uppercase;
        }

        span {
          font-size: 12px;
          line-height: 14.63px;
        }

        .price {
          text-align: right;

          span, p {
            font-size: 20px;
            line-height: 24px;
            font-weight: 600;
            margin-bottom: 0;
          }

          p {
            display: flex;
            align-items: center;
          }
        }
      }

      .property-counter-item {
        display: flex;
        align-items: center;
        justify-content: space-between;

        h3 {
          font-size: 14px;
          line-height: 17px;
          font-weight: 600;
        }

        p {
          font-size: 14px;
          line-height: 17px;
          font-weight: 400;
        }

        span {
          font-size: 16px;
          line-height: 20px;
        }
      }

      .contact-info-container {
        .icon-box {
          width: 16px;
          height: 16px;
        }
      }

      .item-with-icon {
        display: flex;
        align-items: center;
        position: relative;
        padding-left: 23px;

        .icon-box {
          position: absolute;
          left: 0;
          top: 2px;
          width: 13px;
          height: 13px;
          text-align: center;

          img {
            height: 100%;
            vertical-align: top;
          }
        }
      }

      .share-icon {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 17px;
        color: #000;
        margin-bottom: 18px;
        font-family: 'Montserrat';

        img {
          width: 18px;
          margin-right: 6px;
        }
      }
    }

    .mattasur-custom-select-container {
      padding: 26px 30px;
      background: #F4F4F4;

      h4 {
        margin-bottom: 24px;
      }

      a {
        color: #000;
      }
    }

    .info-items-container {
      margin: 0;
      list-style: none;

      .info-item {
        padding: 26px 30px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.11);

        h4 {
          font-weight: 600;
          font-size: 14px;
          line-height: 17px;
        }

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }
      }
    }

    .button-container {
      padding: 26px 30px;

      .button-call-action {
        border: none;
        box-shadow: none;
        line-height: 56px;
        padding: 0 12px;
        font-weight: 600;
        font-size: 13px;

        &.button-yellow {
          background: #F2D84D;
        }
      }
    }

  }

  .fixed-project-info {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    padding: 18px 30px 25px;
    z-index: 10;

    .project-name {
      margin-bottom: 15px;

      h1 {
        font-size: 14px;
        line-height: 17px;
        text-transform: uppercase;
        font-weight: 400;
        margin-bottom: 0;
      }

      span {
        font-size: 13px;
        line-height: 14px;
        display: block;
        font-weight: 400;
      }
    }

    .mattasur-custom-select {
      a {
        color: #000;
      }

      .ms-options-list {
        top: -63px;
        //transform: rotate(180deg);
        max-height: 270px;

        &.pg-program-select {
          position: static;
        }

        &.floor-options-list {
          top: -260px;
        }

        li {
          //transform: rotate(-180deg);
        }
      }
    }
  }


  .property-info-tooltip .header-content .title .model-name {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 0;
    font-family: Montserrat;
  }

  .model-info-Modal {
    .modal-dialog {
      margin: 0;
    }

    .modal-content {
      border-radius: 0;
      min-height: 100vh;
      border: none;
      box-shadow: none;
    }
  }

  .model-info-Modal.distribution-apartment-modal {
    .modal-content {
      border-radius: 0;
      height: auto;
      width: 95%;
      margin: 15px auto;
      border: none;
      box-shadow: none;
    }

    .modal-body {
      padding: 10px;

      .apartment-info-modal .title-and-specs-info {
        padding: 10px 0;
        display: block;

        .title-continer {
          margin-bottom: 10px;
        }
      }
    }
  }

  .modal-header {
    border-bottom: none !important;
    display: none !important;

    .close {
      font-size: 30px;
      padding: 0 15px;
      font-weight: 400;
      opacity: 1;
    }
  }

  .master-plan-page {
    min-height: auto;
    padding-bottom: 115px;

    .master-plan-container {
      /*margin-top: 185px;*/
      overflow: auto;
      margin-bottom: 0;
    }

    .project-models {
      top: 0;
      left: 0;
      z-index: 11 !important;
      margin-top: 67.5px;
      padding: 12px;
      width: 100vw !important;
      min-height: calc(100vh - 67.5px);
      overflow-y: auto;

      .filter-title {
        margin-top: 13px;
        margin-bottom: 31px;
        font-size: 14px;
        line-height: 17px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 500;
        color: #000;
        text-transform: uppercase;
        padding: 0 27px;
      }

      .row {
        & > [class^="col-"],
        & > [class*=" col-"] {
          &:last-child {
            .model-item {
              border-bottom: none;
            }

          }

          &:first-child {
            .model-item {
              padding-left: 45px !important;

              &.active {
                .down-arrow {
                  display: inline-block;
                }
              }
            }
          }

          .model-item {
            &.active {
              border-bottom: none;

              .down-arrow {
                display: none;
              }

              &:before {
                display: none;
              }
            }
          }
        }
      }

      .model-item {

        padding: 20px 23px 20px 20px;
        border-bottom: 1px solid rgba(151, 151, 151, 0.2);

        .model-info .color-indicator {
          margin-top: 3px;
        }

        .down-arrow {
          left: 11px !important;
          top: 50% !important;
          transform: translateY(-50%) rotate(-90deg) !important;
        }

      }

      .buttons-filter-container {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 0 27px 23px;

        a {
          display: block;
          margin-bottom: 15px;
          width: 100%;
          text-align: center;
          padding: 14.5px !important;

          &.button-call-action.button-yellow {
            background: #FFDD17;
            border-color: #FFDD17;
            color: #000;
          }
        }
      }
    }

    &.san-francisco-project {
      margin-top: 65px;
    }

    &.altos-del-valle-project {

      .project-models .buttons-filter-container {
        clear: both;
        position: relative;
        padding: 23px 27px 23px;

        a {
          margin-bottom: 0;
        }
      }
    }

    &.matta-sur-project {
      padding-bottom: 80px;

      &.default-view {
        margin-top: 68px;
      }

      .master-plan-container {
        min-height: 785px;
      }
    }

    &.barrio-viña-carmen-project {
      padding-top: 70px;
    }

  }

  .property-info-tooltip .header-content .title .price {
    font-size: 31px;
    line-height: 38px;
    font-weight: 400;
  }
  .property-info-tooltip .header-content .title {
    width: auto;
  }
  .property-info-tooltip .header-content .financing-info {
    width: 45%;
    min-width: 45%;

    h4 {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
    }

    table {
      border: none;

      tr, td {
        border: none;
      }
    }
  }

  .matta-sur-project {

    .model-info-Modal {
      .modal-header {
        display: none;

        .close {
          font-size: 30px;
          padding: 0;
          margin: 0;
          height: auto;
          font-weight: 400;
          opacity: 1;
        }
      }

      .modal-dialog {
        margin: 0;
      }

      .modal-content {
        border-radius: 0;
        height: 100vh;
        width: 100vw;
        border: none;
        box-shadow: none;
      }
    }
  }
  .property-info-tooltip {
    padding-top: 32px;
    padding-left: 7px;
    padding-right: 7px;

    .body-content .house-specs {
      flex-wrap: wrap;
      margin-bottom: 5px;

      .spec-item {
        width: 50%;
        margin-bottom: 15px;

        span {
          font-size: 12px;
          line-height: 15px;
          font-family: 'Montserrat';
        }

        .spec-item {
          width: 100%;
        }
      }
    }
  }

  .property-info-tooltip .body-content .buttons-container .button-call-action {
    margin-bottom: 20px;
  }

}
</style>
